<template>
  <div class="page-table-layout" data-testid="tasklist">
      <v-card
        class="all-width flex-card shadow-off"
        loader-height="2"
        :loading="loading || false"
        :disabled="loading || false"
        data-testid="tasklist__main-card"
      >
        <v-card-text class="page-table-layout__body" data-testid="tasklist__main-card-content">
          <div class="d-flex flex-column gap-3" data-testid="tasklist__header-bar">
            <div class="" data-testid="tasklist__breadcrumbs-group">
              <lb-breadcrumbs :items="breadcrumbs" />
            </div>
            <div
              class="d-flex justify-space-between align-center"
              data-testid="tasklist__header-action-group"
            >
              <div class="d-flex align-center" data-testid="tasklist__header-right-group">
                <lb-header
                  title="Tasks"
                  :metadata="metadata"
                  :isNotificationEnabled="isNotificationEnabled"
                  :activityLogType="$options.ACTIVITY_LOG_TYPES.TASKLIST"
                  @refresh="refreshData()"
                  @email="emailpop()"
                  data-testid="tasklist__header"
                />
                <v-btn-toggle
                  v-if="horizonViewEnabled"
                  v-model="viewMode"
                  mandatory
                  class="view-mode-toggle ml-4"
                  dense
                  data-testid="tasklist__view-mode-toggle"
                >
                  <v-btn
                    :value="false"
                    dense
                    class="view-mode-toggle__btn"
                    :class="{ 'view-mode-toggle__btn--active': viewMode === false }"
                    data-testid="tasklist__list-view-btn"
                  >
                    <v-icon :class="{ 'mr-1': viewMode === false }">mdi-format-list-bulleted</v-icon>
                    <span v-if="viewMode === false" class="view-mode-toggle__label">List</span>
                  </v-btn>
                  <v-btn
                    :value="true"
                    dense
                    class="view-mode-toggle__btn"
                    :class="{ 'view-mode-toggle__btn--active': viewMode === true }"
                    data-testid="tasklist__horizon-view-btn"
                  >
                    <v-icon :class="{ 'mr-1': viewMode === true }">mdi-calendar</v-icon>
                    <span v-if="viewMode === true" class="view-mode-toggle__label">Horizon</span>
                  </v-btn>
                </v-btn-toggle>
              </div>
              <div class="d-flex align-center gap-2">
                <!-- Bulk Upload component -->
                <BulkUploadChecklistV2
                  uploadType="checklist"
                  buttonLabel="Import Tasks"
                  :expectedHeadings="this.$constants.EXPECTED_HEADERS_CLOSE_CYCLE"
                  :customColumns="customColumns"
                  :chartOfAccounts="chartAcc"
                  :project="id"
                  :activeUsers="userDetails.activeUsers"
                  @reload="refreshData()" 
                  v-if="$nova.hasRight(right, 'edit') ||
                        $nova.hasRight(right, 'add')"
                />

                <v-btn
                  color="primaryBtn"
                  class=""
                  @click="
                    showlocationanduser = false;
                    selectedLocation = null;
                    addEditForm();
                  "
                  v-if="$nova.hasRight(right, 'edit') ||
                      $nova.hasRight(right, 'add')"
                  data-testid="tasklist__add-btn"
                  ><v-icon class="mr-1" data-testid="tasklist__add-icon">mdi-plus</v-icon> <span data-testid="tasklist__add-label"> New Task</span></v-btn
                >
              </div>
            </div>
          </div>
          <TaskStageTabs
            v-if="!isHorizonView"
            :loading="loading"
            :metadata="metadata"
            :task-tabs="taskTabs"
            :selected-tab-stage="selectedTabStage"
            :active-summary="activeSummary"
            @select-stage="filterWithTask($event)"
          />
          <div
            v-if="isHorizonView && hasTasklistMetadata"
            class="flex-fill-table"
            data-testid="tasklist__horizon-panel"
          >
            <HorizonLanding
              ref="horizonLanding"
              :loading="loading"
              data-testid="tasklist__horizon-landing"
              @hook:mounted="onHorizonLandingMounted"
              @role-change="onHorizonRoleChange"
              @due-date-updated="onHorizonDueDateUpdated"
            />
          </div>
          <div v-else-if="loading && !hasTasklistMetadata" data-testid="tasklist__loading-skeleton">
            <v-skeleton-loader
              type="table-heading, list-item-two-line, article, article, article"
            ></v-skeleton-loader>
          </div>
          <div class="flex-fill-table" v-else-if="!isHorizonView">
            <div class="d-flex align-center justify-space-between tasklist__toolbar mb-3" data-testid="tasklist__toolbar">
              <div class="d-flex gap-4" data-testid="tasklist__toolbar-tabs-group">
                <RoleSwitcher
                  :value="userType"
                  :show-manager="hasManagerRole"
                  @change="filterListByUser"
                />
              </div>
              <TaskbarToolbar
                :has-active-table-filter="hasActiveTableFilter"
                :chatbot-enabled="chatbotEnabled"
                :column-order-changed="columnOrderChanged"
                :loading="loading"
                :metadata="metadata"
                :select-item="selectItem"
                :user-type="userType"
                :over-due-date="overDueDate"
                :table-headers-filter="tableHeadersfilter"
                :page_name="page_name"
                :show-conversation="$nova.hasRight(right, 'edit') || $nova.hasRight(right, 'add')"
                @clear-filter="clearTableFilter()"
                @redirect-chatbot="redirectChatBot()"
                @save-column-order="saveColumnOrder()"
                @overdue-filter="overDueDateFun()"
                @bulk-workpaper-upload="bulkworkpaperuploadFun()"
                @get-task-details="getTaskDetails()"
                @download-excel="downloadExcel()"
                @mark-conversation-read="metadata.conversation_read = true"
                @bulk-action="bulkActionUserdilog($event)"
                @bulk-update-duedate="bulkUpdatedueDate(selectItem)"
                @bulk-edit-threshold="openBulkThresholdDialog()"
                @bulk-edit-tasks="bulkEdit(selectItem)"
                @bulk-unlink-bot="bulkunlinkBot(selectItem)"
                @bulk-download="downloadbbulk(selectItem)"
                @bulk-change-status="changeChecklistStatus(selectItem, $event)"
                @apply-columns="handleApplyColumns($event)"
                @save-columns="handleSaveColumns($event)"
                data-testid="tasklist__toolbar"
              />
            </div>
            <div v-if="loading === false" class="tasklist__table-panel">
            <div class="lb-datatableaction-wrapper">
            <lb-datatableaction
              ref="dataTableAction"
              :headers="tableHeadersfilter"
              :tabledata="filterByTab"
              :displayedRowCount="paginatedFilteredItems.length"
              :itemsperpage="itemsPerPage"
              :searchterm="search"
              :enableSaveOption="true"
              thead-class="tasklist-thead"
              header-row-class="tasklist-header-row"
              header-cell-class="tasklist-header-cell"
              @select-all-change="select"
              :isDataSelected="selectItem.length > 0 && selectItem.length < paginatedFilteredItems.length"
              @filter-item="filterPart"
              @filter-active-change="onFilterActiveChange"
              @refresh="getRefresh"
              @sort-order="sortingOrder"
              @column-reorder="onColumnReorder"
              :selectfilter="tableFilterHeader"
              :page_details="page_details"
              class="tasklist-table"
              data-testid="tasklist__datatable-action"
            >
              <template v-slot:tbody>
                <tr
                  v-for="(item, index) in paginatedFilteredItems"
                  :key="item?._id ? `${item._id}-${index}` : `task-${index}`"
                  class="cursor-pointer"
                  :class="{ 'low-opacity': item.status === false }"
                  data-testid="tasklist__table-row"
                >
                  <td class="align-center justify-center">
                    <v-checkbox
                      dense
                      color="primary"
                      class="ma-0 py-1"
                      :ripple="false"
                      hide-details
                      :value="item"
                      v-model="selectItem"
                      multiple
                      data-testid="tasklist__table-row-checkbox"
                    ></v-checkbox>
                  </td>
                  <template v-for="header in tableHeadersfilter">
                    <td
                      v-if="header.visible"
                      :key="header.value"
                      class="px-2"
                      :class="header.value === 'description' ? 'description-header' : 'single-line'"
                      @click="['description','ref','task_type','stage'].includes(header.value) ? viewTaskDetails(item) : null"
                      data-testid="tasklist__table-cell"
                    >
                      <div class="" v-if="header.value === 'location'">
                        <span>{{ getLocationById(item.location) }} </span>
                      </div>
                      <div class="two-line-clamp" v-else-if="header.value === 'description'">
                        <span>{{ getItemData(item, header.value) }}</span>
                      </div>
                      <div class="" v-else-if="header.value === 'duedays'">
                        <div>
                          <div
                            v-if="
                              item[header.value] !== undefined &&
                              item[header.value] !== null &&
                              item[header.value] !== ''
                            "
                            :label="true"
                            size="25"
                            :color="
                              item[header.value] < 0
                                ? ''
                                : ''
                            "
                            :class="
                              item[header.value] < 0
                                ? 'error--text amount-cell font-weight-bold'
                                : 'black--text amount-cell'
                            "
                          >
                            <span class="amount-value">{{ item[header.value] }}</span>
                        </div>
                        </div>
                      </div>
                      <div class="d-flex" v-else-if="header.value === 'task_type'">
                        <span>{{ item.task_type }}</span>
                      </div>
                      <div class="d-flex" v-else-if="header.value === 'stage1'">
                        <v-chip
                          v-if="getStageText(item.stage)"
                          :color="getStageText(item.stage).color"
                          :class="getStageText(item.stage).class"
                          :label="true"
                          class="statusChip pa-0"
                        >
                          <span class="status-empty-indicator status-indicator-width-height-10"></span>
                          <span>{{ getStageText(item.stage).text }}</span>
                        </v-chip>
                      </div>
                      <div class="d-flex" v-else-if="header.value === 'upload'">
                        <v-tooltip
                          bottom
                          content-class="tooltip-bottom"
                          v-if="userType === 'preparer'"
                        >
                          <template v-slot:activator="{ on, attrs }">
                            <v-btn
                              icon
                              data-testid="tasklist__upload-button"
                              v-bind="attrs"
                              v-on="on"
                              @click="handleOpenUploadDrawer(item)"
                            >
                              <v-icon>mdi-upload</v-icon></v-btn
                            >
                          </template>
                          <span>Upload</span>
                        </v-tooltip>

                        <v-tooltip
                          bottom
                          content-class="tooltip-bottom"
                          v-else-if="userType === 'manager'"
                        >
                          <template v-slot:activator="{ on, attrs }">
                            <v-btn
                              icon
                              data-testid="tasklist__edit-button"
                              v-bind="attrs"
                              v-on="on"
                              @click="viewTaskDetails(item)"
                            >
                              <v-icon>mdi-pencil-outline</v-icon></v-btn
                            >
                          </template>
                          <span>Edit</span>
                        </v-tooltip>

                        <!-- Approver: Show download button with menu if files exist -->
                        <v-menu
                          offset-y
                          transition="slide-y-transition"
                          :close-on-content-click="false"
                          v-else-if="userType === 'approver' && item.upload_v2 && item.upload_v2.length > 0"
                        >
                          <template v-slot:activator="{ on, attrs }">
                            <v-tooltip bottom content-class="tooltip-bottom">
                              <template
                                v-slot:activator="{
                                  on: tooltipOn,
                                  attrs: tooltipAttrs,
                                }"
                              >
                                <v-btn
                                  icon
                                  v-bind="{ ...attrs, ...tooltipAttrs }"
                                  v-on="{ ...on, ...tooltipOn }"
                                  @click="OpenBulkUploadBox(item)"
                                  data-testid="tasklist__download-button"
                                  ><v-icon>mdi-download</v-icon></v-btn
                                >
                              </template>
                              <span>Download</span>
                            </v-tooltip>
                          </template>
                          <v-list
                            style="
                              max-height: 50vh;
                              overflow: hidden;
                              z-index: 13 !important;
                              width: 25vh;
                            "
                            class="pa-0 ma-0 d-flex flex-column align-start justify-start all-width"
                          >
                            <v-list-title
                              class="all-width d-flex tableHeaderBg align-center pa-2 pb-3 pt-3 pb-1 justify-space-between noTransform"
                              data-testid="tasklist__document-title"
                            >
                              Document attached
                            </v-list-title>
                            <v-divider></v-divider>
                            <v-list-item
                              style="max-height: 25vh; overflow: scroll"
                              class="d-flex all-width align-start pa-0 ma-0 flex-column"
                              data-testid="tasklist__document-items"
                            >
                              <v-list-item
                                class="d-flex pa-0 px-2 ma-0 all-width flex-wrap"
                                v-if="fileNamesList.length > 0"
                              >
                                  <div
                                    v-for="(file, index) in fileNamesList"
                                    :key="index"
                                    class="d-flex align-center justify-space-between all-width"
                                  >
                                    <span>{{ file.uploadname }}</span>
                                    <v-btn
                                      icon
                                      @click="$nova.downloadFile(file._id)"
                                      data-testid="tasklist__document-download-btn"
                                      ><v-icon class="pr-2"
                                        >mdi-download</v-icon
                                      ></v-btn
                                    >
                                  </div>
                              </v-list-item>
                              <v-list-item
                                v-else
                                class="gray--text d-flex align-center justify-center all-width"
                              >
                                <span data-testid="tasklist__document-no-file">No data</span>
                              </v-list-item>
                            </v-list-item>
                          </v-list>
                        </v-menu>

                        <!-- Approver: Show info icon with tooltip if only remark exists (no files) -->
                        <v-tooltip
                          bottom
                          content-class="tooltip-bottom"
                          v-else-if="userType === 'approver' && (!item.upload_v2 || item.upload_v2.length === 0) && item.remark"
                        >
                          <template v-slot:activator="{ on, attrs }">
                            <v-btn
                              icon
                              v-bind="attrs"
                              v-on="on"
                              data-testid="tasklist__info-button"
                            >
                              <v-icon>mdi-information-outline</v-icon>
                            </v-btn>
                          </template>
                          <span>{{ item.remark }}</span>
                        </v-tooltip>
                      </div>
                      <div class="amount-cell" v-else-if="header.value === '__tbtotals'">
                        <span class="amount-value" v-if="(getItemData(item, header.value) || {}).total">
                          {{ formatAmount((getItemData(item, header.value) || {}).total || 0) }}
                        </span>
                        <span class="amount-value" v-else>0</span>
                      </div>
                      <div class="amount-cell" v-else-if="header.value === 'difference'">
                        <span class="amount-value">
                          {{ formatAmount(calculateUnexplainedDifference(item)) }}
                        </span>
                      </div>
                      <div class="amount-cell" v-else-if="header.value === 'scheduleAmount'">
                        <span class="amount-value">
                          {{ formatAmount(calculateScheduleAmount(item)) }}
                        </span>
                      </div>
                      <div class="amount-cell" v-else-if="header.value === 'explainedDifference'">
                        <span class="amount-value">
                          {{ formatAmount(calculateExplainedDifference(item)) }}
                        </span>
                      </div>
                      <div class="" v-else-if="header.value === 'preparerids'">
                        <div class="d-flex px-1" v-if="item?.preparerids && item.preparerids.length > 0">
                          <div
                            v-for="(preparer, index) in item.preparerids.slice(0, 3)"
                            :key="index"
                            class="d-flex"
                          >
                            <v-tooltip
                              top
                              content-class="tooltip-top"
                              v-if="preparer"
                            >
                              <template v-slot:activator="{ on }">
                                <v-avatar
                                  v-on="on"
                                  size="25"
                                  color="avatar-bg"
                                  class="white--text font-small d-flex pa-0 ma-0 noTransform"
                                  data-testid="tasklist__preparer-avatar"
                                >
                                  <span> {{preparer?.charAt(0)}}</span>
                                </v-avatar>
                              </template>
                              <span>{{ preparer }}</span>
                            </v-tooltip>
                          </div>

                          <v-tooltip
                            top
                            content-class="tooltip-top"
                            v-if="item?.preparerids?.length > 3"
                          >
                            <template v-slot:activator="{ on }">
                              <v-avatar
                                v-on="on"
                                size="25"
                                color="white"
                                style="margin-left: -8px !important; border: 1px solid var(--grey-400) !important"
                                class="black--text font-small align-center justify-center d-flex pa-0 ma-0"
                                data-testid="tasklist__preparer-more-avatar"
                              >
                                +{{ item.preparerids.length - 3 }}
                              </v-avatar>
                            </template>
                            <div>
                              <div
                                v-for="(preparer, index) in item.preparerids.slice(3)"
                                :key="index"
                              >
                                <span>{{ preparer }}</span>
                              </div>
                            </div>
                          </v-tooltip>
                        </div>
                      </div>
                      <div class="" v-else-if="header.value === 'approverids'">
                        <div class="d-flex px-1" v-if="item?.approverids && item.approverids.length > 0">
                          <div
                            v-for="(approver, index) in item.approverids.slice(0, 3)"
                            :key="index"
                            class="d-flex"
                          >
                            <v-tooltip
                              top
                              content-class="tooltip-top"
                              v-if="approver"
                            >
                              <template v-slot:activator="{ on }">
                                <v-avatar
                                  v-on="on"
                                  size="25"
                                  color="avatar-bg"
                                  class="white--text font-small d-flex pa-0 ma-0 noTransform"
                                  data-testid="tasklist__approver-avatar"
                                >
                                  <span>{{approver?.charAt(0)}}</span>
                                </v-avatar>
                              </template>
                              <span>{{ approver }}</span>
                            </v-tooltip>
                          </div>

                          <v-tooltip
                            top
                            content-class="tooltip-top"
                            v-if="item?.approverids?.length > 3"
                          >
                            <template v-slot:activator="{ on }">
                              <v-avatar
                                v-on="on"
                                size="25"
                                color="white"
                                style="margin-left: -8px !important; border: 1px solid var(--grey-400) !important"
                                class="black--text font-small align-center justify-center d-flex pa-0 ma-0"
                                data-testid="tasklist__approver-more-avatar"
                              >
                                +{{ item.approverids.length - 3 }}
                              </v-avatar>
                            </template>
                            <div>
                              <div
                                v-for="(approver, index) in item.approverids.slice(3)"
                                :key="index"
                              >
                                <span>{{ approver }}</span>
                              </div>
                            </div>
                          </v-tooltip>
                        </div>
                      </div>
                      <div class="" v-else-if="header.value === 'created_at'">
                        {{ $nova.formatDate(item.created_at) }}
                      </div>
                      <div class="" v-else-if="header.value === 'tags'">
                          <v-chip
                            v-for="(item, index) in item.tags"
                            :key="index"
                            label
                            color="lightpurple"
                            class="caccounting--text"
                            data-testid="tasklist__tag"
                            ><span>{{ item }}</span></v-chip
                          >
                      </div>
                      <div class="" v-else-if="header.value === 'statusdetail'">
                        <v-tooltip bottom content-class="tooltip-bottom">
                          <template v-slot:activator="{ on, attrs }">
                            <v-btn
                              v-bind="attrs"
                              v-on="on"
                              icon
                              class="shadow-off"
                              data-testid="tasklist__status-button"
                            >
                              <v-icon :color="getStatusConfig(item.statusdetail).color">
                                {{ getStatusConfig(item.statusdetail).icon }}
                              </v-icon>
                            </v-btn>
                          </template>
                          <span>{{ getStatusConfig(item.statusdetail).text }}</span>
                        </v-tooltip>
                      </div>
                      <div v-else-if="header.value === 'ref'" class="d-flex align-center justify-space-between"> 
                        <span>{{ getItemData(item, header.value) }}</span>
                        <img
                          v-if="isTaskBotLinked(item)"
                          src="/img/navicon/AIAgent.svg"
                          alt="bot-logo"
                          class="bot-icon"
                          data-testid="task-ref__bot-icon"
                          />
                      </div>
                       <div v-else-if="header.value === 'action'" class="d-flex align-center justify-space-between"> 
                       <v-menu
                      bottom
                      offset-y
                      :max-width="400"
                      elevation-0
                      :close-on-content-click="false"
                      data-testid="tasklist__menu"
                    >
                      <template v-slot:activator="{ on, attrs }">
                        <div class="text-center">
                          <v-btn icon v-bind="attrs" v-on="on" data-testid="tasklist__menu-btn">
                            <v-icon>mdi-dots-horizontal</v-icon>
                          </v-btn>
                        </div>
                      </template>
                      <v-list style="width: 25vh">
                        <v-list-item
                          class="d-flex pa-0 flex-column align-start justify-center px-1"
                          v-if="userType === 'manager'"
                          data-testid="tasklist__manager-menu"
                        >
                          <!-- <v-list-item
                            class="cursor-pointer hoverable-caccounting all-width radius-small"
                            @click="addEditForm(item)"
                          >
                            <v-icon class="pr-2">mdi-pencil-outline</v-icon>
                            <span>Edit</span>
                          </v-list-item> -->
                          <v-list-item
                            class="cursor-pointer hoverable-caccounting all-width radius-small"
                          >
                            <lb-comment
                              heading="Conversation"
                              width="600"
                              :recurring="false"
                              :recurringText="''"
                              :closed="metadata.stage !== 0"
                              :showname="true"
                              @markread="item.conversation_read = true"
                              :notify="!item.conversation_read"
                              :getapi="
                                '/v2/financialclose/analysis/getconversation/' +
                                metadata._id +
                                '/c/' +
                                item._id
                              "
                              :sendapi="
                                '/v2/financialclose/analysis/addconversation/' +
                                metadata._id +
                                '/c/' +
                                item._id
                              "
                              :readapi="
                                '/v2/financialclose/analysis/markreadconversation/' +
                                metadata._id +
                                '/c/' +
                                item._id
                              "
                              :name="'Comment'"
                              :mentionapi="'/v2/financialclose/analysis/getusersformdata'"
                              data-testid="tasklist__comment"
                            />
                          </v-list-item>
                          <v-list-item
                            class="cursor-pointer hoverable-caccounting all-width radius-small"
                            @click="deleteChecklistItem(item)"
                            data-testid="tasklist__delete-btn"
                          >
                            <v-icon class="pr-2">mdi-delete-outline</v-icon>
                            <span>Delete</span>
                          </v-list-item>
                          <v-list-item
                            class="cursor-pointer hoverable-caccounting all-width radius-small"
                            data-testid="tasklist__activity-log"
                          >
                           <activity-log
                              :resource-id="item._id"
                              label="Activity Log"
                              :row-description="item.description"
                              data-testid="tasklist__activity-log"
                              list-item-mode
                            />
                          </v-list-item>
                          <!-- <v-list-item class="cursor-pointer hoverable-caccounting all-width  radius-small" >
                                                        <v-icon class="pr-2">mdi-card-multiple-outline</v-icon>
                                                        <span>Update in Masters</span>
                                                    </v-list-item> -->
                        </v-list-item>
                        <v-list-item
                          class="d-flex pa-0 flex-column align-start justify-center px-1"
                          v-else-if="userType === 'preparer'"
                          data-testid="tasklist__preparer-menu"
                        >
                          <v-list-item
                            class="cursor-pointer hoverable-caccounting all-width radius-small"
                            @click="openBulkUpload(item)"
                            data-testid="tasklist__upload-btn"
                          >
                            <v-icon class="pr-2"
                              >mdi-file-upload-outline</v-icon
                            >
                            <span>Upload</span>
                          </v-list-item>
                          <v-list-item
                            class="cursor-pointer hoverable-caccounting all-width radius-small"
                            @click="workpaperTemplate()"
                            data-testid="tasklist__download-template-btn"
                          >
                            <v-icon class="pr-2"
                              >mdi-file-download-outline</v-icon
                            >
                            <span>Download Template</span>
                          </v-list-item>
                          <v-list-item
                            class="cursor-pointer hoverable-caccounting all-width radius-small"
                          >
                            <lb-comment
                              heading="Conversation"
                              width="600"
                              :recurring="false"
                              :recurringText="''"
                              :showname="true"
                              @markread="item.conversation_read = true"
                              :notify="!item.conversation_read"
                              :getapi="
                                '/v2/financialclose/analysis/getconversation/' +
                                metadata._id +
                                '/c/' +
                                item._id
                              "
                              :sendapi="
                                '/v2/financialclose/analysis/addconversation/' +
                                metadata._id +
                                '/c/' +
                                item._id
                              "
                              :readapi="
                                '/v2/financialclose/analysis/markreadconversation/' +
                                metadata._id +
                                '/c/' +
                                item._id
                              "
                              :name="'Comment'"
                              :mentionapi="'/v2/financialclose/analysis/getusersformdata'"
                              :closed="false"
                              data-testid="tasklist__comment"
                            />
                          </v-list-item>
                          <v-list-item
                            class="cursor-pointer hoverable-caccounting all-width radius-small"
                          >
                            <activity-log
                              :resource-id="item._id"
                              label="Activity Log"
                              :row-description="item.description"
                              data-testid="tasklist__activity-log"
                            />
                          </v-list-item>
                        </v-list-item>
                        <v-list-item
                          class="d-flex pa-0 flex-column align-start justify-center px-1"
                          v-else-if="userType === 'approver'"
                          data-testid="tasklist__approver-menu"
                        >
                          <v-list-item
                            class="cursor-pointer hoverable-caccounting all-width radius-small"
                            v-if="hasDownloadableFiles(item)"
                            @click="downloadSingleTaskFiles(item)"
                            data-testid="tasklist__download-all-btn"
                          >
                            <v-icon class="pr-2">mdi-tray-arrow-down</v-icon>
                            <span>Download All</span>
                          </v-list-item>
                          <v-list-item
                            class="cursor-pointer hoverable-caccounting all-width radius-small"
                            v-if="!isClosedTask(item)"
                            @click="changeChecklistStatus(item._id, 'approve')"
                            data-testid="tasklist__approve-btn"
                          >
                            <v-icon class="pr-2">mdi-check-circle</v-icon>
                            <span>Approve</span>
                          </v-list-item>
                          <v-list-item
                            class="cursor-pointer hoverable-caccounting all-width radius-small"
                            v-if="!isClosedTask(item)"
                            @click="changeChecklistStatus(item._id, 'reject')"
                            data-testid="tasklist__reject-btn"
                          >
                            <v-icon class="pr-2">mdi-close-circle</v-icon>
                            <span>Reject</span>
                          </v-list-item>
                          <v-list-item
                            class="cursor-pointer hoverable-caccounting all-width radius-small"
                          >
                            <lb-comment
                              heading="Conversation"
                              width="600"
                              :recurring="false"
                              :recurringText="''"
                              :closed="metadata.stage !== 0"
                              :showname="true"
                              @markread="item.conversation_read = true"
                              :notify="!item.conversation_read"
                              :getapi="
                                '/v2/financialclose/analysis/getconversation/' +
                                metadata._id +
                                '/c/' +
                                item._id
                              "
                              :sendapi="
                                '/v2/financialclose/analysis/addconversation/' +
                                metadata._id +
                                '/c/' +
                                item._id
                              "
                              :readapi="
                                '/v2/financialclose/analysis/markreadconversation/' +
                                metadata._id +
                                '/c/' +
                                item._id
                              "
                              :name="'Comment'"
                              :mentionapi="'/v2/financialclose/analysis/getusersformdata'"
                              data-testid="tasklist__comment"
                            />
                          </v-list-item>
                          <v-list-item
                            class="cursor-pointer hoverable-caccounting all-width radius-small"
                          >
                            <activity-log
                              :resource-id="item._id"
                              label="Activity Log"
                              :row-description="item.description"
                              data-testid="tasklist__activity-log"
                            />
                          </v-list-item>
                        </v-list-item>
                        <v-divider class="pa-0 ma-0"></v-divider>
                        <v-list-item
                          class="d-flex pa-0 flex-column align-start justify-center px-1"
                        >
                          <v-list-item
                            class="cursor-pointer hoverable-caccounting all-width radius-small"
                            @click="openHelpdeskDialog(item)"
                            data-testid="tasklist__helpdesk-btn"
                          >
                            <v-icon class="pr-2">mdi-headphones</v-icon>
                            <span>Support</span>
                          </v-list-item>
                          <v-list-item
                            class="cursor-pointer hoverable-caccounting all-width radius-small"
                            @click="openlinkBotDialog(item)"
                            v-if="
                              metadata.managerlist.includes(userid) &&
                              !item.botid
                            "
                            data-testid="tasklist__link-bot-btn"
                          >
                            <v-icon class="pr-2">mdi-robot-outline</v-icon>
                            <span>Link {{$constants.BOT_NAME}}</span>
                          </v-list-item>

                          <v-list-item
                            class="cursor-pointer hoverable-caccounting all-width radius-small"
                            @click="unlinkBot(item)"
                            v-if="
                              metadata.managerlist.includes(userid) &&
                              item.botid
                            "
                            data-testid="tasklist__unlink-bot-btn"
                          >
                            <v-icon class="pr-2">mdi-link-off</v-icon>
                            <span>Unlink {{$constants.BOT_NAME}}</span>
                          </v-list-item>
                          <v-list-item
                            class="cursor-pointer hoverable-caccounting all-width radius-small"
                            @click="viewTaskDetails(item)"
                            data-testid="tasklist__view-details-btn"
                          >
                            <v-icon class="pr-2"
                              >mdi-information-outline</v-icon
                            >
                            <span>View Details</span>
                          </v-list-item>
                        </v-list-item>
                      </v-list>
                    </v-menu>
                      </div>
                      <span v-else>{{ getItemData(item, header.value) }}</span>
                    </td>
                  </template>
                 
                </tr>
              </template>
            </lb-datatableaction>
          </div>
          </div>
            <v-skeleton-loader v-else type="table-heading, list-item-two-line, article, article, article" class="my-4"/>

          </div>
        </v-card-text>
      </v-card>

      <lb-drawer
        v-model="addeditdialog"
        :heading="addeditdata._id ? 'Edit Task' : 'Create Task'"
        width="600"
        :loading="addeditloading"
        data-testid="tasklist__add-edit-drawer"
      >
        <template v-slot:body>
          <div>
            <v-row>
              <v-col cols="12" class="my-1 py-1">
                <p class="gray--text pa-0 ma-0 text-font-size-md mb-1">
                  Task Description*
                </p>
                <lb-textBox
                  v-model="addeditdata.description"
                  label=""
                  requriedrows="3"
                  :error="addeditdataerror.description"
                  data-testid="tasklist__description"
                />
              </v-col>
              <v-col cols="6" class="my-1 py-1">
                <p class="gray--text ma-0 pa-0 text-font-size-md">Task Type*</p>
                <lb-dropdown
                  v-model="addeditdata.task_type"
                  :items="taskTypes"
                  :error="addeditdataerror.task_type"
                  label=""
                  :disabled="isTaskTypeDisabled"
                  data-testid="tasklist__task-type"
                />
              </v-col>
              <v-col cols="6" class="my-1 py-1">
                <p class="pa-0 ma-0 text-font-size-md gray--text">Category*</p>
                <lb-dropdown v-if="addeditdata.task_type === $constants.TASK_LIST_CONSTANTS.TASK_TYPES.ACCOUNT_RECONCILIATION"
                  :multiple="false" v-model="addeditdata.category"
                  appendiconinner="mdi-chevron-down" :error="addeditdataerror.category"
                  :items="coaCategoryAcc" label=""
                  data-testid="tasklist__category" />
                <lb-tagsInput v-else
                  :multiple="false"
                  :multiplechips="false"
                  v-model="addeditdata.category"
                  appendiconinner="mdi-chevron-down"
                  :error="addeditdataerror.category"
                  :items="categoryAcc"
                  data-testid="tasklist__category"
                />
              </v-col>

              <v-col cols="6" class="my-1 py-1">
                <p class="pa-0 ma-0 gray--text text-font-size-md">
                  Sub Category*
                </p>
                <lb-dropdown v-if="addeditdata.task_type === $constants.TASK_LIST_CONSTANTS.TASK_TYPES.ACCOUNT_RECONCILIATION"
                  :multiple="false" v-model="addeditdata.subcategory"
                  appendiconinner="mdi-chevron-down" :error="addeditdataerror.subcategory"
                  :items="coaSubcategoryAcc" label=""
                  data-testid="tasklist__subcategory" />
                <lb-tagsInput v-else
                  :multiple="false"
                  :multiplechips="false"
                  v-model="addeditdata.subcategory"
                  :error="addeditdataerror.subcategory"
                  :items="subcategoryAcc"
                  appendiconinner="mdi-chevron-down"
                  data-testid="tasklist__subcategory"
                />
              </v-col>
              <v-col cols="6" class="my-1 py-1">
                <p class="gray--text ma-0 pa-0 text-font-size-md">Due Date*</p>
                <lb-date
                  v-model="addeditdata.duedate"
                  label=""
                  :error="addeditdataerror.duedate"
                  :min="dueDateMinDate"
                  :max="dueDateMaxDate"
                  data-testid="tasklist__due-date"
                />
                <span class="font-size-xm gray--text">Due date must be within {{ $options.MAX_DUE_DATE_DAYS }} days from today.</span>
              </v-col>
              <v-col cols="6" class="my-1 py-1">
                <p class="gray--text pa-0 ma-0 text-font-size-md">Assertions</p>
                <lb-tagsInput
                  v-model="addeditdata.assertions"
                  :hidedetails="true"
                  :items="possibleAssertions"
                  label=""
                  :error="addeditdataerror.assertions"
                  tagcolor="purpleborder"
                  :multiple="true"
                  :multiplechips="true"
                  data-testid="tasklist__assertions"
                />
              </v-col>
              <v-col cols="6" class="my-1 py-1">
                <p class="gray--text pa-0 ma-0 text-font-size-md">No. of Evidences</p>
                <v-text-field
                  v-model.number="addeditdata.no_of_evidence"
                  type="number"
                  :min="0"
                  :max="10"
                  :step="1"
                  outlined
                  dense
                  :error-messages="addeditdataerror.no_of_evidence"
                  @input="onEvidenceInput"
                  @keypress="(e) => { if (e.key === '.' || e.key === ',') e.preventDefault(); }"
                  data-testid="tasklist__no-of-evidences"
                />
              </v-col>
              <v-col cols="6" class="my-1 py-1">
                <p class="gray--text ma-0 pa-0 text-font-size-md">Purpose</p>
                <lb-textarea
                  v-model="addeditdata.purpose"
                  label=""
                  height="100"
                  :hidedetails="true"
                  :error="addeditdataerror.purpose"
                  data-testid="tasklist__purpose"
                />
              </v-col>

              <v-col cols="6" class="my-1 py-1">
                <p class="gray--text ma-0 pa-0 text-font-size-md">Instruction</p>
                <lb-textarea
                  v-model="addeditdata.instruction"
                  label=""
                  :error="addeditdataerror.instruction"
                  height="100"
                  :hidedetails="true"
                  data-testid="tasklist__instruction"
                />
              </v-col>

              <v-col cols="6" class="my-1 py-1">
                <p class="gray--text ma-0 pa-0 text-font-size-md">Priority*</p>
                <lb-dropdown
                  v-model="addeditdata.priority"
                  :items="priorityList"
                  :error="addeditdataerror.priority"
                  label=""
                  data-testid="tasklist__priority"
                />
              </v-col>
              <v-col cols="6" class="my-1 py-1">
                <p class="gray--text pa-0 ma-0 text-font-size-md">Tags</p>
                <lb-tagsInput
                  tagcolor="purpleborder"
                  :multiple="true"
                  v-model="addeditdata.tags"
                  :multiplechips="true"
                  :items="Alltags"
                  :error="addeditdataerror.tags"
                  data-testid="tasklist__tags"
                />
              </v-col>
              <v-col
                cols="12"
                class="my-1 py-1"
                v-if="addeditdata.task_type === $constants.TASK_LIST_CONSTANTS.TASK_TYPES.ACCOUNT_RECONCILIATION"
              >
                <v-card flat outlined rounded="lg" class="px-3 py-3">
                  <div class="d-flex align-center gap-2">
                    
                    <!-- Icon -->
                    <div class="d-flex align-center justify-center">
                      <v-icon :color="addeditdata.skipValidations ? 'success' : 'grey'" size="20">{{ addeditdata.skipValidations ? 'mdi-shield-check-outline' : 'mdi-shield-off-outline' }}</v-icon>
                    </div>

                    <!-- Text -->
                    <div class="flex-grow-1">
                      <p class="font-weight-medium mb-0" style="color: var(--v-theme-on-surface);">
                        {{ addeditdata.skipValidations ? 'Threshold Enforcement Enabled' : 'Threshold Enforcement Disabled' }}
                      </p>
                      <p class="text-caption grey--text mb-0">
                        {{ addeditdata.skipValidations ? 'Applies standard attachment and threshold validations' : 'Bypasses attachment and threshold validations' }}
                      </p>
                    </div>

                    <!-- Toggle -->
                    <v-switch
                      v-model="addeditdata.skipValidations"
                      :true-value="true"
                      :false-value="false"
                      inset
                      dense
                      color="primary"
                      class="mt-0 pt-0 flex-shrink-0"
                      hide-details
                      data-testid="tasklist__skip-validations"
                    />

                  </div>
                </v-card>
              </v-col>
              <template v-if="customColumns.length > 0">
             <v-col v-for="field in customColumns" :key="field.columnName" cols="12" class="my-1 py-1">
              <p class="gray--text ma-0 pa-0  text-font-size-md">{{ field.displayText }}</p>
              <!-- Text Field -->
              <lb-string v-if="field.dataType === 'string'" v-model="addeditdata[field.columnName]"
                :label="field.displayText" :error="addeditdataerror[field.columnName]" data-testid="tasklist__custom-field-string" />
 
              <!-- Date Field -->
              <lb-date v-else-if="field.dataType === 'date'" v-model="addeditdata[field.columnName]"
                :label="field.displayText" :error="addeditdataerror?.[field.columnName]" data-testid="tasklist__custom-field-date" />

              <!-- Number Field -->
              <lb-number v-else-if="field.dataType === 'number'" min="0" :label="field.displayText"
                v-model="addeditdata[field.columnName]" data-testid="tasklist__custom-field-number" />

              <!-- Fallback (optional) -->
              <lb-textBox v-else v-model="addeditdata[field.columnName]" :label="field.displayText" data-testid="tasklist__custom-field-textbox" />
            </v-col>
            </template>
              <v-col cols="6" v-if="showlocationanduser" :class="{'mandatory-error-border': addeditdataerror.location_users}">
                <p class="pa-0 ma-0 mb-2 gray--text" data-testid="tasklist__location-users">
                 <span>Add {{ $store.state.LocationHeader || "Location" }} and users*</span>
                </p>
                <v-card class="shadow-off border-on">
                  <v-card-title
                    class="tableHeaderBg d-flex align-center justify-space-between px-2 py-1"
                  >
                    <span>{{ getLocationById(addeditdata.location) }}</span>
                    <v-btn
                      icon
                      color="error"
                      @click="
                        showlocationanduser = false;
                        addeditdata.location = [];
                        addeditdata.preparer = [];
                        addeditdata.approver = [];
                      "
                      data-testid="tasklist__remove-location-users-btn"
                    >
                      <v-icon>mdi-delete</v-icon>
                    </v-btn>
                  </v-card-title>
                  <v-card-text class="pa-1">
                    <v-row class="pa-0">
                      <v-col class="py-2 d-flex flex-column" cols="5"
                        >Preparer
                        <v-menu
                          offset-y
                          transition="slide-y-transition"
                          :close-on-content-click="false"
                          ref="preparerMenu"
                          data-testid="tasklist__preparer-menu"
                        >
                          <template v-slot:activator="{ on, attrs }">
                            <span
                              v-bind="attrs"
                              v-on="on"
                              class="d-flex blue--text font-size-xm  shadow-off"
                              @click="addlocationanduserflag = 0"
                              data-testid="tasklist__preparer-menu-edit"
                            >
                              Edit
                            </span>
                          </template>

                          <v-list
                            style="
                              max-height: 50vh;
                              overflow: hidden;
                              z-index: 13 !important;
                              width: 50vh;
                            "
                            class="pa-0 ma-0 d-flex flex-column align-start justify-start all-width"
                          >
                            <div class="ma-0 all-width">
                              <div
                                class="d-flex tableHeaderBg align-center pa-2 pb-3 pt-3 pb-1"
                              >
                                <p class="ma-0 font-weight-bold" data-testid="tasklist__preparer-menu-title">
                                  Choose Preparer
                                </p>
                              </div>
                            </div>
                            <v-divider></v-divider>

                             <v-list-item style="max-height: 25vh; overflow: scroll"
                              class="d-flex all-width align-start pa-1 ma-0 flex-column">
                              <!-- Loop through usersList and manage checkbox manually -->
                              <div class="user-search-checkbox-list">
                                <div class="search-bar-row d-flex align-center mb-2">
                                  <lb-string
                                    label=""
                                    placeholder="Search"
                                    v-model="searchUserName"
                                    :hidedetails="true"
                                    appendinnericon="mdi-magnify"
                                    class="search-bar"
                                  />
                                </div>
                              </div>
                                <v-checkbox v-for="(item, index) in filterActiveUsersBySearchName" :key="index" :label="item.name" class="pa-0 ma-0" :value="addeditdata.preparer?.includes(item._id)"
                                  @change="togglePreparer(item._id)"
                                  data-testid="tasklist__preparer-checkbox"
                                ></v-checkbox>
                            </v-list-item>

                            <v-list-item
                              class="d-flex align-center justify-space-between all-width px-1"
                            >
                              <v-spacer></v-spacer>
                              <v-btn
                                class="black white--text"
                                @click="$refs.preparerMenu.save()"
                                data-testid="tasklist__preparer-menu-add-btn"
                                ><span>Add</span></v-btn
                              >
                            </v-list-item>
                          </v-list>
                        </v-menu>
                      </v-col>
                      <v-col class="py-2 d-flex avatars-group__item" cols="7">
                        <div
                          class="d-flex avatars-group__item"
                          v-for="(item, index) in addeditdata?.preparer?.slice(
                            0,
                            3
                          )"
                          :key="index"
                        >
                          <v-tooltip top content-class="tooltip-top">
                            <template v-slot:activator="{ on }">
                              <v-avatar
                                size="27"
                                color="caccounting"
                                class="white--text"
                                v-on="on"
                                data-testid="tasklist__preparer-avatar"
                                >{{ getNameById(item)[0] }}</v-avatar
                              >
                            </template>
                            <span>{{ getNameById(item) }}</span>
                          </v-tooltip>
                        </div>
                        <v-tooltip
                          top
                          content-class="tooltip-top"
                          v-if="addeditdata?.preparer?.length > 3"
                        >
                          <template v-slot:activator="{ on }">
                            <v-avatar
                              v-on="on"
                              size="25"
                              color="caccounting"
                              style="margin-left: -8px !important"
                              data-testid="tasklist__preparer-more-avatar"
                              class="white--text font-small align-center justify-center d-flex pa-0 avatar-white-border ma-0 v-avatar"
                            >
                              <v-icon color="white">mdi-plus</v-icon>
                            </v-avatar>
                          </template>
                          <div
                            class=""
                            v-for="(
                              preparer, index
                            ) in addeditdata?.preparer?.slice(3)"
                            :key="index"
                          >
                            <span>{{ getNameById(preparer) }}</span>
                          </div>
                        </v-tooltip>
                      </v-col>
                    </v-row>
                    <v-row class="pa-0">
                      <v-col class="py-2 d-flex flex-column" cols="5">
                        Approver
                        <v-menu
                          offset-y
                          transition="slide-y-transition"
                          :close-on-content-click="false"
                          ref="approverMenu"
                          data-testid="tasklist__approver-menu"
                        >
                          <template v-slot:activator="{ on, attrs }">
                            <span
                              v-bind="attrs"
                              v-on="on"
                              class="d-flex blue--text font-size-xm  shadow-off"
                              @click="addlocationanduserflag = 0"
                              data-testid="tasklist__approver-menu-edit"
                            >
                              Edit
                            </span>
                          </template>

                          <v-list
                            style="
                              max-height: 50vh;
                              overflow: hidden;
                              z-index: 13 !important;
                              width: 50vh;
                            "
                            data-testid="tasklist__approver-menu-list"
                            class="pa-0 ma-0 d-flex flex-column align-start justify-start all-width"
                          >
                            <div class="ma-0 all-width">
                              <div
                                class="d-flex tableHeaderBg align-center pa-2 pb-3 pt-3 pb-1"
                              >
                                <p class="ma-0 font-weight-bold" data-testid="tasklist__approver-menu-title">
                                  Choose Approver
                                </p>
                              </div>
                            </div>
                            <v-divider></v-divider>

                          <v-list-item
                              style="max-height: 25vh; overflow: scroll"
                              class="d-flex all-width align-start pa-1 ma-0 flex-column"
                            >
                              <!-- Loop through usersList and manage checkbox manually -->
                              <div class="user-search-checkbox-list">
                                <div class="search-bar-row d-flex align-center mb-2">
                                  <lb-string
                                    label=""
                                    placeholder="Search"
                                    v-model="searchUserName"
                                    :hidedetails="true"
                                    appendinnericon="mdi-magnify"
                                    class="search-bar"
                                  />
                                </div>
                              </div>
                                <v-checkbox v-for="(item, index) in filterActiveUsersBySearchName" :key="index" :label="item.name" class="pa-0 ma-0" :value="addeditdata.approver?.includes(item._id)"
                                  @change="toggleApprover(item._id)"
                                  data-testid="tasklist__approver-checkbox"
                                ></v-checkbox>
                            </v-list-item>
                            <v-list-item
                              class="d-flex align-center justify-space-between all-width px-1"
                            >
                              <v-spacer></v-spacer>
                              <v-btn
                                class="black white--text"
                                @click="$refs.approverMenu.save()"
                                data-testid="tasklist__approver-menu-add-btn"
                                ><span>Add</span></v-btn
                              >
                            </v-list-item>
                          </v-list>
                        </v-menu>
                      </v-col>

                      <v-col class="py-2 d-flex avatars-group__item" cols="7">
                        <div
                          class="d-flex avatars-group__item"
                          v-for="(item, index) in addeditdata?.approver?.slice(
                            0,
                            3
                          )"
                          :key="index"
                        >
                          <v-tooltip top content-class="tooltip-top">
                            <template v-slot:activator="{ on }">
                              <v-avatar
                                size="27"
                                color="caccounting"
                                class="white--text"
                                v-on="on"
                                data-testid="tasklist__approver-avatar"
                                >{{ getNameById(item)[0] }}</v-avatar
                              >
                            </template>
                            <span>{{ getNameById(item) }}</span>
                          </v-tooltip>
                        </div>
                        <v-tooltip
                          top
                          content-class="tooltip-top"
                          v-if="addeditdata?.approver?.length > 3"
                        >
                          <template v-slot:activator="{ on }">
                            <v-avatar
                              v-on="on"
                              size="25"
                              color="caccounting"
                              style="margin-left: -8px !important"
                              data-testid="tasklist__approver-more-avatar"
                              class="white--text font-small align-center justify-center d-flex pa-0 avatar-white-border ma-0 v-avatar"
                            >
                              <v-icon color="white">mdi-plus</v-icon>
                            </v-avatar>
                          </template>
                          <div
                            class=""
                            v-for="(
                              approver, index
                            ) in addeditdata?.approver?.slice(3)"
                            :key="index"
                            data-testid="tasklist__approver-more-names"
                          >
                            <span>{{ getNameById(approver) }}</span>
                          </div>
                        </v-tooltip>
                      </v-col>
                    </v-row>
                  </v-card-text>
                </v-card>
              </v-col>
              <v-col cols="12" v-else>
                <p class="pa-0 ma-0 mb-2 gray--text" data-testid="tasklist__add-location-users">
                  Add {{ $store.state.LocationHeader || "Location" }} and users*
                </p>
                <div
                  class="border-on all-width d-flex align-center justify-center all-height"
                  :class="{'mandatory-error-border': addeditdataerror.location_users}"
                  style="height: 16vh"
                >
                  <v-menu
                    top
                    offset-y
                    transition="slide-y-reverse-transition"
                    :close-on-content-click="false"
                    data-testid="tasklist__add-location-users-menu"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn
                        text
                        v-bind="attrs"
                        v-on="on"
                        class="d-flex blue--text font-size-xm  shadow-off"
                        @click="addlocationanduserflag = 0"
                        data-testid="tasklist__add-location-users-btn"
                      >
                        <v-icon>mdi-plus</v-icon>
                      <span>Add {{ $store.state.LocationHeader || "Location" }} and
                        users </span>
                      </v-btn>
                    </template>

                    <v-list
                      style="
                        max-height: 50vh;
                        min-width: 340px;
                        width: 30vh;
                        overflow-y: auto;
                        z-index: 13 !important;
                      "
                      data-testid="tasklist__add-location-users-list"
                      class="pa-2 ma-0 d-flex flex-column align-start justify-start all-width"
                      v-if="addlocationanduserflag === 0"
                    >
                      <div class="ma-0 all-width">
                        <div
                          class="d-flex tableHeaderBg align-center pa-2 pb-3 pt-3 pb-1 justify-space-between"
                        >
                          <p class="ma-0 font-weight-bold" data-testid="tasklist__location-menu-title">
                            Choose
                            {{ $store.state.LocationHeader || "Location" }}
                          </p>
                          <v-icon color="primary"
                            >mdi-information-outline</v-icon
                          >
                        </div>
                      </div>
                      <v-divider></v-divider>
                      <v-list-item class="d-flex all-width align-start pa-1 ma-0 flex-column tasklist-location-list">
                          <span
                        v-for="(item, index) in filteredLocationsFromStore"
                        :key="index"
                        class="pa-1 radius-mini cursor-pointer all-width tasklist-location-span"
                        :class="`${
                          selectedLocation === item._id
                            ? 'border-on caccounting white--text'
                            : 'hoverable-caccounting'
                        }`"
                        data-testid="tasklist__location-item"
                        @click="
                          addeditdata.location = item._id;
                          selectedLocation = item._id;
                        "
                      >
                        <span>{{ item.name }}</span>
                      </span>
                  </v-list-item>
                      <v-divider></v-divider>
                      <v-list-item
                        class="d-flex align-center justify-space-between all-width px-1"
                        data-testid="tasklist__location-item"
                      >
                        <v-spacer></v-spacer>
                        <v-btn
                          class="black white--text"
                          v-if="addeditdata.location"
                          @click="addlocationanduserflag = 1"
                          data-testid="tasklist__location-next-btn"
                          ><span>Next</span></v-btn
                        >
                      </v-list-item>
                    </v-list>

                    <v-list
                      style="
                        max-height: 50vh;
                        overflow: hidden;
                        z-index: 13 !important;
                        width: 30vh;
                      "
                      class="pa-0 ma-0 d-flex flex-column align-start justify-start all-width"
                      v-else-if="addlocationanduserflag === 1"
                      data-testid="tasklist__preparer-list"
                    >
                      <div class="ma-0 all-width">
                        <div
                          class="d-flex tableHeaderBg align-center pa-2 pb-3 pt-3 pb-1"
                        >
                          <v-btn icon @click="addlocationanduserflag = 0" data-testid="tasklist__preparer-back-btn">
                            <v-icon>mdi-keyboard-backspace</v-icon>
                          </v-btn>
                          <p class="ma-0 font-weight-bold">Choose Preparer</p>
                          <v-icon color="primary"
                            >mdi-information-outline</v-icon
                          >
                        </div>
                      </div>
                      <v-divider></v-divider>

                    <v-list-item style="max-height: 25vh; overflow: scroll"
                      class="d-flex all-width align-start pa-1 ma-0 flex-column">
                      <!-- Loop through usersList and manage checkbox manually -->
                      <div class="user-search-checkbox-list">
                        <div class="search-bar-row d-flex align-center mb-2">
                          <lb-string
                            label=""
                            placeholder="Search"
                            v-model="searchUserName"
                            :hidedetails="true"
                            appendinnericon="mdi-magnify"
                            class="search-bar"
                          />
                        </div>
                      </div>
                        <v-checkbox v-for="(item, index) in filterActiveUsersBySearchName" :key="index" :label="item.name" class="pa-0 ma-0" :value="addeditdata.preparer?.includes(item._id)"
                          @change="togglePreparer(item._id)"></v-checkbox>
                     </v-list-item>
                      <v-list-item
                        class="d-flex align-center justify-space-between all-width px-1"
                      >
                        <v-spacer></v-spacer>
                        <v-btn
                          class="black white--text"
                          :disabled="addeditdata.preparer?.length === 0"
                          v-if="addeditdata.preparer"
                          @click="addlocationanduserflag = 2"
                          data-testid="tasklist__preparer-next-btn"
                          ><span>Next</span></v-btn
                        >
                      </v-list-item>
                    </v-list>

                    <v-list
                      style="
                        max-height: 50vh;
                        overflow: hidden;
                        z-index: 13 !important;
                        width: 30vh;
                      "
                      class="pa-0 ma-0 d-flex flex-column align-start justify-start all-width"
                      v-else-if="addlocationanduserflag === 2"
                    >
                      <div class="ma-0 all-width">
                        <div
                          class="d-flex tableHeaderBg align-center pa-2 pb-3 pt-3 pb-1"
                        >
                          <v-btn icon @click="addlocationanduserflag = 1" data-testid="tasklist__approver-back-btn">
                            <v-icon>mdi-keyboard-backspace</v-icon>
                          </v-btn>
                          <p class="ma-0 font-weight-bold" data-testid="tasklist__approver-menu-title">Choose Approver</p>
                          <v-icon color="primary"
                            >mdi-information-outline</v-icon
                          >
                        </div>
                      </div>
                      <v-divider></v-divider>

                    <v-list-item style="max-height: 25vh; overflow: scroll"
                        class="d-flex all-width align-start pa-1 ma-0 flex-column">
                        <!-- Loop through usersList and manage checkbox manually -->
                        <div class="user-search-checkbox-list">
                          <div class="search-bar-row d-flex align-center mb-2">
                            <lb-string
                              label=""
                              placeholder="Search"
                              v-model="searchUserName"
                              :hidedetails="true"
                              appendinnericon="mdi-magnify"
                              class="search-bar"
                            />
                          </div>
                        </div>
                          <v-checkbox v-for="(item, index) in filterActiveUsersBySearchName.filter((user)=>!addeditdata.preparer.includes(user._id))" :key="index" :label="item.name" class="pa-0 ma-0"
                            :value="addeditdata.approver?.includes(item._id)" @change="toggleApprover(item._id)"
                            data-testid="tasklist__approver-checkbox"
                          ></v-checkbox>
                      </v-list-item>

                      <v-list-item
                        class="d-flex align-center justify-space-between all-width px-1"
                      >
                        <v-spacer></v-spacer>
                        <v-btn
                          class="black white--text"
                          v-if="addeditdata.approver"
                          @click="
                            addlocationanduserflag = 3;
                            showlocationanduser = true;
                          "
                          data-testid="tasklist__approver-next-btn"
                          ><span>Submit</span></v-btn
                        >
                      </v-list-item>
                    </v-list>
                  </v-menu>
                </div>
              </v-col>
              <v-col
                cols="12"
                v-if="addeditdata.location && addeditdata.task_type === $constants.TASK_LIST_CONSTANTS.TASK_TYPES.ACCOUNT_RECONCILIATION"
                data-testid="tasklist__select-accounts"
              >
                <TaskGLSelection
                  :addeditdata="addeditdata"
                  :addeditdataerror="addeditdataerror"
                  :selectgls.sync="selectgls"
                  :searchcustomfilter.sync="searchcustomfilter"
                  :hideUpdateButton="true"
                  @update:selectgls="selectgls = $event"
                />
              </v-col>
            </v-row>
          </div>
        </template>
        <template v-slot:actions>
          <span class="caption">*Required</span>
          <v-spacer></v-spacer>
          <v-btn color="primary" @click="addEditChecklistItem()" data-testid="tasklist__add-checklist-item-btn">
            <span>Add</span>
          </v-btn>
        </template>
      </lb-drawer>


      <lb-drawer
        v-model="bulklinkbotdialog"
        :heading="`Select an ${$constants.BOT_NAME} to Bulk Link`"
        width="500"
        persistent
        data-testid="tasklist__bulk-link-bot-drawer"
      >
        <template v-slot:body>
          <div class="">
            <p class="mb-1 gray--text">Select {{$constants.BOT_NAME}}*</p>
            <lb-dropdown
              v-model="selectedbot"
              label=""
              :placeholder="`Select Required ${$constants.BOT_NAME} Type`"
              :items="botlist"
              data-testid="tasklist__bulk-link-bot-dropdown"
            ></lb-dropdown>
          </div>
          <div
            class="my-2 mb-4 font-weight-bold text-font-size-md"
            v-if="selectedbot === 'Lease Schedule'"
            data-testid="tasklist__bulk-link-lease-schedule-title"
          >
            Select {{$constants.BOT_NAME}} Result(s):
          </div>
          <div v-for="(task, i) in selectItem" :key="i">
            <div v-if="selectedbot === 'Lease Schedule'" class="mb-3" data-testid="tasklist__bulk-link-lease-schedule-items">
              <v-row class="ma-0 pa-0 my-2">
                  <v-col
                    v-for="(lease, index) in leaseScheduleItems || []"
                    :key="`${lease || 'lease'}-${index}`"
                    cols="3"
                    class="ma-0 pa-0"
                  >
                    <v-checkbox
                      color="caccounting"
                      :label="lease"
                      dense
                      class="d-inline-block ml-2"
                      :value="lease"
                      v-model="leaseSchedulebulkValue[gettaskdetails(task)?._id]"
                      multiple
                      hide-details
                      data-testid="tasklist__bulk-link-lease-schedule-checkbox"
                    ></v-checkbox>
                  </v-col>
              </v-row>
              <v-divider></v-divider>
            </div>
          </div>
        </template>
        <template v-slot:actions>
          <div class="d-flex align-center justify-space-between all-width mt-1">
            <span class="pl-2 d-flex align-center"
              >Need additional bots?
              <v-btn
                text
                color="white"
                class="blue--text shadow-off text-lowercase font-size-xm px-1"
                @click="
                  $nova.gotoLink({
                    path: '/financialclose/functionalsupport/' + metadata._id,
                  })
                "
                data-testid="tasklist__bulk-link-bot-contact-us-btn"
                ><span>Contact us</span></v-btn
              >
            </span>
            <v-btn
              data-testid="tasklist__bulk-link-bot-submit-btn"
              class="white--text radius-mini"
              color="primary"
              @click="bulklinkBot()"
              ><span>Submit</span></v-btn
            >
          </div>
        </template>
      </lb-drawer>

      <lb-drawer
        v-model="bulkactionuserdialog"
        :heading="'Edit ' + bulkActionUserType "
        width="500"
        v-if="bulkActionUserType "
        data-testid="tasklist__bulk-action-user-drawer"
      >
        <template v-slot:body>
          <div class="d-flex align-center">
            <v-chip
              color="lightpurple"
              class="caccounting--text d-flex align-center w-30"
              data-testid="tasklist__bulk-action-user-drawer-ref-chip"
            >
              <v-icon class="mr-2">mdi-information-outline</v-icon>
              <span>{{ selectItem.length }}
              task item selected</span>
            </v-chip>
          </div>
          <p class="mb-1 mt-3 gray--text">Action</p>
          <lb-dropdown
            hidedetails
            label=""
            placeholder="Select action "
            v-model="selectaction"
            :items="bulkActionUserType  === 'Approver' ? itemapprover : itempreparer"
            itemtext="name"
            itemvalue="value"
            class="mt-2"
            width="10"
            @change="actionselection(selectaction, bulkActionUserType )"
            data-testid="tasklist__bulk-action-user-drawer-action-dropdown"
          />
          <lb-dropdown
            hidedetails
            label="select user"
            v-model="bulkactionuserid"
            :items="validActiveUsers"
            itemtext="name"
            itemvalue="_id"
            class="mt-4"
            v-if="selectaction === 'remove' || selectaction === 'replace' || selectaction === 'move'"
            data-testid="tasklist__bulk-action-user-drawer-user-dropdown"
            item-class="noTransform"
          />

           <span class="gray--text" v-if="selectaction === 'associate' || selectaction === 'replace'"
            >Select {{ bulkActionUserType  }}</span
          >
           <lb-dropdown
              hidedetails
              label=""
              v-model="changetouser"
              :items="getAvailableUsers([])"
              itemtext="name"
              itemvalue="_id"
              class="mt-4"
              v-if="selectaction === 'associate' || selectaction === 'replace'"
              data-testid="tasklist__bulk-action-user-drawer-change-to-user-dropdown"
            />

          <p class="gray--text mt-2" v-if="selectaction === 'associate'">
            Selected user will be added to all selected tasks
          </p>

          <p class="gray--text mt-2" v-else-if="selectaction === 'remove'">
            Selected user will be removed to all selected tasks
          </p>

          <p class="gray--text mt-2" v-else-if="selectaction === 'replace'">
            Selected user will be replaced to all selected tasks
          </p>
          <p class="gray--text mt-2" v-else-if="selectaction === 'move'">
            Selected user will be chnaged to preparer to all selected tasks
          </p>
        </template>
        <template v-slot:actions>
          <v-spacer></v-spacer>
          <v-btn
            color="error"
            data-testid="tasklist__bulk-action-user-drawer-remove-btn"
            v-if="selectaction === 'remove'"
            @click="
              bulkManageUser(
                selectaction,
                bulkActionUserType ,
                bulkactionuserid,
                selectItem
              )
            "
            ><span>Remove</span></v-btn
          >
          <v-btn
            color=""
            class="black white--text"
            data-testid="tasklist__bulk-action-user-drawer-associate-btn"
            v-else-if="selectaction === 'associate'"
            @click="
              bulkManageUser(
                selectaction,
                bulkActionUserType ,
                changetouser,
                selectItem
              )
            "
            ><span>Add</span></v-btn
          >
          <v-btn
            color=""
            class="black white--text"
            data-testid="tasklist__bulk-action-user-drawer-replace-btn"
            v-else-if="selectaction === 'replace'"
            @click="
              bulkManageUser(
                selectaction,
                bulkActionUserType ,
                bulkactionuserid,
                selectItem,
                changetouser
              )
            "
            ><span>Replace</span></v-btn
          >
          <v-btn
            color=""
            class="black white--text"
            data-testid="tasklist__bulk-action-user-drawer-move-btn"
            v-else-if="selectaction === 'move'"
            @click="
              bulkManageUser(
                selectaction,
                bulkActionUserType  === 'Preparer' ? 'Approver' : 'Preparer',
                bulkactionuserid,
                selectItem
              )
            "
            ><span>Change</span></v-btn
          >
          <v-btn
            color=""
            class="black white--text"
            data-testid="tasklist__bulk-action-user-drawer-update-btn"
            v-else-if="selectaction === 'update'"
            @click="
              bulkManageUser(
                selectaction,
                bulkActionUserType ,
                bulkactionuserid,
                selectItem
              )
            "
            ><span>Update</span></v-btn
          >
        </template>
      </lb-drawer>

      <BulkUpdateDueDateDrawer
        :visible="bulkduedatedialog"
        :selected-tasks="selectItem"
        :due-date.sync="updatebulkduedate"
        :note.sync="bulkDueDateNote"
        :loading="bulkduedateloading"
        :min-date="dueDateMinDate"
        :max-date="dueDateMaxDate"
        @update:visible="bulkduedatedialog = $event"
        @confirm="bulkduedateFun(selectItem, updatebulkduedate, bulkDueDateNote)"
      />

      <!-- Bulk Edit Threshold Enforcement Drawer -->
      <lb-drawer
        v-model="bulkThresholdDialog"
        heading="Edit Threshold Enforcement"
        width="700"
        v-if="bulkThresholdDialog"
        :loading="bulkThresholdLoading"
        data-testid="tasklist__bulk-threshold-enforcement-drawer"
      >
        <template v-slot:body>
          <!-- Selected Tasks Count Badge (CountSection style) -->
          <div class="d-flex align-center threshold-count-badge mb-3 gap-120" data-testid="tasklist__bulk-threshold-enforcement-count-badge">
            <h6 class="font-weight-medium threshold-count-label">Selected</h6>
            <h3 class="font-weight-medium">{{ selectItem.length }}</h3>
          </div>

                    <!-- Selected Tasks Table -->
          
          <div class="" style="max-height: 50vh; overflow-y: auto;" data-testid="tasklist__bulk-threshold-enforcement-table">
            <v-simple-table dense>
              <template v-slot:default>
                <thead class="tableHeaderBg">
                  <tr>
                    <th class="tableHeaderBg text-left" scope="col" colspan="2">Selected Tasks</th>
                  </tr>
                </thead>
                <tbody>
                  <tr
                    v-for="(task, idx) in selectItem"
                    :key="task._id || idx"
                    data-testid="tasklist__bulk-threshold-enforcement-table-row"
                  >
                    <td>{{ task.ref || '-' }}</td>
                    <td>{{ task.description || '-' }}</td>
                  </tr>
                </tbody>
              </template>
            </v-simple-table>
          </div>

          <!-- Radio button selection -->
          <p class="font-weight-medium mb-2 mt-3">Action to apply</p>
          <v-row no-gutters class="all-width">
              <v-col cols="6" class="pr-2">
                <v-card
                  outlined
                  :class="['enable-disable-radio-card pa-3', bulkSkipValidation === true ? 'enable-disable-radio-card--selected' : '']"
                  @click="bulkSkipValidation = true"
                >
                  <div class="d-flex align-center">
                    <v-icon class="mr-2 flex-shrink-0" :color="bulkSkipValidation === true ? 'primary' : 'grey lighten-1'">
                      {{ bulkSkipValidation === true ? 'mdi-radiobox-marked' : 'mdi-radiobox-blank' }}
                    </v-icon>
                    <div>
                      <p class="font-weight-medium mb-0">Enable Threshold Enforcement</p>
                      <p class="text-caption grey--text mb-0">Re-apply standard validation</p>
                    </div>
                  </div>
                </v-card>
              </v-col>
              <v-col cols="6" class="pl-2">
                <v-card
                  outlined
                  :class="['enable-disable-radio-card pa-3', bulkSkipValidation === false ? 'enable-disable-radio-card--selected' : '']"
                  @click="bulkSkipValidation = false"
                >
                  <div class="d-flex align-center">
                    <v-icon class="mr-2 flex-shrink-0" :color="bulkSkipValidation === false ? 'primary' : 'grey lighten-1'">
                      {{ bulkSkipValidation === false ? 'mdi-radiobox-marked' : 'mdi-radiobox-blank' }}
                    </v-icon>
                    <div>
                      <p class="font-weight-medium mb-0">Disable Threshold Enforcement</p>
                      <p class="text-caption grey--text mb-0">Skip attachment + threshold Validation</p>
                    </div>
                  </div>
                </v-card>
              </v-col>
            </v-row>

          <div class="d-flex align-start ru-info-banner mt-3 pa-3 radius-small">
            <v-icon class="mr-2 flex-shrink-0" color="primary" small>mdi-information-outline</v-icon>
            <span class="">Only <strong>Account Reconciliation</strong> tasks in the <strong>Pending Submission</strong> stage can be updated mid-cycle. Ineligible tasks in your selection — including <strong>Approved</strong>, <strong>Auto Approved</strong>, <strong>Pending Approval</strong>, <strong>Blocked</strong>, and non-reconciliation tasks — will be ignored. This action is audit-logged.</span>
          </div>
        </template>
        <template v-slot:actions>
          <v-spacer></v-spacer>
          <v-btn
            class="secondaryBtn"
            @click="bulkThresholdDialog = false"
            data-testid="tasklist__bulk-threshold-enforcement-cancel-btn"
          >
            <span>Cancel</span>
          </v-btn>
          <v-btn
            color="primary"
            class="ml-2"
            @click="bulkUpdateThresholdEnforcement()"
            data-testid="tasklist__bulk-threshold-enforcement-update-btn"
          >
            <span>Review & Apply</span>
          </v-btn>
        </template>
      </lb-drawer>

      <lb-drawer v-model="helpdeskdialog" heading="New Query" width="600" data-testid="tasklist__helpdesk-drawer">
        <template v-slot:body>
          <div class="d-flex align-center">
            <v-chip label class="caccounting--text lightpurple mr-2"><span>{{
              helpdeskitem.ref
            }}</span></v-chip>

            <div class="font-weight-bold px-1 align-center d-flex">
              <span>{{ helpdeskitem.description || "" }}</span>
            </div>
          </div>

          <div class="my-3">
            <span class="text-font-size-md gray--text my-2"
              >Discribe your request</span
            >
            <div class="text-field">
              <textarea
                class="input all-width border-on pa-2 radius-small"
                rows="4"
                cols="12"
                placeholder="Type the request here"
                v-model="helpdeskitem.__ticketdescripton"
                data-testid="tasklist__helpdesk-description-textarea"
              ></textarea>
            </div>
          </div>

          <span class="my-3 gray--text"
            >If you need Consark's assistance to complete this task or if you
            have any query relating to this tasklist item, you can submit this
            form to connect with our functional experts for quick
            resolution.</span
          >
          <div v-if="helpdeskitemnew">
            <v-btn
              v-if="(helpdeskitem.__existingtickets || []).length > 0"
              text
              data-testid="tasklist__helpdesk-back-to-existing-tickets-btn"
              class="shadow-off mb-2"
              @click="helpdeskitemnew = false"
              ><v-icon class="mr-1">mdi-arrow-left</v-icon><span>Back to existing
              tickets</span></v-btn
            >

            <div class="mt-3">
              <span class="font-weight-bold">Discribe your request</span>
              <div class="text-field">
                <textarea
                  class="input"
                  rows="4"
                  cols="12"
                  placeholder="Type the request here"
                  v-model="helpdeskitem.__ticketdescripton"
                  data-testid="tasklist__helpdesk-description-textarea"
                ></textarea>
              </div>
            </div>
          </div>
        </template>
        <template v-slot:actions>
          <v-spacer></v-spacer>
          <v-btn
            v-if="metadata.stage === 0"
            @click="addHelpdeskQuery()"
            class="white--text black"
            data-testid="tasklist__helpdesk-submit-btn"
            ><span>Submit</span></v-btn
          >
        </template>
      </lb-drawer>

      <lb-drawer
        v-model="linkbotdialog"
        :heading="`Select an ${$constants.BOT_NAME} to link`"
        width="500"
        persistent
        :loading="linkbotloading"
        data-testid="tasklist__link-bot-drawer"
      >
        <template v-slot:body>
          <div class="text-center">
            <div class="d-flex align-center justify-center">
              <lb-dropdown
                v-model="selectedbot"
                :label="`Select ${$constants.BOT_NAME}*`"
                :items="botlist"
                data-testid="tasklist__link-bot-dropdown"
              ></lb-dropdown>
            </div>
          </div>

          <div v-if="selectedbot === 'Lease Schedule'" data-testid="tasklist__link-lease-schedule-section">
            <div class="mt-2 mb-2"><strong>Select {{$constants.BOT_NAME}} Result(s):</strong></div>

            <v-row class="ma-0 pa-0 my-2">
                <v-col
                  v-for="(lease, index) in leaseScheduleItems || []"
                  :key="`${lease || 'lease'}-${index}`"
                  cols="3"
                  class="ma-0 pa-0"
                >
                  <v-checkbox
                    color="cacc"
                    :label="lease"
                    dense
                    class="d-inline-block ml-2"
                    :value="lease"
                    v-model="leaseScheduleValue"
                    multiple
                    hide-details
                    data-testid="tasklist__link-lease-schedule-checkbox"
                  ></v-checkbox>
                </v-col>
            </v-row>
          </div>
          <div v-if="selectedbot === 'Transaction Matching'" data-testid="tasklist__link-transaction-matching-section">
            <div class="d-flex align-center justify-center">
              <lb-dropdown
                v-model="selectedTransactionMatching"
                label="Transaction Matching Analysis*"
                :items="transactionMatchingList"
                itemtext="name"
                itemvalue="_id"
                data-testid="tasklist__link-transaction-matching-dropdown"
              ></lb-dropdown>
            </div>
          </div>
        </template>
        <template v-slot:actions>
          <span class="pl-2 d-flex align-center"
            >Need additional bots?
            <v-btn
              text
              color="white"
              class="blue--text shadow-off text-lowercase font-size-xm px-1"
              @click="
                $nova.gotoLink({
                  path: '/financialclose/functionalsupport/' + metadata._id,
                })
              "
              data-testid="tasklist__link-bot-contact-us-btn"
              ><span>Contact us</span></v-btn
            >
          </span>
          <v-spacer></v-spacer>
          <v-btn class="black white--text" @click="linkBot()" data-testid="tasklist__link-bot-btn" v-if="selectedbot === 'Transaction Matching'" :disabled="!selectedTransactionMatching">Link</v-btn>
          <v-btn class="black white--text" @click="linkBot()" data-testid="tasklist__link-bot-btn" v-else>Link</v-btn>
        </template>
      </lb-drawer>

      <lb-drawer
        v-model="bulkworkpaperupload"
        heading="File Bulk Upload"
        width="500"
        persistent
        data-testid="tasklist__bulk-work-paper-upload-drawer"
      >
        <template v-slot:body>
          <div class="d-flex align-center justify-space-between mb-4">
            <h5>Upload your document</h5>
            <v-btn
              class="secondaryBtn"
              @click="
                $nova.downloadFile(
                  '',
                  {},
                  '/v2/financialclose/analysis/gettasklisttemplateV3' // TODO - update the url
                )
              "
              data-testid="tasklist__bulk-work-paper-download-template-btn"
            >
              <v-icon>mdi-download</v-icon><span> Download Template</span></v-btn
            >
          </div>
          <DragDropfile
            hidedetails
            :files="fileuplaoded"
            @update:files="FilesUpload"
            :resetTrigger="resetFlag"
            data-testid="tasklist__bulk-work-paper-drag-drop-file"
          />
          <p class="gray--text ma-0 mt-3">Remark (optional)</p>
          <lb-textBox
            requriedrows="3"
            :hidedetails="true"
            v-model="fileremark"
            label="Input"
            data-testid="tasklist__bulk-work-paper-remark-textbox"
          />
          <v-container class="pa-0">
            <v-row no-gutters class="">
              <template v-if="(fileNamesList || [])?.length > 0">
                <v-col
                  v-for="(v, k) in fileNamesList"
                  :key="k"
                  cols="4"
                  class="pa-3 border-on radius-small"
                >
                  <v-sheet class="d-flex flex-column">
                    <p class="ma-0 black--text font-size-md mb-3">
                      {{ v.uploadname || v.uploadname || modifiedname }}
                    </p>
                    <p class="font-size-xm">{{ $nova.formatDate(v.date) }}</p>
                    <div class="mt-4">
                      <v-btn
                        @click="$nova.downloadFile(v._id)"
                        class="cursor-pointer radius-mini secondaryBtn"
                        text
                        data-testid="tasklist__bulk-work-paper-download-btn"
                      >
                        <v-icon>mdi-download</v-icon>
                        <span>Download</span>
                      </v-btn>
                      <v-spacer></v-spacer>
                    </div>
                  </v-sheet>
                </v-col>
              </template>
              <v-col
                v-if="viewtaskdata?.remark"
                cols="4"
                class="pa-3 border-on radius-small"
              >
                <p class="ma-0 black--text font-size-md mb-3">Remark</p>
                <p class="font-size-xm">
                  {{ $nova.formatDate("2024-02-23T07:01:03.080Z") }}
                </p>

                <span>{{ viewtaskdata?.remark }}</span>
              </v-col>
            </v-row>
          </v-container>
        </template>
        <template v-slot:actions>
          <v-checkbox
            label="Upload without document"
            hide-details
            class="ma-0"
            v-model="uploadiwithoutfile"
            data-testid="tasklist__bulk-work-paper-upload-without-file-checkbox"
          />
          <v-spacer></v-spacer>
          <v-btn
            data-testid="tasklist__bulk-work-paper-submit-btn"
            v-if="uploadiwithoutfile"
            class="ml-2 white--text"
            color="primary"
            @click="sendForReviewBulk()"
            ><span>Submit</span></v-btn
          >
          <v-btn
            v-else
            data-testid="tasklist__bulk-work-paper-submit-btn"
            class="ml-2 white--text"
            color="primary"
            @click="uploadFilesBulk()"
            ><span>Submit</span></v-btn
          >
        </template>
      </lb-drawer>

      <lb-drawer
        :Maxwidth="uploaddata.length > 0 ? '1665' : '700'"
        v-model="bulkuploadtemplate"
        heading="Bulk Upload"
        :loading="loading"
        data-testid="tasklist__bulk-work-paper-upload-drawer"
      >
        <template v-slot:body>
          <div>
            <div class="d-flex align-center justify-space-between">
              <span class="text-center mb-1" v-if="uploaddata.length === 0"
                >Upload your document</span
              >
              <span v-else>Preview</span>
              <div class="d-flex">
                <v-btn text class="secondaryBtn" v-if="uploaddata.length > 0" @click="clearfile()" data-testid="tasklist__bulk-upload-reupload-btn">
                  <v-icon>mdi-reload</v-icon> <span>Re-Upload</span>
                </v-btn>
                <v-btn
                  data-testid="tasklist__bulk-work-paper-download-template-btn"
                  class="secondaryBtn d-flex align-center mb-1"
                  @click="downloadTemplate()"
                  ><span>Download Template</span></v-btn
                >
              </div>
            </div>
            <div
              class="d-flex align-center justify-space-between"
              v-if="uploaddata.length > 0"
            >
              <v-checkbox
                label="Show only items with error"
                color="caccounting"
                v-model="showdatawitherror"
                data-testid="tasklist__bulk-work-paper-show-error-checkbox"
              >
              </v-checkbox>
              <v-spacer></v-spacer>
            </div>
          </div>
          <div class="d-flex align-center justify-center">
            <DragDropfile
              v-if="uploaddata.length === 0"
              hidedetails
              :files="file"
              @update:files="updateFilesBulk"
              :resetTrigger="resetFlag"
              data-testid="tasklist__bulk-work-paper-drag-drop-file"
            />
          </div>
          <div
            v-if="uploaddata.length > 0"
            class="radius-small border-on simple-table"
            style="max-height: 73vh; overflow: scroll"
            data-testid="tasklist__bulk-upload-preview-table"
          >
            <v-simple-table data-testid="tasklist__bulk-upload-preview-table">
              <template v-slot:default>
                <thead class="tableHeaderBg">
                  <th class="text-center tableHeaderBg" scope="sno">S No.</th>
                  <th class="text-center tableHeaderBg" scope="task_type">
                    Task type
                  </th>
                  <th class="text-center tableHeaderBg" scope="description">
                    Description
                  </th>
                  <th class="text-center tableHeaderBg" scope="category">
                    Category
                  </th>
                  <th class="text-center tableHeaderBg" scope="subcategory">
                    Sub Category
                  </th>
                  <th class="text-center tableHeaderBg" scope="location">
                    Location
                  </th>
                  <th class="text-center tableHeaderBg" scope="assertions">
                    Assertions
                  </th>
                  <th class="text-center tableHeaderBg" scope="purpose">
                    Purpose
                  </th>
                  <th class="text-center tableHeaderBg" scope="instructionHe">
                    Instruction
                  </th>
                  <th class="text-center tableHeaderBg" scope="preparer">
                    Preparer
                  </th>
                  <th class="text-center tableHeaderBg" scope="approver">
                    Approver
                  </th>
                  <th class="text-center tableHeaderBg" scope="tags">Tags</th>
                  <th class="text-center tableHeaderBg" scope="duedays">
                    Due days
                  </th>
                  <th class="text-center tableHeaderBg" scope="glcode">
                    Account No.
                  </th>
                  <th class="text-center tableHeaderBg" scope="priority">
                    Priority
                  </th>
                  <th class="text-center tableHeaderBg" scope="evidences">
                    No of Evidences
                  </th>
                  <!-- add customColumns as headers -->
                  <th
                    v-for="(customColumn, index) in customColumns"
                    :key="index"
                    class="text-center tableHeaderBg"
                    scope="customColumn"
                  >
                    {{ customColumn.dataType === "date" ? `${customColumn.displayText} (dd/mm/yyyy)` : customColumn.displayText }}
                  </th>
                </thead>
                <v-slide-y-transition
                  group
                  tag="tbody"
                  style="overflow: hidden !important"
                >
                  <tr v-for="(row, index) in filteredData" :key="index">
                    <td>{{ index + 1 }}</td>
                    <template v-for="(cell, key) in row">
                      <td
                        v-if="errorsonly[index][key]"
                        :key="`error-${key}`"
                        class="font-size-xm pa-0 border-right-data"
                      >
                        <div
                          class="all-width all-height"
                          style="border: 1px solid #f3b9ba"
                        >
                      <v-tooltip bottom content-class="tooltip-bottom error-tooltip">
                <template v-slot:activator="{ on, attrs }">
                  <div
                    v-if="key === 'assertions' || key === 'location'"
                    class="d-inline-block"
                    v-bind="attrs"
                    v-on="on"
                  >
                    <v-chip
                      v-for="(error, errorKey) in cell"
                      :key="errorKey"
                      label
                      color="error"
                      data-testid="tasklist__error-chip"
                      outlined
                      class="pl-2 mb-1 mr-1 error-chip"
                    >
                      <span class="pl-1">{{ error }}</span>
                    </v-chip>
                  </div>

                  <span class="d-flex align-center error-text" v-else v-bind="attrs" v-on="on" data-testid="tasklist__error-text">
                    <v-icon color="error-text" class="mr-1 ">mdi-information</v-icon>
                    <span class="error-text">{{ errorsonly[index]?.[key] }}</span>
                  </span>
                </template>
                <span>
                  {{ errorsonly[index]?.[key] }}
                </span>
                      </v-tooltip>
                        </div>
                      </td>
                      <td v-else :key="`value-${key}`">
                        <div
                          v-if="key === 'tags' || key === 'location'"
                          class="d-flex align-center"
                        >
                          <v-chip
                            label
                            data-testid="tasklist__tag-chip"
                            outlined
                            class="lightpurple caccounting--text pl-2 mb-1 mr-1"
                          >
                            <span class="pl-1">{{ (cell || [])[0] }}</span>
                          </v-chip>
                          <span
                            v-if="cell?.length > 1"
                            class="border-on px-1 ml-1"
                            >+{{ cell.length - 1 }}</span
                          >
                        </div>
                        <div
                          v-else-if="key === 'approver' || key === 'preparer'"
                        >
                          <v-avatar
                            v-for="(va, ka) in cell"
                            :key="ka"
                            size="24"
                            outlined
                            class="lightpurple caccounting--text mb-1 mr-1"
                            data-testid="tasklist__user-avatar"
                          >
                            <v-tooltip top content-class="tooltip-top">
                              <template v-slot:activator="{ on, attrs }">
                                <span v-bind="attrs" v-on="on">
                                  {{ (va || '')[0] }}
                                </span>
                              </template>
                              <span>{{ va }}</span>
                            </v-tooltip>
                          </v-avatar>
                        </div>
                        <div
                          v-else-if="key === 'assertions'"
                          class="d-flex align-center"
                        >
                          <span v-if="cell?.length >= 1">
                            {{ (cell || [])[0] }}
                          </span>
                          <span
                            v-if="cell?.length > 1"
                            class="border-on px-1 ml-1"
                            >+{{ cell.length - 1 }}</span
                          >
                        </div>
                        <div v-else-if="key === 'glcode'">
                          <div
                            v-for="(va, ka) in cell"
                            :key="ka"
                           
                            outlined
                            class="pl-2 mb-1 mr-1"
                          >
                            <span class="pl-1">{{ va }}</span>
                          </div>
                        </div>
                        <div v-else-if="key === 'priority'">
                          {{ cell }}
                          <!-- <div v-for="(va, ka) in cell" :key="ka" outlined class="pl-2 mb-1 mr-1">
                          <span class="pl-1">{{ va}}</span>
                      </div> -->
                        </div>
                        <div v-else class="two-line-clamp">{{ cell }}</div>
                      </td>
                    </template>
                  </tr>
                </v-slide-y-transition>
              </template>
            </v-simple-table>
          </div>
          <p v-if="checkListErrorResponse" class="error--text ma-0 pa-0 mt-4 font-size-xm">
            *{{ checkListErrorResponse }}
          </p>
          <p v-if="flag" class="error--text ma-0 pa-0 mt-4 font-size-xm">
            *These are fields where errors exist / information missing. Please
            rectify and re-upload to continue. (Preparer & Approver cannot be
            the same user)
          </p>
        </template>
        <template v-slot:actions>
          <v-spacer></v-spacer>
          <div v-if="uploaddata.length > 0">
            <v-btn
              data-testid="tasklist__bulk-upload-submit-btn"
              class="ml-2 white--text"
              color="primary"
              v-if="!flag"
              @click="uploadData()"
              ><span>Upload</span></v-btn
            >
            <v-btn class="" @click="cleardata()" data-testid="tasklist__bulk-upload-cancel-btn"><span>Cancel</span></v-btn>
          </div>
        </template>
      </lb-drawer>

      <TaskStatusReportDialog
        v-model="taskdeTailsDialog"
        :statusDetails="statusDetails"
        :userType="userType"
        data-testid="tasklist__all-task-status-report-dialog"
      />

      <lb-dialog
        v-model="emailpopdia"
        heading="Email Notifications"
        width="1000"
        :loading="emailpopdialoading"
        data-testid="tasklist__email-notifications-dialog"
      >
        <template v-slot:body>
          <div class="d-flex justifySpaceBetween boldText" data-testid="tasklist__email-notifications-header">
            <div v-if="isCycleInActive">
              New notifications cannot be created or modified as the current
              cycle is closed.
            </div>
            <v-spacer v-else></v-spacer>
            <v-btn
              color="primary"
              :disabled="isCycleInActive"
              @click="addeditemailFun()"
              data-testid="tasklist__email-notifications-add-btn"
              ><span>Add</span></v-btn
            >
          </div>
          <div>
            <v-simple-table
              class="pbc-view-table mt-2"
              dense
              v-if="emaildata.length > 0"
              data-testid="tasklist__email-notifications-table"
            >
              <thead class="tableHeaderBg">
                <tr>
                  <th scope="#" class="">#</th>
                  <th scope="columns">Category</th>
                  <th scope="columns">Email To</th>
                  <th scope="columns">Location</th>
                  <th scope="columns">Priority</th>
                  <th scope="columns">Created At</th>
                  <th scope="Action" class="text-center">Action</th>
                </tr>
              </thead>
              <tbody>
                  <tr v-for="(v, k) in emaildata" :key="k">
                    <td>
                      <span>{{ k + 1 }}</span>
                    </td>
                    <td>
                      <div class="d-flex flex-wrap">
                        <template v-if="Array.isArray(v.meta.category)">
                          <v-chip
                            v-for="(category, index) in v.meta.category.slice(0, 5)"
                            :key="index"
                            label
                           
                            class="ma-1"
                          >
                            <span>{{ category }}</span>
                          </v-chip>
                          <v-tooltip
                            top
                            content-class="tooltip-top"
                            v-if="v.meta.category.length > 5"
                          >
                            <template v-slot:activator="{ on }">
                              <v-chip
                                v-on="on"
                                label
                                data-testid="tasklist__email-notifications-category-chip"
                                class="ma-1"
                              >
                                <span>+{{ v.meta.category.length - 5 }}</span>
                              </v-chip>
                            </template>
                            <div style="max-width: 400px; white-space: normal; text-align: left;" data-testid="tasklist__email-notifications-category-tooltip">
                              {{ v.meta.category.slice(5).join(", ") }}
                            </div>
                          </v-tooltip>
                        </template>
                        <v-chip
                          v-else-if="v.meta.category"
                          label
                          data-testid="tasklist__email-notifications-category-chip-single"
                          class="ma-1"
                        >
                          <span>{{ v.meta.category }}</span>
                        </v-chip>
                      </div>
                    </td>
                    <td class="justify-center">
                      <div class="d-flex">
                        <div class="d-flex userChip">
                          <v-chip class="userBg" label  v-if="v.meta.toUsers.length > 0" data-testid="tasklist__email-notifications-to-user-chip">
                            <span>{{ v.meta.toUsers[0] }}</span>
                          </v-chip>
                          <v-tooltip
                            top
                            content-class="tooltip-top"
                            v-if="v.meta.toUsers.length > 1"
                          >
                            <template v-slot:activator="{ on }">
                              <v-avatar
                                v-on="on"
                                size="25"
                                color="lime lighten-1"
                                class="align-center"
                                data-testid="tasklist__email-notifications-to-user-more-avatar"
                              >
                                <v-icon color="white">mdi-plus</v-icon>
                              </v-avatar>
                            </template>
                            <div
                              class=""
                              v-for="(email, index) in v.meta.toUsers"
                              :key="index"
                            >
                              <span>{{ email }}</span>
                            </div>
                          </v-tooltip>
                        </div>
                      </div>
                    </td>
                    <td class="locationChip">
                      <div class="d-flex flex-wrap">
                        <template v-if="getLocationName(v.meta.location_key).length > 0">
                          <v-chip
                            v-for="(item, index) in getLocationName(v.meta.location_key).slice(0, 5)"
                            :key="index"
                            label
                            data-testid="tasklist__email-notifications-location-chip"
                            class="ma-1 locationBg"
                          >
                            <span>{{ item }}</span>
                          </v-chip>
                          <v-tooltip
                            top
                            content-class="tooltip-top"
                            v-if="getLocationName(v.meta.location_key).length > 5"
                          >
                            <template v-slot:activator="{ on }">
                              <v-chip
                                v-on="on"
                                label
                                data-testid="tasklist__email-notifications-location-chip-more"
                                class="ma-1 locationBg"
                              >
                                <span>+{{ getLocationName(v.meta.location_key).length - 5 }}</span>
                              </v-chip>
                            </template>
                            <div style="max-width: 300px; white-space: normal; text-align: left;">
                              {{ getLocationName(v.meta.location_key).slice(5).join(", ") }}
                            </div>
                          </v-tooltip>
                        </template>
                      </div>
                    </td>
                    <td>
                      <span>
                        <v-chip label style="background: rgb(159 224 195);" v-if="v.meta.toUsers.length > 0" data-testid="tasklist__email-notifications-priority-chip">
                          <span>{{ v.priority || v.meta?.priority }}</span>
                        </v-chip>
                      </span>
                    </td>
                    <td>
                      <span>{{ $nova.formatDate(v.created_at) }}</span>
                    </td>
                    <td class="">
                      <div class="d-flex text-center">
                        <v-tooltip
                       bottom
                        content-class="tooltip-bottom"
                        v-if="v.flag"
                      >
                        <template v-slot:activator="{ on, attrs }">
                          <v-btn
                            icon
                            data-testid="tasklist__email-notifications-enable-btn"
                            v-bind="attrs"
                            v-on="on"
                            color="success"
                            :disabled="isCycleInActive"
                            @click="enableDisableemails(v, 'disabled')"
                          >
                            <v-icon>mdi-check</v-icon>
                          </v-btn>
                        </template>
                        Disable
                      </v-tooltip>
                      <v-tooltip bottom content-class="tooltip-bottom" v-else>
                        <template v-slot:activator="{ on, attrs }">
                          <v-btn
                            icon
                            data-testid="tasklist__email-notifications-disable-btn"
                            v-bind="attrs"
                            v-on="on"
                            color="error"
                            :disabled="isCycleInActive"
                            @click="enableDisableemails(v, 'enabled')"
                          >
                            <v-icon>mdi-close-circle</v-icon>
                          </v-btn>
                        </template>
                        Enable
                      </v-tooltip>
                      <v-tooltip
                        bottom
                        content-class="tooltip-bottom"
                      >
                        <template v-slot:activator="{ on, attrs }">
                          <v-btn
                            icon
                            data-testid="tasklist__email-notifications-edit-btn"
                            v-bind="attrs"
                            v-on="on"
                            :disabled="isCycleInActive"
                            @click="editemails(v)"
                          >
                            <v-icon>mdi-pencil</v-icon>
                          </v-btn>
                        </template>
                        Edit
                      </v-tooltip>
                       <activity-log 
                        :resource-id="v._id" 
                        data-testid="financialclose-project-users__activitylog"
                        row-description="Email Notifications"
                      />
                      </div>
                    </td>
                  </tr>
              </tbody>
            </v-simple-table>
            <div v-else class="text-center grey--text title pa-6">
              No data available
            </div>
          </div>
        </template>
      </lb-dialog>

      <v-dialog v-model="addeditemail" max-width="800" persistent data-testid="tasklist__email-notifications-add-edit-dialog">
        <v-card
          :loading="addeditemailloading"
          :disabled="addeditemailloading"
          loader-height="2"
          class=""
        >
          <v-card-text
            class="tableHeaderBg d-flex align-center py-2 px-4"
          >
            <p class="font-size-md " v-if="emaildetils._id"
              >Update Email Notification</p
            >
            <p class="font-size-md " v-else
              >Add Email Notification</p
            >
            <v-spacer></v-spacer>
            <v-btn icon @click="addeditemail = false; resetEmailErrors()" class="ml-2 " data-testid="tasklist__email-notifications-add-edit-close-btn">
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </v-card-text>
          <v-card-text class="mt-4 pt-4" data-testid="tasklist__email-notifications-add-edit-form">
            <v-row>
              <v-col cols="6" class="my-0 py-1">
                <lb-date
                  v-model="emaildetils.startDate"
                  label="Start Date*"
                  :min="$nova.formatDateISO(new Date())"
                  :error="emaildetilsErrors.startDate ? [emaildetilsErrors.startDate] : []"
                  @change="emaildetilsErrors.startDate = ''"
                  data-testid="tasklist__email-notifications-start-date-input"
                />
              </v-col>
              <v-col cols="6" class="my-0 py-1">
                <lb-date
                  v-model="emaildetils.endDate"
                  label="End Date*"
                  :min="emaildetils.startDate"
                  :error="emaildetilsErrors.endDate ? [emaildetilsErrors.endDate] : []"
                  @change="emaildetilsErrors.endDate = ''"
                  data-testid="tasklist__email-notifications-end-date-input"
                />
              </v-col>
              <v-col cols="12" class="my-0 py-1">
                <lb-dropdown
                  label="Category*"
                  multiple
                  v-model="emaildetils.category"
                  :items="selectAllCategories"
                  itemtext="name"
                  itemvalue="id"
                  @change="(val) => { handleCategoryChange(val); emaildetilsErrors.category = ''; }"
                  :error="emaildetilsErrors.category ? [emaildetilsErrors.category] : []"
                  data-testid="tasklist__email-notifications-category-input"
                />
              </v-col>
              <v-col cols="12" class="my-0 py-1">
                <lb-tagsInput
                  tagcolor="purpleborder"
                  :multiple="true"
                  v-model="emaildetils.emails"
                  :multiplechips="true"
                  label="Email Address*"
                  outline
                  :error="invalidEmails.length > 0 ? invalidEmails : (emaildetilsErrors.emails ? [emaildetilsErrors.emails] : [])"
                  @input="emaildetilsErrors.emails = ''"
                  data-testid="tasklist__email-notifications-email-address-input"
                />
              </v-col>
              <v-col cols="12" class="my-0 py-1">
                <lb-string
                  label="Email Subject*"
                  v-model="emaildetils.subject"
                  :error="emaildetilsErrors.subject ? [emaildetilsErrors.subject] : []"
                  @input="emaildetilsErrors.subject = ''"
                  data-testid="tasklist__email-notifications-email-subject-input"
                />
              </v-col>
              <v-col cols="12" class="my-0 py-1">
                <lb-textarea
                  label="Email Body*"
                  v-model="emaildetils.mailBody"
                  :error="emaildetilsErrors.mailBody ? [emaildetilsErrors.mailBody] : []"
                  @input="emaildetilsErrors.mailBody = ''"
                  data-testid="tasklist__email-notifications-email-body-input"
                />
              </v-col>
              <v-col cols="6" class="my-0 py-1">
                <lb-dropdown
                  label="Location*"
                  v-model="emaildetils.locations"
                  :items="dropdownLocations"
                  multiple
                  itemtext="name"
                  itemvalue="_id"
                  @change="(val) => { handleLocationChange(val); emaildetilsErrors.locations = ''; }"
                  :error="emaildetilsErrors.locations ? [emaildetilsErrors.locations] : []"
                  data-testid="tasklist__email-notifications-location-input"
                />
              </v-col>
              <v-col cols="6" class="my-0 py-1">
                <lb-dropdown
                  label="Hour*"
                  v-model="emaildetils.time"
                  :items="timeList"
                  @change="(val) => { generateTimeMultiples(val); emaildetilsErrors.time = ''; }"
                  :error="emaildetilsErrors.time ? [emaildetilsErrors.time] : []"
                  data-testid="tasklist__email-notifications-hour-input"
                />
              </v-col>
              <v-col cols="12" class="pt-0" v-if="timeMultiples.length">
                <p class="ma-0">Next 5 Triggers</p>
                <ul class="d-flex flex-wrap" style="list-style: none; padding-left: 0;" data-testid="tasklist__email-notifications-next-5-triggers-list">
                  <li class="me-4" v-for="(time, index) in timeMultiples" :key="index" data-testid="tasklist__email-notifications-next-5-triggers-item">
                    {{ time }}
                  </li>
                </ul>
              </v-col>
              <v-col cols="6" class="my-0 py-1">
                <lb-dropdown
                  label="SLA*"
                  v-model="emaildetils.sla"
                  :items="slalist"
                  itemtext="name"
                  itemvalue="id"
                  :error="emaildetilsErrors.sla ? [emaildetilsErrors.sla] : []"
                  @change="emaildetilsErrors.sla = ''"
                  data-testid="tasklist__email-notifications-sla-input"
                />
              </v-col>
              <v-col cols="6" class="my-0 py-1">
                <lb-dropdown
                  label="Priority"
                  v-model="emaildetils.priority"
                  :items="priorityList"
                  itemtext="name"
                  itemvalue="id"
                  :disabled="true"
                  data-testid="tasklist__email-notifications-priority-input"
                />
              </v-col>
            </v-row>
            <div class="error--text" data-testid="tasklist__email-notifications-invalid-emails-error">
              {{ notificationMessages.SCHEDULE_UPDATE_NOTICE }}
            </div>
          </v-card-text>
          <v-card-text class="d-flex">
            <v-spacer></v-spacer>

            <v-btn
              data-testid="tasklist__email-notifications-submit-btn"
              color="primary"
              v-if="emaildetils._id"
              @click="updateemails()"
              ><span>Update</span></v-btn
            >
            <v-btn
              data-testid="tasklist__email-notifications-create-btn"
              color="primary"
              v-else
              @click="addemails()"
              ><span>Create</span></v-btn
            >
          </v-card-text>
        </v-card>
      </v-dialog>

      <lb-drawer
        :Maxwidth="bulkEditFileDataList.length > 0 ? '1665' : '700'"
        v-model="bulkEditDialog"
        heading="Bulk Tasklist Edit"
        :loading="bulkEditDialogloading"
        data-testid="tasklist__bulk-tasklist-edit-drawer"
      >
        <template v-slot:body>
          <div class="d-flex flex-column" style="height: 100%; overflow: hidden;">
            <div style="flex-shrink: 0;">
              <div class="d-flex align-center justify-space-between py-1">
                <span v-if="bulkEditFileDataList.length === 0">Upload your document</span>
                <span v-else>Preview</span>
                <div class="d-flex gap-2">
                  <v-btn text class="secondaryBtn" v-if="bulkEditFileDataList.length > 0" @click="clearfileBulk()" data-testid="tasklist__bulk-tasklist-edit-reupload-btn">
                    <v-icon>mdi-reload</v-icon> <span>Re-Upload</span>
                  </v-btn>
                  <v-btn
                    class="secondaryBtn d-flex align-center"
                    @click="downloadExcelTasklist(selectItem)"
                    data-testid="tasklist__bulk-tasklist-edit-download-template-btn"
                    ><span>Download Template</span></v-btn
                  >
                </div>
              </div>
              <div
                class="d-flex align-center"
                v-if="bulkEditFileDataList.length > 0 && bulkEditFileDataerror"
                data-testid="tasklist__bulk-tasklist-edit-error-filter-section"
              >
                <v-checkbox
                  color="caccounting"
                  v-model="showdatawitherrorEditBulk"
                  hide-details
                  class="mt-0 pt-0"
                  data-testid="tasklist__bulk-tasklist-edit-show-errors-checkbox"
                >
                  <template v-slot:label>
                    <span>Show only items with errors</span>
                  </template>
                </v-checkbox>
              </div>
            </div>
            <div class="d-flex align-center justify-center" v-if="bulkEditFileDataList.length === 0">
              <DragDropfile
                hidedetails
                :files="bulkEditFileDataFile"
                @update:files="readBulkEditFile"
                :resetTrigger="resetbulkEditFile"
                data-testid="tasklist__bulk-tasklist-edit-drag-drop-file-component"
              />
            </div>
            <div
              v-if="bulkEditFileDataList.length > 0"
              class="radius-small border-on simple-table"
              style="flex: 1; min-height: 0; overflow-x: auto; overflow-y: hidden; display: flex; flex-direction: column;"
              data-testid="tasklist__bulk-tasklist-edit-preview-table-container"
            >
              <div style="flex: 1; min-height: 0; overflow-y: auto;">
              <v-simple-table data-testid="tasklist__bulk-tasklist-edit-preview-table">
                <template v-slot:default>
                  <thead class="tableHeaderBg">
                    <tr>
                      <th
                        v-for="header in bulkEditTableHeaders"
                        :key="header.value"
                        class="text-center tableHeaderBg"
                      >
                        {{ header.text }}
                      </th>
                    </tr>
                  </thead>

                  <v-slide-y-transition group tag="tbody">
                    <tr
                      v-for="(row, index) in filteredDataEditBluk"
                      :key="'row-' + index"
                    >
                      <td
                        v-for="header in bulkEditTableHeaders"
                        :key="'col-' + header.value + '-' + index"
                      >
                        <!-- Enhanced Error Tooltip -->
                        <div
                          v-if="errorsonlyEditBulk[index] && errorsonlyEditBulk[index][header.value]"
                          class="text-error pa-1"
                          style=""
                        >
                          <v-tooltip top color="error" max-width="300">
                            <template v-slot:activator="{ on, attrs }">
                              <span 
                                v-bind="attrs" 
                                v-on="on"
                                class="d-inline-flex align-center"
                              >
                                <v-icon color="error" class="mr-1">mdi-alert-circle</v-icon>
                                <span class="error--text font-weight-medium">
                                  {{ errorsonlyEditBulk[index][header.value] }}
                                </span>
                              </span>
                            </template>
                            <span class="d-flex align-center">
                              <v-icon color="white" class="mr-1">mdi-information</v-icon>
                              <span>{{ errorsonlyEditBulk[index][header.value] }}</span>
                            </span>
                          </v-tooltip>
                        </div>

                        <!-- Enhanced Tags Display -->
                        <div
                          v-else-if="['tags','linkedgl'].includes(header.value) && Array.isArray(row[header.value])"
                          class="d-flex flex-wrap"
                        >
                          <v-tooltip top v-for="(item, i) in row[header.value]" :key="'tag-' + i">
                            <template v-slot:activator="{ on, attrs }">
                              <v-chip
                                v-bind="attrs"
                                v-on="on"
                                class="mr-1 mb-1"
                                data-testid="tasklist__bulk-tasklist-edit-preview-table-chip"
                                outlined
                                :color="header.value === 'tags' ? 'primary' : 'blue'"
                                label
                              >
                              <v-icon left>
                                  {{ header.value === 'tags' ? 'mdi-tag' : 'mdi-file-link' }}
                                </v-icon>
                                <span>{{ item }}</span>
                              </v-chip>
                            </template>
                            <span>{{header.value === 'tags' ? 'Tag' : 'Linked GL'}} :{{item}}</span>
                          </v-tooltip>
                        </div>

                        <!-- Enhanced User Display (Preparer/Approver) -->
                        <div
                          v-else-if="['preparer', 'approver'].includes(header.value)"
                          class="d-flex flex-wrap"
                        >
                          <v-tooltip top v-for="(name, i) in getNamesByIds(row[header.value])" :key="'name-' + i">
                            <template v-slot:activator="{ on, attrs }">
                              <v-chip
                                v-bind="attrs"
                                v-on="on"
                                data-testid="tasklist__bulk-tasklist-edit-preview-table-chip"
                                outlined
                                :color="header.value === 'preparer' ? 'teal' : 'indigo'"
                                class="mr-1 mb-1"
                                label
                              >
                                <v-icon left>
                                  {{ header.value === 'preparer' ? 'mdi-account-edit' : 'mdi-account-check' }}
                                </v-icon>
                                <span>{{ name }}</span>
                              </v-chip>
                            </template>
                            <span>{{ header.value === 'preparer' ? 'Preparer' : 'Approver' }}: {{ name }}</span>
                          </v-tooltip>
                        </div>

                        <!-- Enhanced Location Display -->
                        <div
                          v-else-if="['location'].includes(header.value)"
                          class="d-flex flex-wrap"
                        >
                          <v-tooltip top>
                            <template v-slot:activator="{ on, attrs }">
                              <v-chip
                                v-bind="attrs"
                                v-on="on"
                                data-testid="tasklist__bulk-tasklist-edit-preview-table-chip"
                                outlined
                                color="deep-purple"
                                class="mr-1 mb-1"
                                label
                              >
                                <v-icon left>mdi-map-marker</v-icon>
                                <span>{{ getLocationById(row[header.value]) }}</span>
                              </v-chip>
                            </template>
                            <span>Location: <span>{{ getLocationById(row[header.value]) }}</span></span>
                          </v-tooltip>
                        </div>
                        <div v-else-if="['task_type'].includes(header.value)">
                          <span v-if="row[header.value] === LEGACY_TASK_TYPE_LABEL_CHECKLIST_NAME">
                          {{LEGACY_TASK_TYPE_LABEL_CHECKLIST}} Task
                          </span>
                          <span v-else>
                            {{ row[header.value]}}
                          </span>
                        </div> 

                        <!-- Regular Text Display -->
                        <div v-else class="two-line-clamp">
                          {{ row[header.value] }}
                        </div>
                      </td>
                    </tr>
                  </v-slide-y-transition>
                </template>
              </v-simple-table>
              </div>
            </div>
            <div v-if="bulkEditErrorResponse && bulkEditErrorResponse.length" class="mt-1" style="flex-shrink: 0;">
              <div v-for="(err, idx) in bulkEditErrorResponse" :key="idx" class="error--text font-size-xm">
                {{idx+1}}.{{ err }}
              </div>
            </div>
            <p v-if="bulkEditFileDataerror" class="error--text ma-0 pa-0 mt-2 font-size-xm" style="flex-shrink: 0;">
              *These are fields where errors exist / information missing. Please
              rectify and re-upload to continue. (Preparer & Approver cannot be
              the same user)
            </p>
          </div>
        </template>
        <template v-slot:actions v-if="!bulkEditFileDataerror">
          <v-spacer></v-spacer>
          <div v-if="bulkEditFileDataList.length > 0">
            <v-btn
              data-testid="tasklist__bulk-tasklist-edit-upload-btn"
              class="ml-2 white--text"
              color="primary"
              v-if="!flag"
              @click="uploadDataBulk()"
              ><span>Upload</span></v-btn
            >
            <v-btn class="" @click="cleardataBulkEdit()" data-testid="tasklist__bulk-tasklist-edit-cancel-btn"><span>Cancel</span></v-btn>
          </div>
        </template>
      </lb-drawer>

      <!-- Single Upload Modal using shared TaskUploadModal component -->
      <TaskUploadModal
        :key="'single-' + singleUploadSession"
        v-model="showUploadDrawer"
        :modelValue="showUploadDrawer"
        @update:modelValue="showUploadDrawer = $event"
        :id="id?.length ? id : (metadata?._id || 'dummy')"
        :task="addeditdata && Object.keys(addeditdata).length ? addeditdata : {}"
        :filesOnly="false"
        @refresh="refreshData()"
        data-testid="tasklist__upload-modal"
      />

      <!-- Bulk Upload Modal using shared TaskUploadModal component -->
      <TaskUploadModal
        :key="'bulk-' + bulkUploadSession"
        v-model="sendforreviewdrawer"
        :modelValue="sendforreviewdrawer"
        @update:modelValue="sendforreviewdrawer = $event"
        :id="id?.length ? id : (metadata?._id || 'dummy')"
        :task="{ project: id }"
        :bulkworkpaper="true"
        :selectedTasks="selectItem"
        :filesOnly="false"
        @clear-selected="selectItem = []"
        @refresh="refreshData()"
        data-testid="tasklist__bulk-upload-modal"
      />
      <!-- Pagination — list view only; Horizon uses full checklist grid without paging -->
      <Pagination
        v-if="!isHorizonView"
        :list="filterbysearch"
        :itemsperpage="itemsPerPage"
        @paginated-data="setPaginatedData"
        data-testid="tasklist__pagination"
      />
  </div>
</template>

<script>
import { mapState } from 'vuex';
import BulkUploadChecklistV2 from '../../components/BulkUploadChecklistV2/BulkUploadChecklistV2.vue';
import DragDropfile from "../../../../views/Inputs/DragDropfile.vue";
import TaskUploadModal from "../Project/components/TaskUploadModal.vue";
import TaskStatusReportDialog from "../Project/components/TaskStatusReportDialog.vue";
import Pagination from "../../components/Pagination/Pagination.vue";
// import FilterMenu from "../Components/FilterMenu.vue";
// import TaskDetailModal from './TaskDetails/TaskDetailModal.vue';
import TaskStageTabs from "../../components/TaskStageTabs/TaskStageTabs.vue";
import TaskbarToolbar from "../../components/TaskbarToolbar/TaskbarToolbar.vue";
import RoleSwitcher from "../../components/RoleSwitcher/RoleSwitcher.vue";
import BulkUpdateDueDateDrawer from "../../components/BulkUpdateDueDateDrawer/BulkUpdateDueDateDrawer.vue";
import HorizonLanding from "./Horizon/HorizonLanding.vue";
import { HORIZON_VIEWS } from "../../utils/horizonConstants";
import ActivityLog from "../../components/ActivityLog/ActivityLog.vue";
import TaskGLSelection from "../Project/components/TaskGLSelection.vue";
import { attachInactiveLabel, parseUrlQueryFilters, openTaskDetailPage } from "../../utils/tasklistUtils";
import { formatCustomColumns, identifyPossibleTaskTypes, formatDateToDMY, validateDueDateRange, handleCustomColumnHeadersUtil, getTaskTypeDisplay, getTaskTypeOptions, checkForNotNull, calculateScheduleAmount, calculateExplainedDifference, calculateUnexplainedDifference, extractFileIdsFromTask, hasDownloadableFiles, getStageDisplay, isTaskBotLinked } from "../../utils/utils";
import { getTasklistTableHeaders, EMAIL_NOTIFICATION, CRON, TASK_TABS, TASK_STAGES, CYCLE_MESSAGES , ACTION_STAGE, ERROR_KEYS_CYCLE_TASKLIST,LEGACY_TASK_TYPE_LABEL_CHECKLIST_NAME,LEGACY_TASK_TYPE_LABEL_CHECKLIST, TABLE_OFFSET_SMALL_SCREEN, TABLE_OFFSET_LARGE_SCREEN, LARGE_SCREEN_HEIGHT_THRESHOLD, MAX_DUE_DATE_DAYS, ACTIVITY_LOG_TYPES, USER_TYPE_HEADER_VISIBILITY } from '../../utils/constants';
let styledxlsx = require("sheetjs-style");
export default {
  name: "financialclose_project_checklist",
  // Expose constant for template interpolation via $options
  MAX_DUE_DATE_DAYS,
  ACTIVITY_LOG_TYPES,
  data: function () {
    return {
      // Flag to track if component is still active (prevents API calls during/after navigation away)
      isComponentActive: true,
      // Track if table has active filters (for external clear button)
      hasActiveTableFilter: false,
      showUploadDrawer: false,
      singleUploadSession: 0,
      bulkUploadSession: 0,
      // Track window height for responsive table sizing
      windowHeight: typeof window !== 'undefined' ? window.innerHeight : 800,
      // Number of left sticky columns (default 3)
      stickyColumnCount: 3,
      // Store notification messages for access in component
      notificationMessages: EMAIL_NOTIFICATION.MESSAGES,
      right: "financialclose_analysis",
      page_name: "financialclose_project_checklist",
      custom_layout_success: false,
      columnOrderChanged: false,
      metadata: {},
      loading: false,
      viewMode: false,
      viewModeToggleReady: false,
      bulkDueDateNote: '',
      tbjson: {},
      pbcdata: {},
      pbc: [],
      alltaskassigned: true,
      possibleAssertions: this.$constants.TASK_LIST_CONSTANTS.ASSERTIONS,
      botlist: this.$constants.TASK_LIST_CONSTANTS.BOT_LIST,
      leaseScheduleItems: this.$constants.TASK_LIST_CONSTANTS.LEASE_SCHEDULE_ITEMS,
      // Make constant available to template
      LEGACY_TASK_TYPE_LABEL_CHECKLIST_NAME,
      LEGACY_TASK_TYPE_LABEL_CHECKLIST,
      localCustomColumns: [],
      configureColumns: [
        "Priority",
        "Category",
        "Sub Category",
        "Preparer",
        "Approver",
        "Linked GL(s)",
        "Information requests",
        "Purpose",
        "Instruction",
        "Location",
      ],
      tableHeaders: [
        {
          text: "Ref",
          value: "ref",
          visible: true,
          filterable: true,
          sortable: true,
        },
        {
          text: "Task type",
          value: "task_type",
          visible: true,
          filterable: true,
          sortable: true,
        },
        {
          text: "Task description",
          value: "description",
          visible: true,
          filterable: true,
          sortable: true,
        },
        {
          text: "Status",
          value: "stage",
          visible: true,
          filterable: false,
          sortable: false,
        },
        {
          text: "Action",
          value: "upload",
          visible: true,
          filterable: false,
          sortable: false,
        },
        {
          text: "Due days",
          value: "duedate",
          visible: true,
          filterable: false,
          sortable: false,
        },
        {
          text: "TB amount",
          value: "__tbtotals",
          visible: true,
          filterable: false,
          sortable: false,
          classHeader: "noTransform",
        },
        {
          text: "Recon amount",
          value: "scheduleAmount",
          visible: true,
          filterable: false,
          sortable: false,
        },
        {
          text: "Explained difference",
          value: "explainedDifference",
          visible: true,
          filterable: false,
          sortable: false,
        },
        {
          text: "Unexplained difference",
          value: "difference",
          visible: true,
          filterable: false,
          sortable: false,
        },
        {
          text: "Category",
          value: "category",
          visible: true,
          filterable: true,
          sortable: true,
        },
        {
          text: "Sub category",
          value: "subcategory",
          visible: true,
          filterable: true,
          sortable: true,
        },
        {
          text: this.$store.state.LocationHeader || "Location",
          value: "location",
          visible: true,
          filterable: false,
          sortable: false,
        },
        {
          text: "Priority",
          value: "priority",
          visible: true,
          filterable: true,
          sortable: true,
        },
        {
          text: "Tags",
          value: "tags",
          visible: true,
          filterable: false,
          sortable: false,
        },
        {
          text: "No. of Evidences",
          value: "no_of_evidence",
          visible: true,
          filterable: false,
          sortable: false,
        },
        {
          text: "Created on",
          value: "created_at",
          visible: true,
          filterable: true,
          sortable: true,
        },
        {
          text: "Preparer",
          value: "preparer",
          visible: true,
          filterable: false,
          sortable: false,
        },
        {
          text: "Approver",
          value: "approver",
          visible: true,
          filterable: false,
          sortable: false,
        },

        // {
        //     text: 'Due date',
        //     value: 'duedate',
        //     visible: true,
        //     filterable: true,
        //     sortable: true,
        // },
        {
          text: "Information request",
          value: "inforrequest",
          visible: true,
          filterable: false,
          sortable: false,
        },
        {
          text: "Action",
          value: "action",
          visible: true,
          filterable: false,
          sortable: false,
        },
      ],
      tableHeadersfilter: getTasklistTableHeaders(this.$store.state.LocationHeader || "Location"),
      selectedRows: [],
      checklist: [],
      id: "",
      userid: "",
      clientId: "",
      formatedChecklist: [],
      allRowsSelected: false,
      // viewtaskdailog: false,
      viewtaskdata: [],
      search: "",
      menuOpen: false,
      OpenBulkUpload: false,
      fileNamesList: [],
      userType: this.$store?.state?.tasklistUserType,
      searchcolumn: "",
      itemsPerPage: 50,
      selectItem: [],
      paginatedFilteredItems: [],
      tasklistDataCopy: [],
      showMore: false,
      tabify: 0,
      tblinkdialogitems: [],
      addeditdialog: false,
      taskTypes: getTaskTypeOptions(),
      addeditdata: {
        description: '',
        category: '',
        subcategory: '',
        task_type: '',
        priority: '',
        location: '',
        preparer: [],
        approver: [],
        no_of_evidence: 0,
        tags: [],
        assertions: [],
        purpose: '',
        instruction: '',
        remark: '',
        glcode: [],
        __tbtotals: { items: [] },
        customfields: [],
        threshold: '',
      },
      addeditdataerror: {},
      formdata: {},
      addeditloading: false,
      selectedTabStage: null,
      taskTabs: TASK_TABS,
      categoryAcc: [],
      subcategoryAcc: [],
      coaCategoryAcc: [],
      coaSubcategoryAcc: [],
      priorityList: this.$constants.TASK_LIST_CONSTANTS.PRIORITY_LIST,
      Alltags: [],
      toDoTaskOnly: false,
      overDueDate: false,
      taskMasterCustomColumns: [],
      summaryData: {},
      cycleType:"FBC",
      bulkactions: 0,
      bulkselectedlocations: [],
      showSearch: false,
      searchQuery: "",
      conversationList: [],
      queryMsg: "",
      sendforreviewdrawer: false,
      fileuplaoded: null,
      fileremark: "",
      uploadiwithoutfile: false,
      addlocationanduserflag: 0,
      showlocationanduser: false,
      selectedbot: [],
      bulklinkbotdialog: false,
      leaseScheduleValue: "",
      leaseSchedulebulkValue: [],
      isLocation: false,
      selectaction: "",
      bulkactionuserselected: false,
      bulkActionUserType : "",
      possibleUsers: [],
      bulkactionuserdialog: false,
      bulkactionuserid: "",
      itemapprover: [
        { value: "associate", name: "Add" },
        { value: "remove", name: "Remove" },
        { value: "replace", name: "Replace" },
        { value: "move", name: "Change to Preparer" },
      ],
      itempreparer: [
        { value: "associate", name: "Add" },
        { value: "remove", name: "Remove" },
        { value: "replace", name: "Replace" },
        { value: "move", name: "Change to Approver" },
      ],
      changetouser: "",
      helpdeskitemnew: false,
      helpdeskitem: {},
      helpdeskdialog: false,
      linkbotdialog: false,
      bulkworkpaperupload: false,
      bulkworkpaper: false,
      searchcustomfilter: "",
      selectgls: [],
      selectedGlCodes: [],
      selectedLocation: "",
      hoverIndex: false,
      inforeqstage: "",
      linkbotloading: false,
      bulkuploadtemplate: false,
      file: null,
      fileprocessing: {},
      flag: false,
      uploaddata: [],
      dataerror: [],
      dialog: false,
      showdatawitherror: false,
      errorsonly: [],
      activitylogconfig: {
        checklistedit: {
          icon: "mdi-pencil",
          color: "fbcPrimary",
          displaytext: "Checklist Updated",
        },
        bulkapprove: {
          icon: "mdi-tag-check-outline ",
          color: "fbcPrimary",
          displaytext: "Bulk Approve",
        },
        bulkreject: {
          icon: "mdi-close-box-multiple-outline  ",
          color: "fbcPrimary",
          displaytext: "Bulk Reject",
        },
        checklistsentforreview: {
          icon: "mdi-file-eye",
          color: "fbcPrimary",
          displaytext: "Checklist Sent For Review",
        },
        fileupload: {
          icon: "mdi-file-upload",
          color: "fbcPrimary",
          displaytext: "File Upload",
        },
      },
      resetFlag: false,
      masterTaskList: [], // Original unmodified task data
      processedTaskList: [], // Filtered/sorted task data
      updatebulkduedate: "",
      bulkduedatedialog: false,
      bulkduedateloading: false,
      bulkThresholdDialog: false,
      bulkThresholdLoading: false,
      bulkSkipValidation: false,
      tableFilterHeader: {},
      defaultTableHeadersfilter: [],
      defaultTableFilterHeader: {},
      page_details: {},
      statusdetails: {},
      taskdeTailsDialog: false,
      emailpopdia: false,
      emailpopdialoading: false,
      addeditemail: false,
      addeditemailloading: false,
      emaildetils: {
        category: []
      },
      // Validation errors for email notification form
      emaildetilsErrors: {
        startDate: '',
        endDate: '',
        emails: '',
        subject: '',
        mailBody: '',
        locations: '',
        time: '',
        sla: '',
        category: ''
      },
      emaildata: [],
      timeList: [...Array(24)].map((_, i) => (i + 1).toString()),
      timeMultiples: [],
      slalist: [
        { name: "SLA1", id: 1 },
        { name: "SLA2", id: 2 },
      ],
      isCycleInActive: false,
      selectedTransactionMatching: "",
      botSelecetedId: "",
      bulkEditDialog:false,
      bulkEditDialogloading:false,
      bulkEditFileDataFile:null,
      resetbulkEditFile:false,  
      bulkEditData:{},
      bulkEditFileDataList:[],
      bulkEditFileDataerror:false,
      errorsonlyEditBulk:[],
      dataerroreditBulk:[],
      flageditBulk:false,
      showdatawitherrorEditBulk:false,
      bulkEditTableHeaders: [...this.$constants.TASK_LIST_CONSTANTS.BULK_EDIT_HEADERS_CLOSE_CYCLE],
      originalTaskType: '', // 👈 store the original type
      isEditMode: false,
      bulkEditErrorResponse: [],
      defaultCloneTableHeadersfilter:[],
      checkListErrorResponse: '',
      sendforreviewloadingbulk: false,
      selectedFilter: 'all',
      searchUserName:'',
      userDetails:{ activeUsers: [], activeUserIds: [] }
    };
  },
  components: {
    DragDropfile,
    TaskUploadModal,
    TaskStatusReportDialog,
    Pagination,
    // FilterMenu,
    BulkUploadChecklistV2,
    ActivityLog,
    TaskGLSelection,
    TaskStageTabs,
    TaskbarToolbar,
    RoleSwitcher,
    BulkUpdateDueDateDrawer,
    HorizonLanding,
  },
  beforeRouteEnter(to, from, next) {
    // Check if coming from task details page (same project, task subpage)
    const isFromTaskDetails = from.path && from.path.includes('/financialclose/project/checklist/') && from.path.includes('/task/');
    next(vm => {
      // From task details → use cached data (no force refresh)
      // From any other page → force API reload to get fresh data
      vm.refreshData(!isFromTaskDetails);
    });
  },
  // Prevent API calls when navigating away from this component
  beforeRouteLeave(to, from, next) {
    this.isComponentActive = false;
    next();
  },
  created() {
    this.viewMode = this.$route.query.view === HORIZON_VIEWS.HORIZON;
    this.persistTasklistView();
    this.hydrateTasklistFromStore();
    // enforceHorizonViewAccess runs after fetchFormDataV3 — formDataV3 is not loaded yet on refresh
    // Initialize default headers configuration (do NOT call refreshData here - it's handled by beforeRouteEnter)
    this.defaultTableHeadersfilter = JSON.parse(
      JSON.stringify(this.tableHeadersfilter)
    );
    this.defaultCloneTableHeadersfilter = this.mergeColumns(this.defaultTableHeadersfilter, this.tableHeadersfilter);
    this.defaultTableFilterHeader = JSON.parse(
      JSON.stringify(this.tableFilterHeader)
    );
    // Ensure no_of_evidence defaults to 0 if not set
    if (this.addeditdata && (this.addeditdata.no_of_evidence === undefined || this.addeditdata.no_of_evidence === null)) {
      this.$set(this.addeditdata, 'no_of_evidence', 0);
    }
  },

  methods: {
    /**
     * Handler for filter-active-change event from DataTableAction
     */
    onFilterActiveChange(isActive) {
      this.hasActiveTableFilter = isActive;
    },
    /**
     * Sync ?view=horizon in the address bar without vue-router navigation.
     * base.vue keys router-view on $route.fullPath — router.replace remounts Tasklist and clears metadata.
     */
    syncViewModeQueryParam(isHorizon) {
      const query = { ...this.$route.query };
      if (isHorizon) {
        query.view = HORIZON_VIEWS.HORIZON;
      } else {
        delete query.view;
      }
      const { href } = this.$router.resolve({ path: this.$route.path, query });
      window.history.replaceState(window.history.state, '', href);
    },
    syncUserTypeQueryParam(userType) {
      const query = { ...this.$route.query, userType };
      const { href } = this.$router.resolve({ path: this.$route.path, query });
      window.history.replaceState(window.history.state, '', href);
    },
    syncHorizonViewUserType(userType) {
      if (!this.id || !userType) return;
      const current = this.$store.getters['tasks/getHorizonViewState'](this.id);
      if (current?.userType === userType) return;
      this.$store.dispatch('tasks/saveHorizonViewState', {
        checklistId: this.id,
        partial: {
          userType,
          activeHorizonFilters: {},
          selectedCell: null,
        },
      });
    },
    onHorizonRoleChange(userType) {
      if (userType === this.userType) return;
      this.filterListByUser(userType);
    },
    onHorizonDueDateUpdated() {
      this.refreshData();
    },
    resolveInitialUserType() {
      const available = this.hasManagerRole
        ? ['manager', 'preparer', 'approver']
        : ['preparer', 'approver'];
      const candidates = [
        this.$route?.query?.userType,
        this.userType,
        this.$store.state.tasklistUserType,
      ];
      for (const role of candidates) {
        if (role && available.includes(role)) {
          return role;
        }
      }
      return this.hasManagerRole ? 'manager' : 'preparer';
    },
    /**
     * Horizon is only available when formDataV3.horizonViewEnabled is true.
     * Reset view mode and URL if the flag is off (e.g. ?view=horizon on a non-Horizon client).
     * Skips while formDataV3 is still loading so a refresh with ?view=horizon is not cleared early.
     */
    enforceHorizonViewAccess() {
      if (!this.$store.getters['tasks/getFormDataV3']) return;
      if (this.viewMode && !this.horizonViewEnabled) {
        this.viewMode = false;
        this.syncViewModeQueryParam(false);
      }
    },
    hydrateTasklistFromStore() {
      const checklistId = this.$route.params.id || this.id;
      if (!checklistId) return;
      const storeData = this.$store.getters['tasks/getTaskListData'] || {};
      if (storeData.metadata?._id !== checklistId) return;
      if (!this.metadata?._id) {
        this.metadata = storeData.metadata || {};
      }
      if (!this.checklist?.length && storeData.checklist?.length) {
        this.checklist = storeData.checklist;
      }
      if (!this.tasklistDataCopy?.length && storeData.checklist?.length) {
        this.tasklistDataCopy = [...storeData.checklist];
      }
    },
    /**
     * Persist List vs Horizon so task-detail back navigation can restore view without a query param.
     */
    persistTasklistView(isHorizon = this.isHorizonView) {
      const checklistId = this.$route.params.id || this.id;
      if (!checklistId) return;
      this.$store.commit('tasks/SET_TASKLIST_VIEW', {
        checklistId,
        view: isHorizon ? HORIZON_VIEWS.HORIZON : HORIZON_VIEWS.LIST,
      });
    },
    /**
     * Handle view mode change between List and Horizon — hydrate Horizon from loaded data (no API refetch).
     */
    async onViewModeChange(mode) {
      const nextMode = mode === true || mode === false ? mode : this.viewMode;
      if (nextMode === true && !this.horizonViewEnabled) {
        return;
      }
      const isHorizon = nextMode === true;
      this.syncViewModeQueryParam(isHorizon);
      this.persistTasklistView(isHorizon);

      if (isHorizon) {
        this.ensureStoreHasChecklistForHorizon();
        await this.$nextTick();
        this.syncHorizonAfterDataLoad();
      }
    },
    ensureStoreHasChecklistForHorizon() {
      const storeData = this.$store.getters['tasks/getTaskListData'] || {};
      if (Array.isArray(storeData.checklist) && storeData.checklist.length > 0) {
        return;
      }
      const source = this.checklist?.length
        ? this.checklist
        : (this.tasklistDataCopy?.length ? this.tasklistDataCopy : []);
      if (!source.length || !this.metadata?._id) {
        return;
      }
      this.$store.commit('tasks/SET_TASKLIST_DATA', {
        ...storeData,
        metadata: this.metadata,
        checklist: JSON.parse(JSON.stringify(source)),
      });
    },
    onHorizonLandingMounted() {
      this.$refs.horizonLanding?.ensureHorizonReady?.();
    },
    async waitForHorizonLandingRef(maxAttempts = 15) {
      for (let attempt = 1; attempt <= maxAttempts; attempt += 1) {
        await this.$nextTick();
        const ref = this.$refs.horizonLanding;
        if (ref) {
          return ref;
        }
      }
      return null;
    },
    async syncHorizonAfterDataLoad() {
      if (!this.horizonViewEnabled || !this.isHorizonView) {
        return;
      }
      const ref = await this.waitForHorizonLandingRef();
      ref?.ensureHorizonReady?.();
    },
    /**
     * Clear table filters via DataTableAction ref
     */
    clearTableFilter() {
      if (this.$refs.dataTableAction) {
        this.$refs.dataTableAction.clearFilter();
      }
    },
    handleOpenDocumentMenu(item) {
      // Always set fileNamesList to the current item's files, or empty if none
      this.fileNamesList = item.upload && item.upload.length > 0 ? item.upload : [];
    },
    __attachHeaderDragListeners() {
      try {
        const headerRow = this.$el.querySelector('.tasklist-table .v-data-table__wrapper > table > thead > tr') || this.$el.querySelector('.v-data-table__wrapper > table > thead > tr');
        if (!headerRow) return;
        Array.from(headerRow.children).forEach(th => {
          if (th.__stickyDragBound) return;
          th.addEventListener('dragstart', () => { this.__headerDragging = true; });
          th.addEventListener('dragend', () => {
            this.__headerDragging = false;
            requestAnimationFrame(() => setTimeout(() => this.updateStickyOffsets(), 30));
          });
          th.__stickyDragBound = true;
        });
      } catch (e) { /* silent */ }
    },
    getStageDisplay,
    isTaskBotLinked,
    hasDownloadableFiles,
    extractFileIdsFromTask,
    isClosedTask(item) {
      return item?.stage === TASK_STAGES.CLOSED;
    },
    getStatusConfig(statusDetail) {
      const constants = this.$constants.TASK_LIST_CONSTANTS;
      const statusConfig = {
        [constants.STATUS_DETAILS.PENDING_SUBMISSION_DUE]: {
          icon: constants.STATUS_ICONS.PENDING_SUBMISSION,
          color: constants.STATUS_COLORS.SUBMISSION,
          text: constants.STATUS_DETAILS.PENDING_SUBMISSION_DUE
        },
        [constants.STATUS_DETAILS.PENDING_SUBMISSION_NOT_DUE]: {
          icon: constants.STATUS_ICONS.PENDING_SUBMISSION_NOT_DUE,
          color: constants.STATUS_COLORS.SUBMISSION,
          text: constants.STATUS_DETAILS.PENDING_SUBMISSION_NOT_DUE
        },
        [constants.STATUS_DETAILS.PENDING_SUBMISSION_OVERDUE]: {
          icon: constants.STATUS_ICONS.PENDING_SUBMISSION_OVERDUE,
          color: constants.STATUS_COLORS.SUBMISSION,
          text: constants.STATUS_DETAILS.PENDING_SUBMISSION_OVERDUE
        },
        [constants.STATUS_DETAILS.PENDING_APPROVAL_DUE]: {
          icon: constants.STATUS_ICONS.PENDING_APPROVAL,
          color: constants.STATUS_COLORS.APPROVAL,
          text: constants.STATUS_DETAILS.PENDING_APPROVAL_DUE
        },
        [constants.STATUS_DETAILS.PENDING_APPROVAL_NOT_DUE]: {
          icon: constants.STATUS_ICONS.PENDING_APPROVAL_NOT_DUE,
          color: constants.STATUS_COLORS.APPROVAL,
          text: constants.STATUS_DETAILS.PENDING_APPROVAL_NOT_DUE
        },
        [constants.STATUS_DETAILS.PENDING_APPROVAL_OVERDUE]: {
          icon: constants.STATUS_ICONS.PENDING_APPROVAL_OVERDUE,
          color: constants.STATUS_COLORS.APPROVAL,
          text: constants.STATUS_DETAILS.PENDING_APPROVAL_OVERDUE
        }
      };
      
      return statusConfig[statusDetail] || {
        icon: constants.STATUS_ICONS.CLOSED,
        color: constants.STATUS_COLORS.CLOSED,
        text: constants.STATUS_DETAILS.CLOSED_TASK
      };
    },
    handleFilterChange(filterValue) {
      this.selectedFilter = filterValue;
      
      const normalTaskDisplayName = getTaskTypeDisplay(this.$constants.TASK_LIST_CONSTANTS.TASK_TYPES.NORMAL);
      // Apply task type filtering
      if (filterValue === 'all') {
        this.processedTaskList = [...this.masterTaskList];
      } else if (filterValue === this.$constants.TASK_LIST_CONSTANTS.TASK_TYPES.ACCOUNT_RECONCILIATION) {
        this.processedTaskList = this.masterTaskList.filter(task => 
          task.task_type === this.$constants.TASK_LIST_CONSTANTS.TASK_TYPES.ACCOUNT_RECONCILIATION
        );
      } else if (filterValue === this.$constants.TASK_LIST_CONSTANTS.TASK_TYPES.NORMAL) {
        this.processedTaskList = this.masterTaskList.filter(task => 
          task.task_type === normalTaskDisplayName
        );
      }

    },
    onEvidenceInput(val) {
      if (typeof val !== 'number') val = Number(val);
      if (val < 0 || val > 10) {
        this.addeditdataerror.no_of_evidence = ['Please enter a value between 0 and 10.'];
      } else {
        this.addeditdataerror.no_of_evidence = '';
      }
      this.addeditdata.no_of_evidence = val;
    },
    getColumnValue(column, task) {
    if (column.dataType === "date") {
      return task[column.columnName]
        ? this.$nova.formatDate(task[column.columnName])
        : "";
    }
    return task[column.columnName] || "";
  },

  /**
   * Handle Apply button click from CustomizeColumnMenu
   * Updates column visibility locally (session only)
   * @param {Array} headers - Updated headers array
   */
  handleApplyColumns(headers) {
    this.tableHeadersfilter = headers;
    this.menuOpen = false;
  },

  /**
   * Handle Save Columns button click from CustomizeColumnMenu
   * Persists column preferences to database using Vuex saveCustomLayout action
   * @param {Object} payload - { headers, pageName }
   */
  async handleSaveColumns({ headers, pageName }) {
    this.tableHeadersfilter = headers;
    this.loading = true;
    try {
      await this.$store.dispatch('saveCustomLayout', {
        axios: this.axios,
        page: pageName || this.page_name,
        cycleId: this.id,
        layout: headers,
        filter: this.tableFilterHeader || {}
      });
      this.page_details = { cycle_id: this.id, pagename: this.page_name, layout: headers };
      this.columnOrderChanged = false;
      this.menuOpen = false;
    } catch (err) {
      console.error('[Tasklist]: Error saving columns:', err);
    } finally {
      this.menuOpen = false;
      this.loading = false;
    }
  },
  onColumnReorder(headers) {
    this.tableHeadersfilter = [...headers];
    this.columnOrderChanged = true;
  },
  async saveColumnOrder() {
    await this.handleSaveColumns({ headers: this.tableHeadersfilter, pageName: this.page_name });
  },
     getAvailableUsers(possibleUsers) {
    const users = Object.values(this.userMap);
    if (users.length === 0) return [];
    if (!Array.isArray(possibleUsers)) possibleUsers = [];
    return users.filter(
      u => !possibleUsers.some(pu => pu._id === u._id) && this.userDetails.activeUserIds.includes(u._id)
    );
  },
     mergeColumns(colim1, colim2) {
      const seen = new Set();
      const merged = [];

  // Add colim2 columns first (they have priority)
  for (const col of colim2) {
    merged.push(col);
    seen.add(col.value);
  }

  // Add only new columns from colim1, force visible: false
  for (const col of colim1) {
    if (!seen.has(col.value)) {
      merged.push({ ...col, visible: false }); // Override visibility
      seen.add(col.value);
    }
  }

      return merged;
    },
    checkForNotNull(item, attribute) {
      return checkForNotNull(item, attribute);
    },
    handleCategoryChange(selected) {
      if (!Array.isArray(selected)) return;
      this.$nextTick(() => {
        const allIds = this.uniqueCategoryIds;
        const hasSelectAll = this.emaildetils.category.includes('__select_all__');
        const filtered = this.emaildetils.category.filter(id => id !== '__select_all__');
        const isAllSelected = filtered.length === allIds.length;
        if (hasSelectAll && !isAllSelected) {
          this.emaildetils.category = JSON.parse(JSON.stringify(allIds));
        } else if (hasSelectAll && isAllSelected) {
          this.emaildetils.category = [];
        } else {
          this.emaildetils.category = JSON.parse(JSON.stringify(filtered));
        }
      });
    },
    handleLocationChange(selected) {
      const normalizeId = (value) => {
        if (value && typeof value === 'object') {
          return String(value._id || value.id || value.value || '');
        }
        return value === undefined || value === null ? '' : String(value);
      };
      const normalizedSelected = (Array.isArray(selected) ? selected : [])
        .map(normalizeId)
        .filter(Boolean);
      const totalIds = this.dropdownLocations
        .map(item => normalizeId(item._id))
        .filter(id => id && id !== 'all');
      const isAllSelected = totalIds.length > 0 && totalIds.every(id => normalizedSelected.includes(id));

      if (normalizedSelected.includes('all')) {
        if (isAllSelected) {
          this.emaildetils.locations = [];
        } else {
          this.emaildetils.locations = [...totalIds];
        }
      } else {
        this.emaildetils.locations = normalizedSelected.filter(id => id !== 'all');
      }
    },
    generateTimeMultiples(selectedHour) {
      const baseHour = parseInt(selectedHour);
      if (isNaN(baseHour)) {
        this.timeMultiples = [];
        return;
      }
      const getGMTOffset = (date) => {
        const offset = -date.getTimezoneOffset(); // In minutes
        const sign = offset >= 0 ? '+' : '-';
        const hours = String(Math.floor(Math.abs(offset) / 60)).padStart(2, '0');
        const minutes = String(Math.abs(offset) % 60).padStart(2, '0');
        return `GMT${sign}${hours}:${minutes}`;
      };
      const baseUTC = new Date();
      baseUTC.setUTCHours(0, 0, 0, 0);
      this.timeMultiples = Array.from({ length: 5 }, (_, i) => {
        const timeUTC = new Date(baseUTC.getTime());
        timeUTC.setUTCDate(baseUTC.getUTCDate() + i);      // ✅ day increment
        timeUTC.setUTCHours(baseHour, 0, 0, 0);             // ✅ fixed hour
        const localDate = new Date(timeUTC);
        const year = localDate.getFullYear();
        const month = String(localDate.getMonth() + 1).padStart(2, '0');
        const day = String(localDate.getDate()).padStart(2, '0');
        const hours = String(localDate.getHours()).padStart(2, '0');
        const minutes = String(localDate.getMinutes()).padStart(2, '0');
        const seconds = String(localDate.getSeconds()).padStart(2, '0');
        const timezone = getGMTOffset(localDate);
        return `${year}-${month}-${day} ${hours}:${minutes}:${seconds} ${timezone}`;
      });
    },
    getBotRoute(item) {

      if (item.bot_details?.name === "Lease Schedule") {
        this.$nova.gotoLink({
          path: "/financialclose/automationlease/" + this.id,
        });
      } else if (item.bot_details?.name === "Borrowing Schedule") {
        this.$nova.gotoLink({
          path: "/financialclose/automationborrowingschedule/" + this.id,
        });
      } else if (item.bot_details?.name === "Transaction Matching" || item.tmaid) {
        this.$nova.gotoLink({
          path:
            "/financialclose/automationtransactionmatching/" +
            this.id +
            "/c/" +
            (item.bot_analysis_detail?._id || item.tmaid),
        });
      } else {
        console.log(this.$constants.BOT_NAME +" not found");
      }
    },
    // This function formats the tasklist data into a more usable structure
    formateData() {
      const customColumns = this.customColumns;
      
      if (!this.taskListData || this.taskListData.length === 0) {
        console.warn('[formateData] WARNING: this.taskListData is empty.');
      }
      this.processedTaskList = (this.taskListData || []).map((item, index) => {
        // Resolve locationItem from locationList for backward compatibility
        const matchedLocation = item.location && Array.isArray(this.locationList)
          ? this.locationList.find(loc => loc._id === item.location)
          : null;
        const formatted = {
          ...item, // Spread all properties — new backend fields are automatically included
          // Explicit overrides for formatted/derived fields:
          __keys: index,
          __formatedkey: index,
          indexno: index + 1,
          approverids: this.getNamesByIds(item.approver),
          closed_date: this.$nova.formatDate(item?.closed_date),
          created_at: this.$nova.formatDate(item.created_at),
          created_by: item.created_by?.split("T")[0],
          duedate: item.duedate?.split("T")[0],
          duedate1: this.$nova.formatDate(item.duedate),
          locationItem: matchedLocation ? [matchedLocation] : [{ name: "" }],
          locationName: matchedLocation?.name || item.locationName || "",
          preparerids: this.getNamesByIds(item.preparer),
          stage1: this.getStageText(item.stage).text,
          statusdetail: this.getStatusText(item.statusdetail),
          task_type: getTaskTypeDisplay(item.task_type),
          submited_on: this.$nova.formatDate(item?.submited_on),
          no_of_evidence: item.no_of_evidence || 0,
          updated_at: item.updated_at?.split("T")[0],
          updated_by: item.updated_by?.split("T")[0],
          skipValidations: item.skipValidations ?? false,
        };
        // Dynamically add custom columns
        (Array.isArray(customColumns) ? customColumns : []).forEach(field => {
          const key = field.columnName;
          if (!(key in formatted)) {
            formatted[key] = item[key] ?? '';
          }
        });
        return formatted;
      });
      this.masterTaskList = this.processedTaskList;

      // Apply the current filter after data is loaded
      this.handleFilterChange(this.selectedFilter);
    },
    getNamesByIds(ids) {
      if (!Array.isArray(ids)) {
        if (typeof ids === 'string') {
          ids = [ids];
        } else if (ids == null) {
          return [];
        } else {
          return [String(ids)];
        }
      }
      return ids
        .map((id) => this.userMap[id]?.name || id)
        .filter(Boolean);
    },
    // MARKER: TASK_TYPE
    async downloadExcelTasklist(selectedItem){
      try {
        const selectIds = selectedItem.map(item => item._id);
        
        console.log('[downloadExcelTasklist] Starting download with IDs:', selectIds);

        const response = await this.$store.dispatch('tasks/downloadBulkEditTasklistTemplate', {
          checklistId: this.id,
          taskIds: selectIds,
        });

        // Extract filename from Content-Disposition header with better handling
        let filename = `Tasklist-${new Date().toISOString().split('T')[0]}.xlsx`;
        const contentDisposition = response.headers['content-disposition'];
        
        console.log('[downloadExcelTasklist] Content-Disposition:', contentDisposition);
        
        if (contentDisposition && contentDisposition.trim() !== '') {
          // Handle filename*=UTF-8''encodedname (RFC 5987)
          const filename5987Match = contentDisposition.match(/filename\*=(?:UTF-8'')?([^;]+)/i);
          if (filename5987Match && filename5987Match[1]) {
            try {
              filename = decodeURIComponent(filename5987Match[1].trim());
              console.log('[downloadExcelTasklist] Extracted filename (RFC 5987):', filename);
            } catch (e) {
              console.warn('[downloadExcelTasklist] Failed to decode RFC 5987 filename:', e);
            }
          } else {
            // Handle filename="name" or filename=name
            const filenameMatch = contentDisposition.match(/filename=([^;]+)/i);
            if (filenameMatch && filenameMatch[1]) {
              filename = filenameMatch[1].trim().replace(/^["']|["']$/g, '');
              console.log('[downloadExcelTasklist] Extracted filename (standard):', filename);
            }
          }
        }
          
        // Create download link and trigger download
        const url = window.URL.createObjectURL(new Blob([response.data]));
        console.log('[downloadExcelTasklist] Blob URL created:', url);
        
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', filename);
        document.body.appendChild(link);
        
        link.click();
        
        // Cleanup
        document.body.removeChild(link);
        window.URL.revokeObjectURL(url);
        
        console.log('[downloadExcelTasklist] Download completed successfully');
        this.$store.commit('sbSuccess', 'Tasklist exported successfully');
      } catch (error) {
        console.error('[downloadExcelTasklist] Error exporting tasklist:', {
          message: error?.message,
          status: error?.response?.status,
          statusText: error?.response?.statusText,
          errorData: error?.response?.data,
          fullError: error
        });
        this.$store.commit("sbError", error?.response?.data?.message || "Failed to export tasklist. Please try again.");
      }
    },
    downloadTemplate() {
      if (this.id)
        this.$nova.downloadFile(
          "",
          {},
          `/v2/financialclose/analysis/getbulkchecklisttemplate/${this.id ? `${this.id}` : ''}`
        );
      else
        this.$nova.downloadFile(
          "",
          {},
          "/v2/financialclose/masters/checklist/getbulksubmittemplate"
        );
    },

    /**
     * Extracts linked GL codes from a task
     * @param {Object} task - The task object containing __tbtotals data
     * @returns {string} Comma-separated GL codes or empty string
     */
    getLinkedGLsForExport(task) {
      if (!task || !task.__tbtotals || !Array.isArray(task.__tbtotals.items)) {
        return "";
      }
      return task.__tbtotals.items.map(item => item.glcode).join(", ");
    },

    /**
     * Finds a task by ID and extracts its linked GL codes
     * @param {Array} tasks - Array of task objects
     * @param {string} taskId - The task ID to search for
     * @returns {string} Comma-separated GL codes or empty string
     */
    getGLCodeAndNameByChecklistId(tasks, taskId) {
      const task = tasks.find(t => t._id === taskId);
      return this.getLinkedGLsForExport(task);
    },

    // MARKER: TASK_TYPE
    uploadDataBulk(){
      this.bulkEditDialogloading = true;
      const url = "v2/financialclose/analysis/bulkUpdateCycleTaskList/" + this.id;
      this.axios
        .post(url, { data: this.bulkEditFileDataList })
        .then((dt) => {
          if (dt.data.status === "success") {
            this.$store.commit("sbSuccess", "Tasklist updated successfully");
            this.bulkEditDialog = false;
            this.refreshData();
          } else {
            this.bulkEditErrorResponse = dt.data.data || [];
            throw dt.data.message || "Error uploading Tasklist";
            }
        })
        .catch((err) => {
          this.$store.commit("sbError", err.message || err || "Unknown error!");
          //  this.resetbulkEditFile = !this.resetbulkEditFile;
          console.log(err);
        })
        .finally(() => {
          this.resetbulkEditFile = !this.resetbulkEditFile;
          this.bulkEditDialogloading = false;
        });
      
    },
    cleardataBulkEdit(){
      this.bulkEditFileDataList = [];
      this.bulkEditFileDataerror = false;
      this.dataerroreditBulk = [];
      this.errorsonlyEditBulk = [];
      this.bulkEditDialog = false;
      this.bulkEditDialogloading = false;
      this.showdatawitherrorEditBulk = false;
    },
    cleardata() {
      this.file = null;
      this.fileprocessing = {};
      this.flag = false;
      this.uploaddata = [];
      this.dataerror = [];
      this.dialog = false;
      this.loading = false;
      this.showdatawitherror = false;
    },
    // MARKER: TASK_TYPE
    readFile(key) {
      let file = this.file;
      


      if ((file || {}).name && (this.fileprocessing[key] || 0) === 0) {
        let headings = this.$constants.EXPECTED_HEADERS_CLOSE_CYCLE;
        // Add custom columns to headings if they exist
        headings = [...headings, ...(this.customColumns.map((col) => col.dataType === "date" ? `${col.displayText} (dd/mm/yyyy)` : col.displayText) || [])];
        this.loading = true;
        this.fileprocessing[key] = 1;
        let ext = ((file || {}).name || "").split(".").pop();
        Promise.resolve()
          .then(() => {
            if (["xlsx", "xls", "xlsm", "xlsb"].indexOf(ext) === -1)
              throw new Error(CYCLE_MESSAGES.ERROR.UNSUPPORTED_FILE_EXTENSION);
            return this.$nova.readExcelFile(file, "");
          })
          .then(async (dt) => {
            if (JSON.stringify(dt[0] || []) === JSON.stringify(headings)) {
              let filedata = [];
              let errordata = [];
              let chartofaccountData = [];
              this.flag = false;
              await this.axios
                .post("/v2/financialclose/masters/chartofaccount/get")
                .then((dt) => {
                  if (dt.data.status === "success") {
                    chartofaccountData.push({ data: dt.data.data });
                  }
                });
              for (let i = 0; i < dt.length; i++) {
                if (i > 0 && dt[i].length > 0) {
                  const el = dt[i];
                  let rowdata = {
                    task_type: "",
                    description: el[0],
                    category: el[1],
                    subcategory: el[2],
                  };
                  rowdata.location = (el[3]?.toString() || "base")
                    .split(",")
                    .filter((x) => x.replaceAll(/\s/g, ""));
                  rowdata.assertions = (el[4] || "")
                    .split(",")
                    .filter((x) => x.replaceAll(/\s/g, ""));
                  rowdata.purpose = el[5];
                  rowdata.instruction = el[6];
                  rowdata.preparer = (el[7] || "")
                    .split(",")
                    .filter((x) => x.replaceAll(/\s/g, ""));
                  rowdata.approver = (el[8] || "")
                    .split(",")
                    .filter((x) => x.replaceAll(/\s/g, ""));
                  rowdata.tags = (el[9] || "")
                    .split(",")
                    .filter((x) => x.replaceAll(/\s/g, ""));
                  // Parse Due Days - blank => null, otherwise convert to number (supports signed offsets: -200 to 200)
                  const dueDaysRaw = (el[10] || "").toString().trim();
                  rowdata.duedays = dueDaysRaw && !isNaN(dueDaysRaw) && Number.isFinite(Number(dueDaysRaw)) ? Number(dueDaysRaw) : null;
                  
                  rowdata.glcode = (el[11] || "")
                    .toString()
                    .split(",")
                    .filter((x) => x.replaceAll(/\s/g, ""));
                  rowdata.task_type = rowdata.glcode.length ? this.$constants.TASK_LIST_CONSTANTS.TASK_TYPES.ACCOUNT_RECONCILIATION : this.$constants.TASK_LIST_CONSTANTS.TASK_TYPES.NORMAL;
                  rowdata.priority = (el[12] || '').toString().trim();
                  rowdata.no_of_evidence = Number(el[13] || "") || 0;
                  let errors = {};
                  // Priority validation: required and must match one of PRIORITY_LIST values (case-insensitive)
                  const allowedPriorities = (this.priorityList || []).map(p => (p.value || p).toString().toLowerCase());
                  if (!rowdata.priority) {
                    errors["priority"] = "Priority is required";
                  } else if (allowedPriorities.length && !allowedPriorities.includes(rowdata.priority.toLowerCase())) {
                    errors["priority"] = "Invalid priority";
                  }
                  // Due Days validation: required, finite number, and in range -200 to 200
                  if (rowdata.duedays === null || rowdata.duedays === '') {
                    errors["duedays"] = "Due Days is required";
                  } else if (isNaN(rowdata.duedays) || !Number.isFinite(rowdata.duedays)) {
                    errors["duedays"] = `'${dueDaysRaw}' is not a valid number`;
                  } else if (rowdata.duedays < -200 || rowdata.duedays > 200) {
                    errors["duedays"] = "Due Days must be between -200 and 200";
                  }
                  if ((rowdata.description || "").toString() === "")
                    errors["description"] = "Description is required";
                  if ((rowdata.category || "").toString() === "")
                    errors["category"] = "Category is required";
                  if ((rowdata.subcategory || "").toString() === "")
                    errors["subcategory"] = "Sub category is required";
                  if ((rowdata.approver || "").toString() === "")
                    errors["approver"] = " Approver is required";
                  if ((rowdata.preparer || "").toString() === "")
                    errors["preparer"] = " Preparer is required";
                  if (this.project) delete rowdata.tags;
                  else if ((rowdata.tags || []).length === 0)
                    errors["tags"] = " Tags are required";
                  if (
                    rowdata.preparer.length > 0 &&
                    rowdata.approver.length > 0
                  ) {
                    let preparers = rowdata.preparer;
                    let approvers = rowdata.approver;
                    let duplicates = [];
                    for (const i of preparers) {
                      if (approvers.indexOf(i.trim()) > -1) duplicates.push(i);
                    }
                    if (duplicates.length > 0)
                      errors["preparer"] =
                        "'" +
                        duplicates.join(",") +
                        "' cannot be both preparer and approver";
                  }
                  
                  for (const i of rowdata.glcode) {
                    if (rowdata.glcode[i] != null && rowdata.glcode[i] !== "") {
                      let isGLValid =
                        chartofaccountData[0].data.filter(
                          (obj) => obj["glcode"] == rowdata.glcode[i]
                        ) || "";
                      if (isGLValid === "" || isGLValid.length === 0) {
                        errors["glcode"] =
                          rowdata.glcode[i] + " Invalid GL Code";
                      }
                    }
                  }
                  if (Object.keys(errors).length > 0) this.flag = true;
                  if (this.customColumns.length > 0) {
                    (Array.isArray(this.customColumns) ? this.customColumns : []).forEach(column => {
                      // Account for date suffix when searching for column header
                      let headerIndex = -1;
                      if (column.dataType === 'date') {
                        const headerWithDateSuffix = `${column.displayText} (dd/mm/yyyy)`;
                        headerIndex = headings.indexOf(headerWithDateSuffix);
                      } else {
                        headerIndex = headings.indexOf(column.displayText);
                      }
                      let value = headerIndex >= 0 ? el[headerIndex] : '';
                      rowdata[column.columnName] = value;
                    });
                  }
                  filedata.push(rowdata);
                  errordata.push(errors);
                }
              }
              this.uploaddata = filedata;
              this.dataerror = errordata;
              this.errorsonly = this.dataerror;
              this.dialog = true;
            } else
              throw Error(
                "Columns '" +
                  headings.join("','") +
                  "' are required in the same order"
              );
          })
          .catch((err) => {
            this.$store.commit(
              "sbError",
              err.message || err || "Unknown error!"
            );
            console.log(err);
          })
          .finally(() => {
            this.file = null;
            this.fileprocessing[key] = 0;
            this.loading = false;
          });
      }
    },
    // MARKUP_RECON
    readFilesinglebulk(key) {
      console.log(key);

      let files = this.file;
      if (Array.isArray(files) && files.length > 0) {
        this.loading = true;
        Promise.all(
          files.map(async (file, index) => {
            if ((file || {}).name && (this.fileprocessing[index] || 0) === 0) {
              this.fileprocessing[index] = 1;
              let ext = ((file || {}).name || "").split(".").pop();

              // Validate file extension
              if (!["xlsx", "xls", "xlsm", "xlsb"].includes(ext)) {
                throw new Error(
                  `File '${file.name}' has unsupported extension. Only xlsx, xls, xlsm, xlsb are allowed.`
                );
              }

              // Read Excel file
              let dt = await this.$nova.readExcelFile(file, "TOP SHEET");
              let headings = [
                "Task No ",
                "Task description",
                "Location",
                "Particulars",
                "Amount",
                "File Reference",
                "Type"
              ];

              // New set of headings for consildated recon file.
              let headingsConsolidated = [
                "Task No", 
                "Task description (Optional)", 
                "Location",
                "Particulars",
                "Amount",
                "File Reference (Optional)",
                "Type",
                "Standalone Entity (refer # 11 in Instructions)",
                "GL (refer # 12 in Instructions)"
              ]
              // let consolidatedReconFile = false;
              if (JSON.stringify(dt[0] || []) === JSON.stringify(headingsConsolidated)) {
                // consolidatedReconFile = true;
              } else if (JSON.stringify(dt[0] || []) !== JSON.stringify(headings)) {
                throw new Error(
                  `File '${
                    file.name
                  }' is missing required columns or they are not in the correct order. Expected: '${headings.join(
                    "', '"
                  )}'`
                );
              }

            }
          })
        )
          .then(() => {
            console.log("All files validated successfully.");
          })
          .catch((err) => {
            this.$store.commit(
              "sbError",
              err.message || err || "Unknown error!"
            );
            console.log(err);
          })
          .finally(() => {
            this.file = null; // Reset file array
            this.fileprocessing = {}; // Reset processing state
            this.loading = false; // Reset loading state
          });
      } else {
        console.log("No files to validate.");
      }

      //   let file = this.file;
      //   if ((file || {}).name && (this.fileprocessing[key] || 0) === 0) {
      //     let headings = ['Description', 'Category', 'Sub Category','Location', 'Assertions', 'Purpose', 'Instruction', 'Preparer', 'Approver', 'Tags', 'Due Days', 'Account No'];
      //     // let possibleAssertions = ['Existence', 'Occurrence', 'Rights and obligations', 'Completeness', 'Accuracy valuation and allocation', 'Cut–off', 'Classification', 'Presentation'];
      //     this.loading = true;
      //     this.fileprocessing[key] = 1;
      //     let ext = ((file || {}).name || "").split(".").pop();
      //     Promise.resolve().then(() => {
      //       if (["xlsx", "xls", "xlsm", "xlsb"].indexOf(ext) === -1) throw new "Only xlsx,xls,xlsm,xlsb file extension supported";
      //       return this.$nova.readExcelFile(file, "");
      //     }).then(async (dt) => {
      //       if (JSON.stringify(dt[0] || []) === JSON.stringify(headings)) {

      //       } else throw Error("Columns '"+headings.join("','")+"' are required in the same order");
      //     }).catch(err => {
      //       this.$store.commit("sbError", err.message || err || "Unknown error!");
      //       console.log(err);
      //     }).finally(() => {
      //       this.file = null;
      //       this.fileprocessing[key] = 0;
      //       this.loading = false;
      //     });
      //   }
    },
    // MARKER: TASK_TYPE
    uploadData() {
      this.loading = true;
      let url = "/v2/financialclose/masters/checklist/bulkadd";
      if (this.id)
        url = "/v2/financialclose/analysis/bulkaddchecklist/" + this.id;

      this.axios
        .post(url, { data: this.uploaddata })
        .then((dt) => {
          if (dt.data.status === "success") {
            this.bulkuploadtemplate = false;
            this.$emit("reload");
            this.$store.commit("sbSuccess", "Checklist uploaded successfully");
            this.refreshData();
            this.uploaddata = [];
            this.showdatawitherror = false;
            this.dataerror = [];
            this.flag = false;
          } else {
            this.checkListErrorResponse = dt.data.message || "Error uploading Tasklist";
            this.$store.commit("sbError", this.checkListErrorResponse);
          }
        })
        .catch((err) => {
          this.$store.commit("sbError", err.message || err || "Unknown error!");
          this.resetFlag = !this.resetFlag;
          console.log(err);
        })
        .finally(() => {
          this.resetFlag = !this.resetFlag;
          this.loading = false;
        });
    },
    bulkworkpaperuploadFun() {
      // Validate that all selected tasks share the same task_type before opening bulk upload
      if (!Array.isArray(this.selectItem) || this.selectItem.length === 0) {
        this.$store.commit('sbError', 'Select at least one task.');
        return;
      }
      const distinctTypes = [...new Set(this.selectItem.map(t => t && t.task_type).filter(Boolean))];
      if (distinctTypes.length > 1) {
        this.$store.commit('sbError', 'You have chosen both "Account Reconciliation" and "Checklist" task types. Bulk submission is only available for tasks of a single type. Please select tasks of one type to proceed.');
        return;
      }
      this.sendforreviewdrawer = true;
      this.bulkworkpaper = true;
      this.resetFlag = !this.resetFlag;
      this.fileNamesList = [];
      this.fileremark = "";
    },
    updateFilesBulk(newFilesBulk) {
      this.file = newFilesBulk[0];
      this.readFile("file");
    },

    toggleSearch() {
      this.showSearch = !this.showSearch; // Toggle search box visibility
    },

    async loadTasklistData(force) {
      // Early exit if component is no longer active (user navigated away)
      if (!this.isComponentActive) {
        return;
      }
      const taskListObj = this.$store.getters['tasks/getTaskListData'] || {};
      const useCache = !force && taskListObj?.metadata?._id === this.id;
      if (!useCache) {
        this.loading = true;
      }
      // If taskListObj is valid and matches the current id, use cached data
      if (useCache) {
        this.metadata = taskListObj.metadata || {};
        this.cycleType = (taskListObj.checklist?.[0]?.cycle_type) || "FBC";
        this.checklist = taskListObj.checklist || [];
        this.coaCategoryAcc = taskListObj.coaCategoryAcc || [];
        this.coaSubcategoryAcc = taskListObj.coaSubcategoryAcc || [];
        this.categoryAcc = taskListObj.categoryAcc || [...this.coaCategoryAcc];
        this.subcategoryAcc = taskListObj.subcategoryAcc || [...this.coaSubcategoryAcc];
        
        const { localCustomColumns, taskMasterCustomColumns, tableHeadersfilter } = handleCustomColumnHeadersUtil(taskListObj.customColumns, this.tableHeadersfilter);
        this.localCustomColumns = localCustomColumns || taskListObj.customColumns || [];
        this.taskMasterCustomColumns = taskMasterCustomColumns;
        this.tableHeadersfilter = tableHeadersfilter;
        
        await this.getCustomLayout(false);
        
        this.tasklistDataCopy = Array.isArray(taskListObj.checklist) ? [...taskListObj.checklist] : [];
        this.page_details = { cycle_id: this.id, pagename: this.page_name, layout: this.tableHeadersfilter };

        this.$store.commit('tasks/SET_MANAGER_SUMMARY', taskListObj.summary?.manager || {});
        this.$store.commit('tasks/SET_PREPARER_SUMMARY', taskListObj.summary?.preparer || {});
        this.$store.commit('tasks/SET_APPROVER_SUMMARY', taskListObj.summary?.approver || {});

        this.filterListByUser(this.resolveInitialUserType());
        this.formateData();
        this.loading = false;
        this.applyUrlQueryFilters();
        return;
      }
      try {
        if (!this.isComponentActive) {
          return;
        }
        const taskListData = await this.$store.dispatch('tasks/getAllTasks', {
          checklistId: this.id,
          forceRefresh: force,
        });
        
        if (!this.isComponentActive) {
          return;
        }
        this.metadata = taskListData.metadata || {};
        
        this.filterListByUser(this.resolveInitialUserType());
        this.cycleType = (taskListData.checklist?.[0]?.cycle_type) || "FBC";
        this.checklist = taskListData.checklist || [];
        this.coaCategoryAcc = taskListData.coaCategoryAcc || [];
        this.coaSubcategoryAcc = taskListData.coaSubcategoryAcc || [];
        this.categoryAcc = taskListData.categoryAcc || [...this.coaCategoryAcc];
        this.subcategoryAcc = taskListData.subcategoryAcc || [...this.coaSubcategoryAcc];
        const customColumnSchema = taskListData.customColumnSchema || [];
        console.log('[loadTasklistData] customColumnSchema from store:', customColumnSchema.length, 'entries');
        const { localCustomColumns, taskMasterCustomColumns, tableHeadersfilter } = handleCustomColumnHeadersUtil(taskListData.customColumns, this.tableHeadersfilter, customColumnSchema);
        this.localCustomColumns = localCustomColumns;
        this.taskMasterCustomColumns = taskMasterCustomColumns;
        this.tableHeadersfilter = tableHeadersfilter;
        await this.getCustomLayout(force);
        this.page_details = { cycle_id: this.id, pagename: this.page_name, layout: this.tableHeadersfilter };

        this.tasklistDataCopy = Array.isArray(taskListData.checklist) ? [...taskListData.checklist] : [];
        this.$store.commit('tasks/SET_MANAGER_SUMMARY', taskListData.summary?.manager || {});
        this.$store.commit('tasks/SET_PREPARER_SUMMARY', taskListData.summary?.preparer || {});
        this.$store.commit('tasks/SET_APPROVER_SUMMARY', taskListData.summary?.approver || {});
        this.$store.commit('tasks/SET_LOCATION_LIST', taskListData.locationList || []);
        this.$store.commit('tasks/SET_USERS_LIST', taskListData.usersList || []);
      } catch (err) {
        this.$store.commit("sbError", err.message || err || "Unknown error!");
        console.error(err);
      } finally {
        if (this.isComponentActive) {
          // v3: statusDetails and __computed fields are already set by getAllTasks — no calculateDetails needed
          this.formateData();
          this.loading = false;
        }
        this.applyUrlQueryFilters();
      }
    },
    /**
     * Fetches distinct non-AR category/subcategory values across all cycles
     * and merges them with COA lists into categoryAcc/subcategoryAcc.
     */
    async fetchAndMergeCrossCycleCategories() {
      const { categoryAcc, subcategoryAcc } = await this.$store.dispatch('tasks/fetchMasterCategories', {
        cycleType: this.cycleType,
        level: 'cycle',
        coaCategoryAcc: this.coaCategoryAcc,
        coaSubcategoryAcc: this.coaSubcategoryAcc,
      });
      this.categoryAcc = categoryAcc;
      this.subcategoryAcc = subcategoryAcc;
    },
    // To get custom columns by cycle type
    // This function fetches custom columns based on the cycle type and formats them
    async getCustomColumnsByCycleType() {
      try {
        const customColumnsResponse = await this.axios.post('/v2/financialclose/masters/checklist/readColumn/',{query:{cycle_type:this.cycleType.toUpperCase(), deleted: false}});
          if (customColumnsResponse?.data?.status === 'success' && Array.isArray(customColumnsResponse?.data?.data) && customColumnsResponse?.data?.data.length > 0) {
           return formatCustomColumns(customColumnsResponse?.data?.data);
          }else{
           return []
          }
      } catch (err) {
        this.$store.commit("sbError", err?.message || err || "Failed to get custom columns by cycle type");
        console.error("Error fetching custom columns by cycle type:", err);}
      return [];  
      },
    getTaskDetails() {
      this.taskdeTailsDialog = true;
    },

    // calculateDetails — no longer needed with v3 (server-side computed __computed fields)
    // Kept as no-op for backward compatibility with any child component calls
    calculateDetails() {
      // v3: threshold, locationName, tbtotals, alltaskassigned are now in __computed per task
    },
    async getCustomLayout(force = false) {
      this.page_details = { cycle_id: this.id, pagename: this.page_name };
      this.custom_layout_success = false;

      try {
        // Fetch layout via Vuex action (caching is handled in the store)
        const layoutData = await this.$store.dispatch('tasks/fetchCustomLayout', {
          pageName: this.page_name,
          forceRefresh: force
        });
        this.custom_layout_success = true;

        if (layoutData?.custom_layout?.length > 0) {
          this.tableHeadersfilter = layoutData.custom_layout;
          // Validate filter keys against current headers before applying
          const rawFilter = layoutData.filter?.[this.id] || {};
          this.tableFilterHeader = this._validateFilterKeys(rawFilter);
        } else {
          this.tableHeadersfilter = JSON.parse(JSON.stringify(this.defaultTableHeadersfilter));
          this.tableFilterHeader = JSON.parse(JSON.stringify(this.defaultTableFilterHeader));
        }


        this.defaultCloneTableHeadersfilter = this.mergeColumns(
          this.defaultTableHeadersfilter,
          this.tableHeadersfilter
        );
        // Keep active headers aligned with defaults so newly added columns
        // (for example Purpose/Instruction) show up in Customize menu even
        // when the user has an older saved layout.
        this.tableHeadersfilter = JSON.parse(JSON.stringify(this.defaultCloneTableHeadersfilter));

        // Filter out invalid custom columns
        const customColumnNames = this.customColumns.map(c => c.columnName);
        this.tableHeadersfilter = this.tableHeadersfilter.filter(h => {
          const isCustom = String(h.value_en).startsWith(this.$constants.CUSTOM);
          return !isCustom || customColumnNames.includes(h.value);
        });

        // Add any new custom columns
        this.customColumns.forEach(col => {
          const exists = this.tableHeadersfilter.some(h =>
            h.value === col.columnName || h.value_en === `custom_${col.columnName}`
          );
          if (!exists) {
            this.tableHeadersfilter.push({
              value_en: `custom_${col.columnName}`,
              value: col.columnName,
              text: col.displayText,
              visible: true,
              filterable: true,
              sortable: true
            });
          }
        });

        // Move 'action' column to the end
        const actionIdx = this.tableHeadersfilter.findIndex(h => h.value === "action");
        if (actionIdx !== -1) {
          const [actionCol] = this.tableHeadersfilter.splice(actionIdx, 1);
          this.tableHeadersfilter.push(actionCol);
        }

      } catch (error) {
        console.error("[Tasklist] Error fetching custom layout:", error);
      }
    },
    // toglle multiselect items in table
    toggleSelectAll() {
      this.allRowsSelected = !this.allRowsSelected;
      if (this.allRowsSelected) {
        this.selectedRows = [...this.formatedChecklist];
      } else {
        this.selectedRows = [];
      }
    },
    // refresh data — loads all Tasklist APIs into Vuex on first load; toggles hydrate from store cache
    async refreshData(force = true) {
      if (!this.isComponentActive) {
        return;
      }
      this.id = this.$route.params.id || "";
      this.userid = this.$store.state.user.id;
      this.clientId = this.$store.state.client;
      if (!this.id) {
        console.warn('[Tasklist.vue] Route param id is missing. API call skipped.');
        this.loading = false;
        return;
      }

      if (force) {
        this.loading = true;
      }

      try {
        await this.$store.dispatch('tasks/ensureTasklistPageData', {
          checklistId: this.id,
          pageName: this.page_name,
          forceRefresh: force,
        });
        await this.fetchFormDataV3(false);
        await this.loadTasklistData(false);
      } catch (err) {
        console.error('[Tasklist] refreshData error:', err);
      } finally {
        if (this.isComponentActive) {
          this.loading = false;
        }
      }
      this.syncHorizonAfterDataLoad();
    },
    async fetchFormDataV3(force = false) {
      if (!this.isComponentActive) return;
      try {
        const formData = await this.$store.dispatch('tasks/fetchFormDataV3', { forceRefresh: force });
        if (!this.isComponentActive) return;
        if (formData) {
          const activeUsers = (formData.users || []).filter(u => u.isActive);
          this.$set(this.userDetails, 'activeUsers', activeUsers);
          this.$set(this.userDetails, 'activeUserIds', activeUsers.map(u => u._id).filter(Boolean));
        }
        this.enforceHorizonViewAccess();
      } catch (error) {
        console.error('[Tasklist] fetchFormDataV3 error:', error);
        this.$set(this.userDetails, 'activeUsers', []);
        this.$set(this.userDetails, 'activeUserIds', []);
      }
    },
    // viewtaskdetails
    viewTaskDetails(item) {
      this.viewtaskdata = { ...item };
      this.populatetblinkdialogitems(item, false);
      // v3: Read pre-computed info manager requests from __computed
      const infoReqs = item.__computed?.infoManagerRequests || [];
      this.viewtaskdata["linkedInformationReq"] = infoReqs;
      this.inforeqstage = infoReqs.length > 0
        ? (infoReqs.filter(r => r.stage === 2).length / infoReqs.length) * 100
        : 0;
      this.OpenBulkUploadBox(item);

      openTaskDetailPage({
        router: this.$router,
        store: this.$store,
        task: item,
        checklistId: this.id,
        userType: this.userType,
        tasklistView: this.isHorizonView ? HORIZON_VIEWS.HORIZON : HORIZON_VIEWS.LIST,
      });
    },

    // download ppt for all closed task
    downloadPPT() {
      if (!this.alltaskassigned)
        this.$store.commit(
          "sbError",
          "Assign all tasks before generating the PPT"
        );
      else if (this.alltaskopen)
        this.$store.commit("sbError", "No task closed to generate the PPT");
      else
        this.$nova.downloadFile(
          "",
          {},
          "/v2/financialclose/analysis/downloadppt/" + this.metadata._id
        );
    },
    // download excel
    downloadExcel() {
      // Build header row from tableHeadersfilter, exclude columns with type: 'action'
      const headers = this.tableHeadersfilter
        .filter(h => h.visible !== false && h.type !== "action")
        .map(h => ({
          text: h.text || h.label || h.displayText || h.value,
          value: h.value
        }));

      // Add Linked GLs column after __tbtotals if not already present
      const tbtotalsIndex = headers.findIndex(h => h.value === "__tbtotals");
      const hasLinkedGLs = headers.some(h => h.value === "linkedgl");
      if (tbtotalsIndex !== -1 && !hasLinkedGLs) {
        headers.splice(tbtotalsIndex + 1, 0, { text: "Linked GLs", value: "linkedgl" });
      }

      // Prepare the data rows with special logic for calculated columns
      const dataRows = this.processedTaskList.map(v => {
        return headers.map(h => {
          switch (h.value) {
            case "__tbtotals": // TB Amount
              return {
                v: ((v.__tbtotals || {}).total || 0).toFixed(0),
                z: "#,##",
                t: "n",
              };
            case "linkedgl": // Linked GLs - extract GL codes from __tbtotals
              return this.getLinkedGLsForExport(v);
            case "scheduleAmount": // Recon Amount
              return {
                v: this.calculateScheduleAmount(v),
                z: "#,##",
                t: "n",
              };
            case "explainedDifference": // Explained Difference
              return {
                v: this.calculateExplainedDifference(v),
                z: "#,##",
                t: "n",
              };
            case "difference": // Unexplained Difference
              return {
                v: this.calculateUnexplainedDifference(v),
                z: "#,##",
                t: "n",
              };
            case "duedate1": // Due date formatting
              return v.duedate ? this.$nova.formatDate(v.duedate) : "";
            case "locationName":
              return this.getLocationById(v.location);
            case "preparerids":
              return Array.isArray(v.preparerids) ? v.preparerids.join(", ") : (v.preparerids || "");
            case "approverids":
              return Array.isArray(v.approverids) ? v.approverids.join(", ") : (v.approverids || "");
            case "stage1": // Status column
              {
                const chip = this.getStageText(v.stage);
                return chip ? chip.text : "";
              }
            case "tags": // Tags - array handling
              return Array.isArray(v.tags) ? v.tags.join(", ") : (v.tags || "");
            case "created_at": // Created on - date formatting
              return v.created_at ? this.$nova.formatDate(v.created_at) : "";
            case "submited_on": // Submission date - date formatting
              return v.submited_on ? this.$nova.formatDate(v.submited_on) : "";
            case "closed_date": // Completion date - date formatting
              return v.closed_date ? this.$nova.formatDate(v.closed_date) : "";
            case "statusdetail": // Status detail - text representation
              {
                const statusConfig = this.getStatusConfig(v.statusdetail);
                return statusConfig ? statusConfig.text : (v.statusdetail || "");
              }
            case "no_of_evidence": // No. of evidences
              return v.no_of_evidence !== undefined ? v.no_of_evidence : 0;
            case "inforrequest": // Information request
              return v.inforrequest || "";
            case "task_type": // Task type
              return v.task_type || "";
            default:
              return v[h.value] !== undefined ? v[h.value] : "";
          }
        });
      });

      // Title section rows
      const titleRows = [
        [
          { v: "Tasklist Status Tracker", s: { font: { bold: true, sz: 20 } } },
        ],
        [
          { v: this.metadata.description, s: { font: { bold: true, sz: 14 } } },
        ],
        [
          {
            v:
              this.$nova.formatDate(this.metadata.from) +
              " - " +
              this.$nova.formatDate(this.metadata.to),
            s: { font: { bold: true, sz: 14 } },
          },
        ],
        [undefined],
      ];

      // Prepare the final array for Excel (title + header + data)
      const excelData = [
        ...titleRows,
        headers.map(h => ({ v: h.text, s: { font: { bold: true } } })),
        ...dataRows
      ];

      // Create and export the Excel file
      let workbook = styledxlsx.utils.book_new();
      let worksheet = styledxlsx.utils.aoa_to_sheet(excelData);
      styledxlsx.utils.book_append_sheet(workbook, worksheet, "Tasklist");
      styledxlsx.writeFile(workbook, (this.metadata.description || "Tasklist") + ".xlsx");
    },
    workpaperTemplate() {
      this.$nova.downloadFile(
        "",
        {},
        "/v2/financialclose/analysis/gettasklisttemplateV3" // TODO - update the url
      );
    },
    getEmailByIdsBulk(ids) {
      if (!Array.isArray(ids)) return "";
      return ids
        .map((id) => this.userMap[id]?.email || "")
        .filter(Boolean)
        .join(", ");
    },
    getNameByIds(ids) {
      for (const i of ids) {
        return this.userMap[i]?.name || "";
      }
    },

    getUserList(x) {
      if (!Array.isArray(x)) return "";
      return x
        .map(id => this.userMap[id]?.name || "")
        .filter(Boolean)
        .join(", ");
    },

    getStageText(x) {
      if (x === 0) return { text: "Pending Submission", color: "", class: "pending-sub-chip" };
      else if (x === 1) return { text: "Processing", color: "", class: "pending-approval-chip" };
      else if (x === 2) return { text: "Pending Approval", color: "", class: "pending-approval-chip" };
      else if (x === 3) return { text: "Approved", color: "", class: "closed-task-chip" };
      else if (x === -1) return { text: "Rejected", color: "lightred", class: "error--text cancelled-chip" };
      else return { text: "Unknown", color: "grey", class: "" };
    },
    getStatusText(x) {
      if (x === "pending_not_due") return "Pending Submission Not Due";
      else if (x === "pending_over_due") return "Pending Submission Overdue";
      else if (x === "pending_due") return "Pending Submission Due";
      else if (x === "pendingapproval_due") return "Pending Approval Due";
      else if (x === "pendingapproval_not_due")
        return "Pending Approval Not Due";
      else if (x === "pendingapproval_over_due")
        return "Pending Approval Overdue";
      else return "approved";
    },
    // delete any task in tasklist
    deleteChecklistItem(item) {
      let url =
        "/v2/financialclose/analysis/deletechecklist/" +
        this.id +
        "/c/" +
        item._id;
      this.axios
        .post(url, {})
        .then((dt) => {
          if (dt.data.status === "success") {
            this.$store.commit("sbSuccess", "Tasklist item deleted");
            this.refreshData();
          } else throw Error(dt.data.message || "Unknown error");
        })
        .catch((err) => {
          this.$store.commit("sbError", err.message || err || "Unknown error!");
          console.log(err);
        })
        .finally(() => {});
    },
    // link bot for ahy single task
    async linkBot() {
      if (!this.selectedbot || !this.addeditdata._id) {
        this.$store.commit("sbError", "Please select an " + this.constants.BOT_NAME + "and task.");
        return;
      }

      // Build the data object dynamically
      let dataObj = {
        botid: this.botSelecetedId,
        task_id: this.addeditdata._id,
        bot_result_tags: [],
      };
      if (this.selectedbot === "Lease Schedule") {
        dataObj.bot_result_tags = this.leaseScheduleValue;
      }
      if (this.selectedbot === "Transaction Matching") {
        dataObj.tmaid = this.selectedTransactionMatching;
      }
      const data = { data: [dataObj] };
      this.linkbotloading = true;
      const url = "/v2/financialclose/analysis/linkbot/" + this.id;
      await this.axios
        .post(url, data)
        .then((dt) => {
          if (dt.data.status === "success") {
            this.$store.commit("sbSuccess", this.$constants.BOT_NAME + " Linked");
            this.refreshData();
            this.linkbotdialog = false;
            this.selectedbot = "";
            this.botSelecetedId = "";
            this.selectedTransactionMatching = "";
            this.leaseScheduleValue = [];
          } else {
            throw new Error(dt.data.message || "Unknown error");
          }
        })
        .catch((err) => {
          this.$store.commit("sbError", err.message || err || "Unknown error!");
          console.error(err);
        })
        .finally(() => {
          this.linkbotloading = false;
        });
    },
    // link bot for multi selected task
    async bulklinkBot() {
      try {
        this.bulklinkbotloading = true;
        let successMessageSent = false;
        const url = "/v2/financialclose/analysis/linkbot/" + this.id;
        const requests = Object.keys(this.addeditdata).map(async (key) => {
          const value = this.addeditdata[key];
          const response = await this.axios.post(url, {
            data: [
              {
                botid: this.selectedbot,
                task_id: value,
                bot_result_tags: this.leaseSchedulebulkValue[value],
              },
            ],
          });
          if (response.data.status === "success" && !successMessageSent) {
            this.$store.commit("sbSuccess", `Bulk ${this.$constants.BOT_NAME} Linked`);
            successMessageSent = true;
            this.bulklinkbotdialog = false;
            this.leaseSchedulebulkValue = {};
            // this.checklist[this.addeditdata.__key].botid = this.selectedbot;
            this.selectedbot = "";
            this.calculateDetails();
            this.refreshData();
            this.bulklinkbotloading = false;
          } else {
            throw Error(response.data.message || "Unknown error");
          }
        });
        await Promise.all(requests);
      } catch (err) {
        //this.$store.commit("sbError", err.message || err || "Unknown error!");
        console.error(err);
      } finally {
        this.bulklinkbotloading = false;
      }
    },
    // unlink bot for single task
    async unlinkBot(v) {
      this.loading = true;
      const url = `/v2/financialclose/analysis/unlinkbot/${this.id}`;
      const data = { task_id: v._id };

      try {
        const response = await this.axios.post(url, { data: [data] });
        if (response.data.status === "success") {
          this.$store.commit("sbSuccess", this.$constants.BOT_NAME + " Unlinked");
          this.refreshData();
        } else {
          throw new Error(response.data.message || "Unknown error");
        }
      } catch (err) {
        this.$store.commit("sbError", err.message || err || "Unknown error!");
        console.error(err);
      } finally {
        this.loading = false;
      }
    },
    // unlink bot for bulk task
    bulkEdit() {
      this.bulkEditDialog = true;
      this.clearfileBulk();
    },
    bulkunlinkBot(v) {
      this.loading = true;
      let url = "/v2/financialclose/analysis/unlinkbot/" + this.id;
      this.axios
        .post(url, { data: [v] })
        .then((dt) => {
          if (dt.data.status === "success") {
            this.$store.commit("sbSuccess", this.$constants.BOT_NAME + " Unlinked");
            //  this.checklist[v.__key].botid  = "";
            this.selectedbot = "";
            this.calculateDetails();
            this.refreshData();
            this.loading = false;
          } else throw Error(dt.data.message || "Unknown error");
        })
        .catch((err) => {
          this.$store.commit("sbError", err.message || err || "Unknown error!");
          console.log(err);
        })
        .finally(() => {
          this.loading = false;
        });
    },
    bulkUpdatedueDate(item) {
      this.updatebulkduedate = "";
      this.bulkDueDateNote = "";
      this.bulkduedatedialog = true;
      this.bulkduedateloading = false;
      console.log(item);
    },
    openBulkThresholdDialog() {
      this.bulkSkipValidation = false;
      this.bulkThresholdDialog = true;
    },
    async bulkUpdateThresholdEnforcement() {
      if (this.selectItem.length === 0) return;
      this.bulkThresholdLoading = true;
      try {
        const result = await this.$store.dispatch('tasks/bulkUpdateSkipValidations', {
          cycleId: this.id,
          taskIds: this.selectItem.map(item => item._id),
          skipValidations: this.bulkSkipValidation,
          client: this.$store.state.client,
        });
        if (result.success) {
          this.bulkThresholdDialog = false;
          this.refreshData();
        }
      } finally {
        this.bulkThresholdLoading = false;
      }
    },
    async bulkduedateFun(selecteditem, date, note = '') {
      // Validate Due Date is within allowed range
      if (date) {
        const dueDateResult = validateDueDateRange(date, MAX_DUE_DATE_DAYS);
        if (!dueDateResult.valid) {
          this.$store.commit('sbError', dueDateResult.error);
          return;
        }
      }
      this.bulkduedateloading = true;
      this.loading = true;
      try {
        const result = await this.$store.dispatch('tasks/bulkUpdateDueDate', {
          cycleId: this.id,
          taskIds: selecteditem.map((item) => item._id),
          duedate: date,
          note: note || undefined,
        });
        if (result.success) {
          this.selectItem = [];
          this.bulkduedatedialog = false;
          this.refreshData();
        }
      } finally {
        this.bulkduedateloading = false;
        this.loading = false;
      }
    },
    // tb amount amount calculation for table
    populatetblinkdialogitems(data = {}, opendialog = true) {
      this.tblinkdialogitems = [];
      this.tblinkdialogitems = (data.__tbtotals || {})?.items || [];
      this.tblinkdialogchecklistdata = data;
      if (opendialog) this.tblinkdialog = true;
    },

    // On open bulkupload add filelist
    async OpenBulkUploadBox(dt) {
      if (dt.upload) {
        if ((dt.stage === 2 || dt.stage === 3) && dt.upload) {
          await this.axios
            .post("/v2/upload/filenames/" + dt?.upload)
            .then((dt) => {
              this.fileNamesList = dt.data.data;
            })
            .catch((err) => {
              this.$store.commit(
                "sbError",
                err.message || err || "Unknown error!"
              );
              console.log(err);
            });
        }
      } else {
        this.fileNamesList = [];
      }
    },
    // change user type
    overDueDateFun() {
      this.overDueDate = !this.overDueDate;
    },
    redirectChatBot(){
      
      this.$store.commit('chatbot/SET_PROJECT', this.id);
      // Open chatbot as overlay instead of navigating to route
      this.$root.toggleChatbot?.();
    },
    filterListByUser(user) {
      this.userType = user;
      this.$store.commit('setTasklistUserType', user);
      this.syncUserTypeQueryParam(user);
      this.syncHorizonViewUserType(user);
      this.selectItem = [];

      const visibility = USER_TYPE_HEADER_VISIBILITY[user] || USER_TYPE_HEADER_VISIBILITY.manager;
      for (const header of this.tableHeadersfilter) {
        if (header.value in visibility) {
          header.visible = visibility[header.value];
        }
      }

      if (user === 'approver') this.summaryData = this.approversummary;
      else if (user === 'preparer') this.summaryData = this.preparersummary;
      else this.summaryData = this.managersummary;
    },
    // add header
    // addTableHeader(item) {
    //     this.tableHeaders.find((x) => x === item ? x.visible = !x.visible : "")
    // },
    addTableHeader(item) {
      // this.tableHeadersfilter.find((x) =>
      //   x === item ? (x.visible = !x.visible) : ""
      // );
      this.tableHeadersfilter.find((x) =>
        x === item ? (x.visible = !x.visible) : ""
      );
      
    },
    select(isSelected) {
      if (isSelected) {
        this.selectItem = [...this.filterbysearch];
      } else {
        this.selectItem = [];
      }
    },
    getItemData(item, key) {
      return item[key];
    },
    setPaginatedData(paginationInfo) {
      if (paginationInfo && typeof paginationInfo === 'object' && 'data' in paginationInfo) {
        this.paginatedFilteredItems = paginationInfo.data || [];
        this.page = paginationInfo.page || 1;
      } else {
        this.paginatedFilteredItems = paginationInfo || [];
      }
    },
    getLocationById(id) {
      let locationname = this.locationList?.find(
        (location) => location._id === id
      );
      return locationname?.name || "";
    },
    getNameById(id) {
      return this.userMap[id]?.name || "";
    },

    // edit task
    addEditForm(dt = {}) {
      this.isEditMode = true;
      this.originalTaskType = dt?.task_type;
      this.addeditdataerror = {};
      const baseModel = {
        description: '',
        category: '',
        subcategory: '',
        task_type: '',
        priority: '',
        location: '',
        preparer: [],
        approver: [],
        no_of_evidence: 0,
        tags: [],
        assertions: [],
        purpose: '',
        instruction: '',
        remark: '',
        glcode: [],
        __tbtotals: { items: [] },
        __tblinks: [],
        customfields: [],
        threshold: '',
      };
      const incoming = JSON.parse(JSON.stringify(dt || {}));
      const toArray = v => Array.isArray(v) ? v : (v ? [v] : []);
      incoming.preparer = toArray(incoming.preparer);
      incoming.approver = toArray(incoming.approver);
      incoming.tags = toArray(incoming.tags);
      incoming.assertions = toArray(incoming.assertions);
      if (!incoming.__tbtotals || !Array.isArray(incoming.__tbtotals.items)) incoming.__tbtotals = { items: [] };
      if (!Array.isArray(incoming.glcode)) incoming.glcode = [];
      if (!Array.isArray(incoming.customfields)) incoming.customfields = [];
      this.addeditdata = { ...baseModel, ...incoming };

      // Always sync selectgls from __tbtotals.items (glcodes for display consistency with TaskGLSelection)
      if (Array.isArray(this.addeditdata.__tbtotals?.items) && this.addeditdata.__tbtotals.items.length > 0) {
        this.selectgls = this.addeditdata.__tbtotals.items.map(gl => String(gl.glcode));
        this.addeditdata.__tblinks = this.addeditdata.__tbtotals.items.map(gl => String(gl._id));
      } else if (Array.isArray(this.addeditdata.__tblinks) && this.addeditdata.__tblinks.length > 0) {
        this.selectgls = [...this.addeditdata.__tblinks];
      } else if (Array.isArray(this.addeditdata.glcode) && this.addeditdata.glcode.length > 0) {
        this.selectgls = [...this.addeditdata.glcode];
        this.addeditdata.__tblinks = [...this.selectgls];
      } else {
        this.selectgls = [];
        this.addeditdata.__tblinks = [];
      }

      this.isLocationSelected = false;
      if (dt.location && dt.approver && dt.preparer) {
        this.showlocationanduser = true;
      }
      this.populatetblinkdialogitems(dt, false);
      this.addeditdialog = true;
    },
    finaluserlist() {
      let nl = [];
      for (const i of this.metadata.managerlist) {
        let ud = { ...this.userlist[i] };
        ud.type = "manager";
        ud._id = this.userlist[i]._id;
        ud.name = this.userlist[i].name;
        nl.push(ud);
      }
      for (const i of this.metadata.userlist) {
        let ud = { ...this.userlist[i] };
        ud.type = "general";
        ud._id = this.userlist[i]._id;
        ud.name = this.userlist[i].name;
        nl.push(ud);
      }
      return nl;
    },

    // Unified validation similar to the sample you provided
    validateTaskFields() {
      // Reset errors
      this.addeditdataerror = {};

      const d = this.addeditdata || {};
      const e = this.addeditdataerror;

      // Helper to set required error (array form for existing components)
      const req = (key, msg) => { e[key] = [msg || 'required']; };

      // Core required fields (UI shows *):
      const EM = this.$constants.TASK_LIST_CONSTANTS.ERROR_MESSAGES;
      if (!d.description || !String(d.description).trim()) req('description', EM.TASK_DESCRIPTION_REQUIRED);
      if (!d.category) req('category', EM.CATEGORY_REQUIRED);
      if (!d.subcategory) req('subcategory', EM.SUBCATEGORY_REQUIRED);
      if (!d.task_type) req('task_type', EM.TASK_TYPE_REQUIRED);
      if (!d.priority) req('priority', EM.PRIORITY_REQUIRED);

      // Location + preparer + approver group
      const preparerArr = Array.isArray(d.preparer) ? d.preparer : (d.preparer ? [d.preparer] : []);
      const approverArr = Array.isArray(d.approver) ? d.approver : (d.approver ? [d.approver] : []);
      if (!d.location) req('location_users', EM.LOCATION_REQUIRED);
      if (!preparerArr.length) req('location_users', EM.PREPARER_REQUIRED);
      if (!approverArr.length) req('location_users', EM.APPROVER_REQUIRED);

      // Due date validation
      if (!d.duedate) {
        req('duedate', EM.DUE_DATE_REQUIRED || 'Due Date is required');
      } else {
        const dueDateResult = validateDueDateRange(d.duedate, MAX_DUE_DATE_DAYS);
        if (!dueDateResult.valid) {
          req('duedate', dueDateResult.error);
        }
      }

      // Optional: No. of evidences (include if you want strict)
      // If you want them mandatory uncomment below lines
      // if (d.no_of_evidence === undefined || d.no_of_evidence === null || d.no_of_evidence === '') req('no_of_evidence', 'No. of Evidences is required');

      // Custom columns (if flagged isRequired)
      if (Array.isArray(this.customColumns)) {
        this.customColumns.forEach(col => {
          if (col.isRequired && (d[col.columnName] === undefined || d[col.columnName] === null || d[col.columnName] === '')) {
            req(col.columnName, `${col.displayText} is required`);
          }
        });
      }

      // Preparer & Approver uniqueness (no overlap)
      if (preparerArr.length && approverArr.length) {
        const overlap = preparerArr.filter(x => approverArr.includes(x));
        if (overlap.length) {
          req('location_users', EM.PREPARER_APPROVER_OVERLAP);
        }
      }

      // For Account Reconciliation task type, GL codes required; for Normal they must not exist.
      if (d.task_type === this.$constants.TASK_LIST_CONSTANTS.TASK_TYPES.ACCOUNT_RECONCILIATION) {
        if (!(this.selectgls && this.selectgls.length)) {
          req('glcode', EM.GL_REQUIRED_RECON || EM.GL_CODE_REQUIRED);
        }
        // AR COA membership check
        if (d.category && !this.coaCategoryAcc.includes(d.category)) {
          req('category', EM.CATEGORY_NOT_FROM_COA);
        }
        if (d.subcategory && !this.coaSubcategoryAcc.includes(d.subcategory)) {
          req('subcategory', EM.SUBCATEGORY_NOT_FROM_COA);
        }
      } else if (d.task_type === this.$constants.TASK_LIST_CONSTANTS.TASK_TYPES.NORMAL) {
        if (this.selectgls && this.selectgls.length) {
          req('glcode', EM.GL_NOT_ALLOWED_NORMAL);
        }
      }

      return Object.keys(this.addeditdataerror).length === 0;
    },

    // edit task update api
    async addEditChecklistItem() {
      this.addeditloading = true;
      // Run unified validation
      if (!this.validateTaskFields()) {
        this.$store.commit('sbError', 'Please fill all mandatory fields');
        this.addeditloading = false;
        return;
      }

      try {
        // Build selectglsLocal (ObjectIDs) from addeditdata.__tblinks (set by TaskGLSelection)
        let selectglsLocal = [];
        if (this.addeditdata.task_type === this.$constants.TASK_LIST_CONSTANTS.TASK_TYPES.ACCOUNT_RECONCILIATION) {
          if (Array.isArray(this.addeditdata.__tblinks) && this.addeditdata.__tblinks.length > 0) {
            selectglsLocal = [...this.addeditdata.__tblinks];
          } else if (Array.isArray(this.addeditdata.__tbtotals?.items) && this.addeditdata.__tbtotals.items.length > 0) {
            selectglsLocal = this.addeditdata.__tbtotals.items.map(gl => String(gl._id));
          }
        }

        const payload = {
          addeditdata: { ...this.addeditdata },
          customColumns: this.customColumns,
          selectglsLocal,
          projectId: this.id,
        };

        const result = await this.$store.dispatch('tasks/addEditChecklistItem', payload);
        if (result && result.success) {
          this.$store.commit('sbSuccess', result.isEdit ? 'Tasklist item updated' : 'Tasklist item added');
          this.addeditdialog = false;
          this.selectgls = [];
          this.searchcustomfilter = "";
          this.viewtaskdialog = false;
          this.refreshData();
        } else {
          if (result && result.data && result.data.index0) {
            this.addeditdataerror = result.data.index0;
          } else {
            this.$store.commit('sbError', result?.errorMessage || 'Unknown error!');
          }
        }
      } catch (err) {
        this.$store.commit('sbError', err.message || err || 'Unknown error!');
        console.error('[Tasklist]: addEditChecklistItem error', err);
      } finally {
        this.addeditloading = false;
      }
    },
    filterWithTask(x) {
      this.selectedTabStage = x;
    },
    customStageOrder(arr) {
      const stageOrder = [2, 0, 3];
      return arr.sort((a, b) => {
        const aIndex = stageOrder.indexOf(a.stage);
        const bIndex = stageOrder.indexOf(b.stage);
        if (aIndex === -1) return 1;
        if (bIndex === -1) return -1;
        return aIndex - bIndex;
      });
    },
    bulklocationActions() {
      this.$refs.bulkmenu.isActive = false;
      this.bulkactions = 0;
    },
    getConversation(task) {
      this.axios
        .post(
          "/v2/financialclose/analysis/getconversation/" +
            this.metadata._id +
            "/c/" +
            task._id
        )
        .then((dt) => {
          if (dt.data.status === "success") {
            this.conversationList = dt.data.data;
            // if (mark) this.markAsRead();
          } else throw Error(dt.data.message || "Unknown error");
        })
        .catch((err) => {
          this.$store.commit("sbError", err.message || err || "Unknown error!");
          console.log(err);
        })
        .finally(() => {
          // this.scrollToBottom();

          const chatContainer = this.$refs.chatContainer;
          if (chatContainer) {
            chatContainer.scrollTop = chatContainer?.scrollHeight;
          }
        });
    },

    sendQuery(task) {
      if (this.queryMsg) {
        // this.loading = true;
        let dataObject = {
          type: "string",
          value: this.queryMsg,
          status: "",
        };
        let successflag = false;
        this.axios
          .post(
            "/v2/financialclose/analysis/addconversation/" +
              this.metadata._id +
              "/c/" +
              task._id,
            { data: dataObject }
          )
          .then((dt) => {
            if (dt.data.status === "success") {
              successflag = true;
              // this.$store.commit("sbSuccess", "successfully sended");
              this.queryMsg = "";
            } else throw Error(dt.data.message || "Unknown error");
          })
          .catch((err) => {
            this.$store.commit(
              "sbError",
              err.message || err || "Unknown error!"
            );
            console.log(err);
          })
          .finally(() => {
            // this.loading = false;
            if (successflag) this.getConversation(task);
          });
      }
    },
    handleOpenUploadDrawer() {
      // Set addeditdata to the current row/task before opening drawer
      let args = arguments;
      if (args && args[0]) {
        this.addeditdata = { ...args[0] };
      }
      this.showUploadDrawer = true;
    },
    openBulkUpload(task) {
  // Open TaskUploadModal instead of lb-drawer
  this.showUploadDrawer = true;
  this.addeditdata = { ...task };
    },
    clearfileBulk(){
      this.resetbulkEditFile = !this.resetbulkEditFile;
      this.bulkEditFileDataList = [];
      this.bulkEditFileDataerror = false;
      this.dataerroreditBulk = [];
      this.errorsonlyEditBulk = [];
      this.bulkEditErrorResponse = [];
    },
    clearfile() {
      this.resetFlag = !this.resetFlag;
      this.file = [];
      this.fileuplaoded = [];
      (this.uploaddata = []),
        (this.showdatawitherror = false),
        (this.dataerror = []),
        (this.flag = false),
        (this.file = null);
        this.checkListErrorResponse = '';
    },

    FilesUpload(filesss) {
      // Only store files, always assign a new array reference for reactivity
      this.fileuplaoded = Array.isArray(filesss) ? [...filesss] : [];
    },

    async uploadFiles(id) {
      let files = this.fileuplaoded;
      this.sendforreviewloading = true;
      // Validate files before upload
      if (Array.isArray(files) && files.length > 0) {
        // Only allow files that start with 'reco_'
        const validFiles = files.filter((file) => file.name.startsWith("reco_"));
        if (validFiles.length === 0) {
          this.$store.commit("sbError", "No valid files selected. File name must start with 'reco_'.");
          this.sendforreviewloading = false;
          return;
        }
        // Validate headers for each file
        for (const file of validFiles) {
          let ext = ((file || {}).name || "").split(".").pop();
          if (["xlsx", "xls", "xlsm", "xlsb"].indexOf(ext) === -1) {
            this.$store.commit("sbError", `File '${file.name}' has unsupported extension. Only xlsx, xls, xlsm, xlsb are allowed.`);
            this.sendforreviewloading = false;
            return;
          }
          let dt = await this.$nova.readExcelFile(file, "TOP SHEET");
          let headings = [
            "Task No ",
            "Task description",
            "Location",
            "Particulars",
            "Amount",
            "File Reference",
            "Type"
          ];
          let headingsConsolidated = [
            "Task No",
            "Task description (Optional)",
            "Location",
            "Particulars",
            "Amount",
            "File Reference (Optional)",
            "Type",
            "Standalone Entity (refer # 11 in Instructions)",
            "GL (refer # 12 in Instructions)"
          ];
          if (
            JSON.stringify(dt[0] || []) !== JSON.stringify(headings) &&
            JSON.stringify(dt[0] || []) !== JSON.stringify(headingsConsolidated)
          ) {
            this.$store.commit("sbError", `File '${file.name}' is missing required columns or they are not in the correct order.`);
            this.sendforreviewloading = false;
            return;
          }
        }
        // If all files are valid, proceed to upload
        let arrayPush = [];
        const uploadPromises = validFiles.map(async (file) => {
          try {
            let dt = await this.$nova.uploadFile(this.axios, file, {});
            arrayPush.push(dt);
          } catch (err) {
            this.fileprocessing[id] = 0;
            this.$store.commit("sbError", err.message || err || "Unknown error!");
            console.error(err);
          }
        });
        await Promise.all(uploadPromises);
        if (arrayPush.some((response) => response.data.status === "success")) {
          this.dataArray = arrayPush.flatMap((response) =>
            response.data.data.map((item) => {
              return {
                filename: item.uploadname,
                file_id: item._id,
                file_path: item.path,
              };
            })
          );
          // this.fileprocessing[id] = 2;

          // Rest of your code...
          let data = {
            upload: this.dataArray,
            project: this.id,
            checklist: this.viewtaskdata,
            bulkupload: false,
          };
          // Continue with the post request
          try {
            let response = await this.axios.post(
              "/v2/financialclose/analysis/storeworkpaper",
              {
                data: [data],
              }
            );

            if (response.data.status === "success") {
              this.$store.commit("sbSuccess", "File uploaded");
              this.refreshData();
              // this.fileprocessing[id] = 0;
              // this.sendforreviewdata.stage = 1;
              // this.checklist[this.sendforreviewdata.__key] = {
              //     ...this.sendforreviewdata
              // };
              this.sendforreviewdrawer = false;
            } else {
              throw new Error(
                response?.data?.message || "Error uploading file"
              );
            }
          } catch (axiosError) {
            // this.fileprocessing[id] = 0;
            this.$store.commit(
              "sbError",
              axiosError.message || axiosError || "Unknown error!"
            );
            console.error(axiosError);
          } finally {
            // Reset file and loading states
            this.files = {};
            // this.refreshData();
            this.sendforreviewloading = false;
          }
        } else {
          // this.fileprocessing[id] = 0;
          this.$store.commit("sbError", "Unable to upload file");
          // this.sendforreviewloading = false
        }
      } else {
        this.sendforreviewloading = false;
        this.$store.commit("sbError", "No files to upload");
        this.sendforreviewloading = false;
      }
    },

    async uploadFilesBulk() {
      let files = this.fileuplaoded;
      this.sendforreviewloadingbulk = true;
      // let taskIds=  this.selectItem.length>0 ? this.selectItem : [this.viewtaskdata];
      this.log = 0;
      try {
        let totalSize = 0;
        let dataArrayList = [];
        if (Array.isArray(files) && files.length > 0) {
          files.forEach((file) => {
            if (file.name) {
              totalSize += file.size;
            }
          });
          if (totalSize > 50 * 1024 * 1024) {
            this.$store.commit(
              "sbError",
              "Total file size exceeds the limit (50 MB)"
            );
            return;
          }
          this.sendforreviewloadingbulk = true;
          const uploadPromises = files.map(async (file) => {
            if (file.name) {
              try {
                let response = await this.$nova.uploadFile(
                  this.axios,
                  file,
                  {}
                );
                dataArrayList.push(response);
              } catch (uploadError) {
                this.$store.commit(
                  "sbError",
                  uploadError.message || "Error uploading file"
                );
                console.error(uploadError);
              }
            }
          });
          this.bulkfilesloading = 0;
          await Promise.all(uploadPromises);
          if (
            dataArrayList.some((response) => response.data.status === "success")
          ) {
            this.dataArray = dataArrayList.flatMap((item) =>
              item.data.data.flatMap((item) => {
                return {
                  filename: item.uploadname,
                  file_id: item._id,
                  file_path: item.path,
                };
              })
            );
            let data = {
              bulkupload: true,
              upload: this.dataArray,
              project: this.id,
              checklist:
                this.selectItem.length > 0
                  ? this.selectItem
                  : [this.viewtaskdata],
              removelocalfile: false,
            };
            try {
              this.bulkfilesloading = 0;
              let response = await this.axios.post(
                "/v2/financialclose/analysis/bulkStoreWorkPaper",
                { data: [data] }
              );
              if (response.data.status === "success") {
                this.$store.commit("sbSuccess", "File uploaded");
                this.bulkworkpaperupload = false;
                this.bulkfilesloading = 1;
                // if (index === (this.selectItem.length - 1)) {
                // }
                this.sendForReviewDialogbulk = false;
                this.sendforreviewdrawer = false;
                this.refreshData();
              } else {
                throw new Error(
                  response?.data?.message || "Error Uploading File"
                );
              }
            } catch (axiosError) {
              this.filesbulk = {};
              this.clearuploadfiledata = true;
              this.$store.commit(
                "sbError",
                axiosError.message || "Unknown error!"
              );
            }

            this.sendforreviewloadingbulk = false;
          } else {
            this.$store.commit("sbError", "Unable to upload file ");
            this.sendforreviewloadingbulk = false;
          }
        } else {
          this.$store.commit("sbError", "No files to upload");
          this.sendforreviewloadingbulk = false;
        }
      } catch (error) {
        console.error(error);
      } finally {
        this.sendforreviewloadingbulk = false;
        this.filesbulk = {};
        this.bulkfilesloading = 1;
        this.clearuploadfiledata = true;
        this.sendforreviewdialogbulk = false;
        this.refreshData();
      }
      this.resetFlag = !this.resetFlag;
    },

    togglePreparer(id) {
      if (!("preparer" in this.addeditdata)) {
        this.$set(this.addeditdata, "preparer", []);
      }
      const index = this.addeditdata.preparer.indexOf(id);
      if (index === -1) {
        this.addeditdata.preparer.push(id);
      } else {
        this.addeditdata.preparer.splice(index, 1);
      }
    },

    toggleApprover(id) {
      if (!("approver" in this.addeditdata)) {
        this.$set(this.addeditdata, "approver", []);
      }
      const index = this.addeditdata.approver.indexOf(id);
      if (index === -1) {
        this.addeditdata.approver.push(id);
      } else {
        this.addeditdata.approver.splice(index, 1);
      }
    },
    bulkopenlinkBotDialog: function (d) {
      this.addeditdata = { ...d };
      this.selectedbot = this.addeditdata.botid;
      this.bulklinkbotdialog = true;
      this.leaseScheduleValue = [];
    },

    gettaskdetails(id) {
      return this.tasklistData.find((item) => item._id === id._id);
    },
    bulkActionUserdilog(type) {
      this.isLocation = false;
      this.selectaction = "";

      this.bulkActionUser(type);
    },
    bulkActionUser(type) {
  // Only show users assigned as preparer/approver in selected tasks
  this.possibleUsers = [];
  if (!type) return;

  // if (type ==='add') {
    
  // }
  let userSet = new Set();
  if (type === "preparer" || type === "Preparer") {
    this.bulkActionUserType  = "Preparer";
    this.selectItem.forEach(task => {
      (task.preparer || []).forEach(uid => userSet.add(uid));
    });
  } else if (type === "approver" || type === "Approver") {
    this.bulkActionUserType  = "Approver";
    this.selectItem.forEach(task => {
      (task.approver || []).forEach(uid => userSet.add(uid));
    });
  }

  // Map user IDs to user objects
  this.possibleUsers = [...userSet].map(id => this.userMap[id]).filter(Boolean);
  this.bulkactionuserdialog = true;
},
    actionselection(select, type) {
      if (select === "remove") {
        this.bulkactionuserselected = true;
        this.bulkActionUser(type);
      } else {
        this.bulkActionUser(type);
      }
    },
    bulkManageUser(action, usertype, userid, selectitems, changeuserid) {    
      let ndt = {};
      if (usertype === "Location") {
        if (userid === "") {
          throw new Error("Please select location");
        }
      }
      if (action === "replace") {
        ndt = { fromuserid: userid, touserid: changeuserid, type: action };
      } else {
        ndt = {
          userid: userid,
          usertype: (usertype || "").toLowerCase(),
          type: action,
        };
      }
      let fdt = { type: "checklist", _id: selectitems.map((item) => item._id) };

      let successflag = false;
      this.axios
        .post(
          "/v2/financialclose/analysis/bulkmanageuser/" + this.metadata._id,
          { data: [ndt], filter: fdt }
        )
        .then((dt) => {
          if (dt.data.status === "success") {
            this.bulkactionuserdialog = false;
            let successMessage = "";
            if (action === "associate") successMessage = "User Added";
            else if (action === "remove") successMessage = "User Removed";
            else if (action === "move")
              successMessage = "Change to " + usertype;
            else if (action === "replace") successMessage = "User Replaced";
            this.$store.commit("sbSuccess", successMessage);
            this.changetouser = "";
            successflag = true;
            this.selectItem = [];
          } else {
            throw new Error(dt.data.message || "Error changing status");
          }
        })
        .catch((err) => {
          this.$store.commit("sbError", err.message || err || "Unknown error!");
        })
        .finally(() => {
          this.bulkactionuserloading = false;
          if (successflag) this.refreshData();
        });
    },
    /**
     * Bulk download files from selected tasks
     * Uses extractFileIdsFromTask utility for backward compatibility with upload and upload_v2
     * @param {Array} items - Array of selected task items
     */
    downloadbbulk(items) {
      if (!Array.isArray(items) || items.length === 0) {
        this.$store.commit('sbError', 'No tasks selected for download');
        return;
      }

      // Collect file IDs from all selected tasks using utility function
      const fileIds = items.flatMap(task => extractFileIdsFromTask(task));
      
      // Remove duplicates
      const uniqueFileIds = [...new Set(fileIds)];

      if (uniqueFileIds.length === 0) {
        this.$store.commit('sbError', 'No files available to download');
        return;
      }

      this.$nova.downloadFiles(uniqueFileIds);
    },
    /**
     * Download files from a single task
     * Uses extractFileIdsFromTask utility for backward compatibility
     * @param {Object} task - Task object
     */
    downloadSingleTaskFiles(task) {
      const fileIds = extractFileIdsFromTask(task);
      
      if (fileIds.length === 0) {
        this.$store.commit('sbError', 'No files available to download');
        return;
      }

      this.$nova.downloadFiles(fileIds);
    },
    changeChecklistStatus(analysis, type) {
      let idtxt = analysis;
      let data = { type: type };

      if (Array.isArray(analysis)) {
        const eligibleTasks = analysis.filter((item) => !this.isClosedTask(item));
        const skippedCount = analysis.length - eligibleTasks.length;

        if (eligibleTasks.length === 0) {
          this.$store.commit('sbError', 'Approved tasks cannot be modified');
          return;
        }

        if (skippedCount > 0) {
          this.$store.commit(
            'sbWarning',
            `${skippedCount} approved task${skippedCount === 1 ? '' : 's'} excluded from this action`
          );
        }

        idtxt = 'bulk';
        data.checklist = eligibleTasks.map((item) => item._id);
      } else {
        const task = this.masterTaskList.find((t) => t._id === analysis);
        if (task && this.isClosedTask(task)) {
          this.$store.commit('sbError', 'Approved tasks cannot be modified');
          return;
        }
      }

      this.loading = true;
      this.axios
        .post(
          "/v2/financialclose/analysis/changecheckliststage/" +
            this.metadata._id +
            "/a/" +
            idtxt,
          { data: [data] }
        )
        .then((dt) => {
          if (dt.data.status === "success") {
            this.$store.commit("sbSuccess", "Status Updated");
            this.refreshData();
          } else throw dt.data.message || "Error changing status";
        })
        .catch((err) => {
          this.$store.commit("sbError", err.message || err || "Unknown error!");
          console.log(err);
        })
        .finally(() => {
          this.loading = false;
        });
    },
    openHelpdeskDialog(d) {
      this.helpdeskitem = { ...d };
      this.helpdeskdialog = true;
      this.helpdeskitemnew = false;
      let url =
        "/v2/financialclose/analysis/getexistingtickets/" +
        this.metadata._id +
        "/c/" +
        this.helpdeskitem._id;
      this.axios
        .post(url)
        .then((dt) => {
          if (dt.data.status === "success") {
            this.helpdeskitem.__existingtickets = dt.data.data || [];
            if ((this.helpdeskitem.__existingtickets || []).length === 0)
              this.helpdeskitemnew = true;
          } else throw Error(dt.data.message || "Unknown error");
        })
        .catch((err) => {
          this.$store.commit("sbError", err.message || err || "Unknown error!");
          console.log(err);
        })
        .finally(() => {});
    },
    addHelpdeskQuery() {
      let ndt = {
        issue: this.helpdeskitem.description,
        description: this.helpdeskitem.__ticketdescripton,
        modulename: this.$route.meta.modulename,
      };
      let url =
        "/v2/financialclose/analysis/addfunctionalquery/" +
        this.metadata._id +
        "/c/" +
        this.helpdeskitem._id;
      this.axios
        .post(url, { data: ndt })
        .then((dt) => {
          if (dt.data.status === "success" && dt.data.data.length > 0) {
            this.$store.commit("sbSuccess", "Ticket raised");
            this.helpdeskdialog = false;
            this.$nova.gotoLink({
              path:
                "/financialclose/functionalsupport/" +
                this.metadata._id +
                "/support/" +
                dt.data.data[0]._id,
            });
          } else throw Error(dt.data.message || "Unknown error");
        })
        .catch((err) => {
          this.$store.commit("sbError", err.message || err || "Unknown error!");
          console.log(err);
        })
        .finally(() => {});
    },
    openlinkBotDialog: function (d) {
      this.addeditdata = { ...d };
      this.selectedbot = this.addeditdata.botid;
      this.linkbotdialog = true;
      this.leaseScheduleValue = [];
      this.selectedTransactionMatching = "";
      // Fetch transaction matching list when dialog opens
      this.$store.dispatch('tasks/fetchTransactionMatchingAnalysis', { checklistId: this.id }).catch(() => {});
    },
    sendForReview() {
      // this.sendforreviewloading = true;
      let url =
        "/v2/financialclose/analysis/sendforreview/" +
        this.id +
        "/c/" +
        this.viewtaskdata._id;
      this.axios
        .post(url, { data: { remark: this.fileremark } })
        .then((dt) => {
          if (dt.data.status === "success") {
            this.$store.commit("sbSuccess", "Tasklist sent for review");
            // this.sendforreviewdialog = false;
            this.files = [];
            this.filesbulk = [];
            this.viewtaskdata.stage = 2;
            this.checklist[this.viewtaskdata.__key] = { ...this.viewtaskdata };
            this.calculateDetails();
            this.refreshData();
          } else throw Error(dt.data.message || "Unknown error");
        })
        .catch((err) => {
          this.$store.commit("sbError", err.message || err || "Unknown error!");
          console.log(err);
        })
        .finally(() => {
          this.sendforreviewdrawer = false;
        });
    },
    sendForReviewBulk() {
      const tasklistid = this.selectItem.map((item) => item._id);
      let url = "v2/financialclose/analysis/bulksendforreview";
      this.axios
        .post(url, {
          data: { remark: this.fileremark, pid: this.id, cidList: tasklistid },
        })
        .then((dt) => {
          if (dt.data.status === "success") {
            this.$store.commit("sbSuccess", "Tasklist sent for review");
            this.bulkworkpaperupload = false;
            // this.sendforreviewdialog = false;
            this.files = [];
            this.filesbulk = [];
            this.selectItem = [];
            this.viewtaskdata.stage = 2;
            this.checklist[this.viewtaskdata.__key] = { ...this.viewtaskdata };
            // this.calculateDetails();
            this.refreshData();
          } else throw Error(dt.data.message || "Unknown error");
        })
        .catch((err) => {
          this.$store.commit("sbError", err.message || err || "Unknown error!");
          console.log(err);
        })
        .finally(() => {
          this.sendforreviewdrawer = false;
        });
    },
    //     filterPart(item,header){
    //     this.tasklistData = this.$nova.filterByDynamicCriteria(this.tasklistDataCopy, item);
    //   },
    // clearPart(item){
    //     console.log(item,"item");
    //     this.tasklistData = this.tasklistDataCopy;
    //   }

    sortFun(array, key, order = "ascending") {
      return array.slice().sort((a, b) => {
        const valA = a[key];
        const valB = b[key];
        const normalizedA =
          typeof valA === "string" ? valA.toLowerCase() : valA;
        const normalizedB =
          typeof valB === "string" ? valB.toLowerCase() : valB;

        if (normalizedA < normalizedB) return order === "ascending" ? -1 : 1;
        if (normalizedA > normalizedB) return order === "ascending" ? 1 : -1;
        return 0;
      });
    },
    sortingOrder(key, order) {
      this.processedTaskList = this.sortFun(this.masterTaskList, key, order);
    },
    /**
     * Validates filter keys against current table headers to remove stale/invalid filter entries.
     * This prevents API errors when filter columns have been deleted from the system.
     * @param {Object} filter - The filter object to validate
     * @returns {Object} - Cleaned filter with only valid keys
     */
    _validateFilterKeys(filter) {
      if (!filter || typeof filter !== 'object') return {};
      
      // Get valid header values from tableHeadersfilter
      const validHeaderValues = new Set();
      const headersToCheck = this.tableHeadersfilter || this.defaultTableHeadersfilter || [];
      headersToCheck.forEach(h => {
        if (h && h.value) validHeaderValues.add(h.value);
        if (h && h.value_en) validHeaderValues.add(h.value_en);
      });
      
      // If no headers yet (component initializing), return filter as-is
      if (validHeaderValues.size === 0) return filter;
      
      // Clean filter by removing keys that don't match any header
      const cleanedFilter = {};
      
      Object.keys(filter).forEach(filterKey => {
        if (validHeaderValues.has(filterKey)) {
          cleanedFilter[filterKey] = filter[filterKey];
        } else {
          console.warn(`[Tasklist] Removed stale filter key: ${filterKey}`);
        }
      });
      
      return cleanedFilter;
    },
    filterPart(item) {
      this.tableFilterHeader = item;
      this.processedTaskList = this.$nova.filterByDynamicCriteria(
        this.masterTaskList,
        this.tableFilterHeader
      );
      this.page = 1;
    },
    getRefresh() {
      this.refreshData();
    },
    isValidEmail(email) {
      if (!email || typeof email !== "string") return false;
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      return emailRegex.test(email.trim());
    },

    /**
     * Get location names from location IDs, filtering out unknown locations
     * @param {Array|string} locationIds - Array of location IDs or single ID
     * @returns {Array} - Array of location names (unknown locations are skipped)
     */
    getLocationName(locationIds) {
      if (!locationIds || locationIds.length === 0) return [];
      // Make sure locationIds is an array
      const ids = Array.isArray(locationIds) ? locationIds : [locationIds];
      return ids
        .map(id => {
          const normalizedId = typeof id === 'object' ? (id?._id || id?.id || id?.value) : id;
          const location = this.locationList?.find(loc => {
            return String(loc?._id) === String(normalizedId) || String(loc?.id) === String(normalizedId);
          });
          return location?.name ?? null;
        })
        .filter(name => name !== null);
   },

    async emailpop() {
      this.emailpopdia = true;
      this.emailpopdialoading = true;
      try {
        // Use store action instead of direct API call
        await this.$store.dispatch('tasks/getAllTaskEmailNotifications', { 
          cycleId: this.id
        });
        // Store state is updated by the action, get data from there
        this.emaildata = (this.$store.getters['tasks/getTaskEmailNotifications'] || []).map((item) => ({
          ...item,
          startDate: item?.startDate || item?.meta?.startDate || item?.start || item?.meta?.start || '',
          endDate: item?.endDate || item?.meta?.endDate || item?.end || item?.meta?.end || '',
          sla: item?.sla ?? item?.meta?.sla ?? '',
          priority: item?.priority || item?.meta?.priority || 'High',
        }));
        this.isCycleInActive = this.$store.getters['tasks/isCycleInactive'];
      } catch (err) {
        console.error(err);
        this.$store.commit("sbError", err.message || "Unknown error!");
      } finally {
        this.emailpopdialoading = false;
      }
    },
  
    addeditemailFun() {
      const maxEmailInstance = 10;
      if (this.emaildata && this.emaildata.length >= maxEmailInstance) {
        this.$store.commit(
          "sbError",
          this.notificationMessages.MAX_NOTIFICATIONS_ERROR
        );
        return;
      }
      this.addeditemail = true;
      this.timeMultiples = [];
      this.emaildetils = {
        priority: "High",
        category: [],
        locations: [],
        emails: []
      };
      this.resetEmailErrors();
    },
    
    /**
     * Reset email form validation errors
     */
    resetEmailErrors() {
      this.emaildetilsErrors = {
        startDate: '',
        endDate: '',
        emails: '',
        subject: '',
        mailBody: '',
        locations: '',
        time: '',
        sla: '',
        category: ''
      };
    },
    
    /**
     * Validate email notification form fields
     * @returns {boolean} - True if all required fields are valid
     */
    validateEmailNotificationFields() {
      this.resetEmailErrors();
      let isValid = true;
      const details = this.emaildetils;
      const errors = this.emaildetilsErrors;
      
      // Start Date validation
      if (!details.startDate) {
        errors.startDate = 'Start Date is required';
        isValid = false;
      }
      
      // End Date validation
      if (!details.endDate) {
        errors.endDate = 'End Date is required';
        isValid = false;
      } else if (details.startDate && new Date(details.endDate) < new Date(details.startDate)) {
        errors.endDate = 'End Date must be after Start Date';
        isValid = false;
      }
      
      // Category validation
      if (!details.category || details.category.length === 0) {
        errors.category = 'At least one category is required';
        isValid = false;
      }
      
      // Email addresses validation
      if (!details.emails || details.emails.length === 0) {
        errors.emails = 'At least one email address is required';
        isValid = false;
      } else if (this.invalidEmails.length > 0) {
        errors.emails = 'Please enter valid email addresses';
        isValid = false;
      }
      
      // Subject validation
      if (!details.subject || details.subject.trim() === '') {
        errors.subject = 'Email Subject is required';
        isValid = false;
      }
      
      // Mail Body validation
      if (!details.mailBody || details.mailBody.trim() === '') {
        errors.mailBody = 'Email Body is required';
        isValid = false;
      }
      
      // Hour validation
      if (details.time === null || details.time === undefined || details.time === '' || (Array.isArray(details.time) && details.time.length === 0)) {
        errors.time = 'Hour is required';
        isValid = false;
      }
      
      // SLA validation
      if (details.sla === null || details.sla === undefined || details.sla === '' || (Array.isArray(details.sla) && details.sla.length === 0)) {
        errors.sla = 'SLA is required';
        isValid = false;
      }

      // Location validation
      if (!details.locations || details.locations.length === 0) {
          errors.locations = 'At least one location is required';
          isValid = false;
      }
      
      if (!isValid) {
        this.$store.commit('sbError', this.notificationMessages.REQUIRED_VALIDATION);
      }
      
      return isValid;
    },

    async addemails() {
      // Validate required fields before submission
      if (!this.validateEmailNotificationFields()) {
        return;
      }

      this.addeditemailloading = true;
      try {
        // Use store action instead of direct API call
        const result = await this.$store.dispatch('tasks/addTaskEmailNotification', {
          cycleId: this.id,
          notificationData: {
            subject: this.emaildetils.subject,
            mailBody: this.emaildetils.mailBody,
            time: this.emaildetils.time,
            locations: this.emaildetils.locations,
            emails: this.emaildetils.emails,
            startDate: this.emaildetils.startDate,
            endDate: this.emaildetils.endDate,
            sla: this.emaildetils.sla,
            category: this.emaildetils.category,
            priority: this.emaildetils.priority,
          }
        });

        if (result.success) {
          this.addeditemail = false;
          this.emailpop(); // Refresh email notifications list
        }
      } catch (err) {
        console.error(err);
      } finally {
        this.addeditemailloading = false;
      }
    },

    async updateemails() {
      // Validate required fields before submission
      if (!this.validateEmailNotificationFields()) {
        return;
      }

      this.addeditemailloading = true;
      try {
        // Use store action instead of direct API call
        const result = await this.$store.dispatch('tasks/updateTaskEmailNotification', {
          cycleId: this.id,
          notificationData: {
            _id: this.emaildetils._id,
            subject: this.emaildetils.subject,
            mailBody: this.emaildetils.mailBody,
            time: this.emaildetils.time,
            locations: this.emaildetils.locations,
            emails: this.emaildetils.emails,
            startDate: this.emaildetils.startDate,
            endDate: this.emaildetils.endDate,
            sla: this.emaildetils.sla,
            category: this.emaildetils.category,
            priority: this.emaildetils.priority,
          }
        });

        if (result.success) {
          this.addeditemail = false;
          this.emailpop(); // Refresh email notifications list
        }
      } catch (err) {
        console.error(err);
      } finally {
        this.addeditemailloading = false;
      }
    },

    async enableDisableemails(item, type) {
      if (!item?._id) return;
      
      this.emailpopdialoading = true;
      const isEnabled = type.trim() === "enabled";

      try {
        // Use store action instead of direct API call
        await this.$store.dispatch('tasks/toggleTaskEmailNotificationStatus', {
          cycleId: this.id,
          notification: item,
          enable: isEnabled
        });
        this.emailpop(); // Refresh email notifications list

      } catch (err) {
        console.error(err);
        this.$store.commit("sbError", err.message || "Unknown error!");
      } finally {
        this.emailpopdialoading = false;
      }
    },

    editemails(item) {
      if (!item) return;
      const ensureArray = (value) => {
        if (Array.isArray(value)) return [...value];
        if (value === undefined || value === null || value === '') return [];
        return [value];
      };
      const normalizeIdArray = (value) => {
        return ensureArray(value)
          .map(entry => {
            if (entry && typeof entry === 'object') {
              return entry._id || entry.id || entry.value || '';
            }
            return entry;
          })
          .filter(entry => entry !== undefined && entry !== null && entry !== '')
          .map(entry => String(entry));
      };
      const schedulerTiming = item.schedulerTiming ? String(item.schedulerTiming) : '';

      this.addeditemail = true;
      this.resetEmailErrors();
      this.emaildetils = {
        ...item,
        endDate: item.endDate || item.meta?.endDate || item.end || item.meta?.end || '',
        locations: normalizeIdArray(item.meta?.location_key),
        startDate: item.startDate || item.meta?.startDate || item.start || item.meta?.start || '',
        emails: ensureArray(item.meta?.toUsers),
        time: CRON.cronFormatToHour(schedulerTiming) || '',
        sla: item.sla ?? item.meta?.sla ?? '',
        category: ensureArray(item.meta?.category),
        priority: item.priority || item.meta?.priority || "High",
      };
      this.generateTimeMultiples(this.emaildetils.time);
    },
  // MARKER: TASK_TYPE
  readBulkEditFile(files) {
  const bulkeditFile = files[0];
  if (!bulkeditFile || !bulkeditFile.name) return;
  const headings = [
    "__taskId__",
    "Reference",
    "Task Description",
    "Due Date (dd/mm/yyyy)",
    "Category",
    "Sub Category",
    "Purpose",
    "Instruction",
    "Priority",
    "Preparer",
    "Approver",
    "Tags",
    "Linked Gls",
    "Location",
    "Skip Validation",
    "No. of Evidences"
  ];
   headings.push(...this.customColumns.map(column =>
      column.dataType === "date"
        ? `${column.displayText} (dd/mm/yyyy)`
        : column.displayText
    ));
  this.bulkEditTableHeaders = [...this.$constants.TASK_LIST_CONSTANTS.BULK_EDIT_HEADERS_CLOSE_CYCLE ];
  this.bulkEditTableHeaders.push({ text: "Skip Validation", value: "skipValidations" });
  this.bulkEditTableHeaders.push(...this.customColumns.map(column => ({
    text: column.dataType === "date" ? `${column.displayText} (dd/mm/yyyy)` : column.displayText,
    value: column.columnName,
  })));
  this.bulkEditDialogloading = true;
  const ext = bulkeditFile.name.split(".").pop();

  Promise.resolve()
    .then(() => {
      if (!["xlsx", "xls", "xlsm", "xlsb"].includes(ext)) {
        throw new Error("Only xlsx, xls, xlsm, xlsb file extensions supported");
      }
      return this.$nova.readExcelFile(bulkeditFile, "");
    })
    .then(async (dt) => {
      const cleanedDt = dt.map(row => {
        if (!Object.prototype.hasOwnProperty.call(row, 0) || row[0] === null || row[0] === "") {
          console.warn("Skipping row with empty first element:", row);
          return row.slice(1); // Remove the first element
        }
        return row;
      });
      this.bulkEditFileDataerror = false;
      const chartofaccountData = [];
      const coares = await this.axios.post("/v2/financialclose/masters/chartofaccount/get");
      if (coares.data.status === "success") {
        chartofaccountData.push(...coares.data.data);
      }
      // Pre-compute COA category/subcategory sets for AR task validation
      const coaCategorySet = new Set(chartofaccountData.map(acc => acc.category).filter(Boolean));
      const coaSubcategorySet = new Set(chartofaccountData.map(acc => acc.subcategory).filter(Boolean));
      // Fetch all TB records on-demand for GL code validation
      const projectId = this.id || this.$route.params.id;
      let tbRecords = [];
      if (projectId) {
        const tbResult = await this.$store.dispatch('tasks/fetchTbPage', {
          projectId,
          page: 1,
          limit: 0,
          search: null,
          location: null,
          append: false,
        });
        tbRecords = tbResult?.records || this.$store.getters['tasks/getTbRecords'] || [];
      }
      console.log(cleanedDt,"Cleaned Data from Excel");
      console.log(headings,"Expected Headings");
      if (JSON.stringify(cleanedDt[1] || []) !== JSON.stringify(headings)) {
        throw new Error(`Columns '${headings.join("','")}' are required in the same order`);
      }
      const filedata = [];
      const errordata = [];
      for (let i = 2; i < cleanedDt.length; i++) {
        if (cleanedDt[i].length === 0) continue;
        const [
           __taskId__, ref, description, duedate, category, subcategory,
          purpose, instruction, priority, preparerName, approverName, tagss, linkedgls, locationName, skipValidationValue, evidences
        ] = cleanedDt[i];
        const matchedTask = this.masterTaskList.find(
          x => {
            return x._id.toString() === __taskId__;
          }
        );
        if(!matchedTask) {
          continue;
        }
        
      const preparerNames = preparerName?.split(',').map(n => n.trim()).filter(Boolean) || [];
      const approverNames = approverName?.split(',').map(n => n.trim()).filter(Boolean) || [];
      const tags = tagss?.split(',').map(n => n.trim()).filter(Boolean) || [];
      const linkedgl = linkedgls?.toString().split(',').map(n => n.trim()).filter(Boolean) || [];
    
      const matchedPreparers = preparerNames.map(email => {
        return this.userEmailMap[email] || email;
      });
      const matchedApprovers = approverNames.map(email => {
        return this.userEmailMap[email] || email;
      });
      const matchedGls = linkedgl.map(glcode => {
        const user = tbRecords.find(u => String(u.glcode || '').trim() === String(glcode || '').trim());
        return user ? user.glcode : glcode;
      });
      const matchedGlsIds = linkedgl.map(glcode => {
        const gldetails = tbRecords.find(u => String(u.glcode || '').trim() === String(glcode || '').trim());
        return gldetails ? gldetails._id : glcode;
      });
      // Parse evidences explicitly. Preserve 0 and allow blank -> use existing value; invalid -> mark error later.
      let no_of_evidence;
      if (evidences === undefined || evidences === null || evidences === "") {
        // keep original or default 0
        no_of_evidence = (matchedTask.no_of_evidence === undefined || matchedTask.no_of_evidence === null) ? 0 : Number(matchedTask.no_of_evidence);
      } else if (!isNaN(Number(evidences)) && Number(evidences) >= 0) {
        no_of_evidence = Number(evidences);
      } else {
        no_of_evidence = NaN; // trigger validation error below
      }
      const activeUserEmails = (this.userDetails.activeUsers || []).map(user => user.email);
      const inactivePreparer = preparerNames.filter(email => !activeUserEmails.includes(email));
      const inactiveApprover = approverNames.filter(email => !activeUserEmails.includes(email));
      const duplicateUsers = preparerNames.filter(email => approverNames.includes(email));
      const matchedLocation = this.locationList.find(l => l.name?.trim() === locationName?.trim());
      let rowdata = {
        task_type: "",
        ref,
        description,
        duedate: duedate ? formatDateToDMY(duedate) : "",
        category,
        subcategory,
        purpose,
        instruction,
        priority,
        preparer: matchedPreparers,
        approver: matchedApprovers,
        tags,
        linkedgl:matchedGls,
        location: matchedLocation?._id || locationName,
        _id: __taskId__,
        glcode: matchedGlsIds,
        // Store actual evidences numeric value; also provide 'evidences' alias for table header mapping
        no_of_evidence,
        evidences: no_of_evidence,
        skipValidations: (skipValidationValue?.toString().toLowerCase() === 'yes'),
      };
      // TODO - Create BULK EDIt as separate component
      rowdata.task_type = rowdata.glcode.length ? this.$constants.TASK_LIST_CONSTANTS.TASK_TYPES.ACCOUNT_RECONCILIATION : this.$constants.TASK_LIST_CONSTANTS.TASK_TYPES.NORMAL;
      const errors = {
        preparer:'',
        approver:'',
        linkedgl:'',
        evidences:''
      };
      let customfields = [];
      if (this.customColumns.length > 0) {
          customfields = this.customColumns.map((column) => {
              // Find header index accounting for date suffix: "Column Name (dd/mm/yyyy)"
              let headerIndex = -1;
              let value;
              const headerWithDateSuffix = `${column.displayText} (dd/mm/yyyy)`;
              if (column.dataType === 'date') {
                  headerIndex = headings.indexOf(headerWithDateSuffix);
                  value = headerIndex >= 0 ? formatDateToDMY(cleanedDt[i][headerIndex]) : '';
                   // If date value exists, validate and reformat it
              } else {
                  headerIndex = headings.indexOf(column.displayText);
                  value = headerIndex >= 0 ? cleanedDt[i][headerIndex] : '';
              }
             
              let fieldValue = value || ''; // Default field value

              // // Validate custom fields and add errors for mismatched data types
              // if (column.dataType === 'number' && isNaN(Number(value))) {
              //     errors[column.columnName] = `'${value}' is not a valid number`;
              // } else if (column.dataType === 'date' && isNaN(new Date(value).getTime())) {
              //     errors[column.columnName] = `'${value}' is not a valid date`;
              // }

              return { [column.columnName]: fieldValue };
          });
          rowdata = { ...rowdata, ...customfields.reduce((acc, field) => ({ ...acc, ...field }), {}) };
      }
      rowdata.customfields = customfields;
      if (!description) errors["description"] = "Description is required";
      if (!duedate) {
        errors["duedate"] = "Duedate is required";
      } else {
        const dueDateValidation = validateDueDateRange(duedate, MAX_DUE_DATE_DAYS);
        if (!dueDateValidation.valid) {
          errors["duedate"] = dueDateValidation.error;
        }
      }
      if (!category) errors["category"] = "Category is required";
      if (!subcategory) errors["subcategory"] = "Subcategory is required";
      // Category & Sub Category COA validation for AR tasks
      if (rowdata.task_type === this.$constants.TASK_LIST_CONSTANTS.TASK_TYPES.ACCOUNT_RECONCILIATION && chartofaccountData.length > 0) {
        if (category && !coaCategorySet.has(category)) {
          errors["category"] = this.$constants.TASK_LIST_CONSTANTS.ERROR_MESSAGES.CATEGORY_NOT_FROM_COA;
        }
        if (subcategory && !coaSubcategorySet.has(subcategory)) {
          errors["subcategory"] = this.$constants.TASK_LIST_CONSTANTS.ERROR_MESSAGES.SUBCATEGORY_NOT_FROM_COA;
        }
      }
      if (!priority) errors["priority"] = "Priority is required";
      // Validate no_of_evidence: must be a number between 0 and 10
      if (no_of_evidence === null || no_of_evidence === undefined || isNaN(no_of_evidence)) {
        errors["evidences"] = "No. of Evidences must be a valid number";
      } else if (no_of_evidence < 0 || no_of_evidence > 10) {
        errors["evidences"] = "No. of Evidences must be between 0 and 10";
      }
      // if (!Array.isArray(matchedGls) || matchedGls.length === 0) errors["linkedgl"] = "Linked Gl is required";
      if (!preparerName) errors["preparer"] += " Preparer is required";
      if (!approverName) errors["approver"] += " Approver is required";
      if (inactivePreparer.length > 0) {
         errors["preparer"] += ` Inactive Preparer(s): ${inactivePreparer.join(", ")}`;  
        }
      if (inactiveApprover.length > 0) {
         errors["approver"] += ` Inactive Approver(s): ${inactiveApprover.join(", ")}`;
        }
      if (duplicateUsers.length > 0) {
        errors["preparer"] += ` Preparer and Approver cannot be the same: ${duplicateUsers.join(", ")}`;
      }
      
      for (const name of preparerNames) {
        if (!this.userEmailMap[name]) {
          errors["preparer"] += ` Invalid Preparer: '${name}' not found`;
        }
      }
      for (const name of approverNames) {
        if (!this.userEmailMap[name]) {
          errors["approver"] += ` Invalid Approver: '${name}' not found`;
        }
      }

      if (matchedTask) {
  const validGlcodes = (matchedTask.__tbtotals?.items || []).map(item => item.glcode);
  if (validGlcodes.length > 0 && linkedgl.length === 0) {
    rowdata.task_type = this.$constants.TASK_LIST_CONSTANTS.TASK_TYPES.ACCOUNT_RECONCILIATION;
    for (const code of validGlcodes) {
      errors["linkedgl"] = `Linked GL(s) are mandatory for Account Reconciliation task ${code}`;
    }
  }
}
      for (const code of linkedgl) {
        const matched = tbRecords.find(u => String(u.glcode || '').trim() === String(code || '').trim());
        if (!matched) {
          errors["linkedgl"] = `Invalid GL Code: '${code}' not found`;
        }
      }

      if (locationName && !matchedLocation) {
        errors["location"] = `Invalid Location: '${locationName}' not found`;
      }
     const errorKeys = ERROR_KEYS_CYCLE_TASKLIST;
      
    const hasError = errorKeys.some(key => errors[key]);
    if (hasError) {
        rowdata.error = Object.values(errors).filter(Boolean).join(" | ");
        this.bulkEditFileDataerror = true;
        this.flageditBulk = true;
      }

      filedata.push(rowdata);
      errordata.push(errors);
      }

      this.bulkEditFileDataList = filedata;
      this.dataerroreditBulk = errordata;
      this.errorsonlyEditBulk = this.dataerroreditBulk;
    })
    .catch((err) => {
      this.$store.commit("sbError", err.message || err || "Unknown error!");
    })
    .finally(() => {
      this.bulkEditFileDataFile = null;
      this.bulkEditDialogloading = false;
    });
  },

   clearBulkEditFile(){
    this.resetbulkEditFile = !this.resetbulkEditFile;
   },

    formatAmount(amount) {
      return this.$nova.formatNumber((Number(amount) || 0).toFixed(0));
    },
    calculateUnexplainedDifference(item) {
      return calculateUnexplainedDifference(item);
    },
    calculateExplainedDifference(item) {
      return calculateExplainedDifference(item);
    },
    calculateScheduleAmount(item) {
      return calculateScheduleAmount(item);
    },
    // Compute sticky offsets for the first N (default 3) visible columns
    updateStickyOffsets() {
      try {
        if (this.__headerDragging) return; // skip during drag
        
        // Wait for table to be ready
        const table = this.$el?.querySelector('.tasklist-table .v-data-table__wrapper > table') || this.$el?.querySelector('.v-data-table__wrapper > table');
        if (!table) {
          // Retry if table not found
          setTimeout(() => this.updateStickyOffsets(), 100);
          return;
        }
        
        const headerRow = table.querySelector('thead tr');
        if (!headerRow) {
          // Retry if header not found
          setTimeout(() => this.updateStickyOffsets(), 100);
          return;
        }

        const count = Number(this.stickyColumnCount || 3);

        // Reset previous sticky state
        table.querySelectorAll('th.dyn-sticky-col, td.dyn-sticky-col').forEach(el => {
          el.classList.remove('dyn-sticky-col');
          el.style.left = '';
          el.removeAttribute('data-sticky-seq');
        });

        const visible = Array.from(headerRow.children).filter(th => {
          const rect = th.getBoundingClientRect();
          return th.offsetParent !== null && rect.width > 0.5;
        });
        
        if (!visible.length) {
          // Retry if no visible columns detected
          setTimeout(() => this.updateStickyOffsets(), 100);
          return;
        }
        
        const targets = visible.slice(0, count);

        const headerIndexes = [];
        let left = 0;
        const widths = [];
        targets.forEach((th, seq) => {
          let w = th.getBoundingClientRect().width;
          if (!w || w < 1) {
            // fallback to offsetWidth or a min width to avoid zero width issues
            w = th.offsetWidth || 80;
          }
          headerIndexes.push(Array.from(headerRow.children).indexOf(th));
          widths.push(w);
          th.classList.add('dyn-sticky-col');
          th.dataset.stickySeq = seq;
          th.style.left = left + 'px';
          th.style.width = w + 'px';
          th.style.minWidth = w + 'px';
          left += w;
        });

        const bodyRows = table.querySelectorAll('tbody tr');
        bodyRows.forEach(tr => {
          let running = 0;
          headerIndexes.forEach((idx, seq) => {
            const cell = tr.children[idx];
            if (!cell) return;
            cell.classList.add('dyn-sticky-col');
            cell.dataset.stickySeq = seq;
            cell.style.left = running + 'px';
            const w = widths[seq];
            if (w) {
              cell.style.width = w + 'px';
              cell.style.minWidth = w + 'px';
            }
            running += widths[seq];
          });
        });

        // Success check - if left is still 0, retry once more
        if (left === 0 && !this.__stickyRetry) {
          this.__stickyRetry = true;
          setTimeout(() => { this.__stickyRetry = false; this.updateStickyOffsets(); }, 150);
        }
      } catch (_) { /* silent */ }
    },
    scheduleStickyUpdate() {
      if (this.__stickyScheduled) return;
      this.__stickyScheduled = true;
      requestAnimationFrame(() => {
        this.__stickyScheduled = false;
        this.updateStickyOffsets();
      });
    },
    applyUrlQueryFilters() {
      try {
        const urlFilters = parseUrlQueryFilters({
          query: this.$route.query,
          standardParams: ['cid', 'view', 'userType'],
          keyMap: {
            location: 'locationName',
            status: 'stage1',
            sub_category: 'subcategory',
            due_in_days: 'duedays',
            preparer: 'preparerids',
            approver: 'approverids',
          },
          locationList: this.locationList,
          usersList: this.usersList,
          tableHeadersfilter: this.tableHeadersfilter,
          masterTaskList: this.masterTaskList,
        });

        if (!urlFilters) {
          return;
        }

        this.tableFilterHeader = { ...this.tableFilterHeader, ...urlFilters };

        if (this.masterTaskList?.length) {
          this.filterPart(this.tableFilterHeader);
          
        } else {
          console.warn('masterTaskList is empty, filters not applied');
        }

      } catch (err) {
        console.error('Error applying URL filters:', err);
      }
    },

  },
  mounted() {
    // Track window height for responsive table sizing
    // Store as instance property (_handleResize) to maintain the same function reference
    // This allows proper cleanup in beforeUnmount when removing the event listener
    this._handleResize = () => {
      this.windowHeight = window.innerHeight;
      this.scheduleStickyUpdate();
    };
    window.addEventListener('resize', this._handleResize, { passive: true });
    
    // Multiple attempts to ensure sticky columns work on initial load
    this.$nextTick(() => {
      this.updateStickyOffsets();
      // Additional attempts with increasing delays for better reliability
      setTimeout(() => this.updateStickyOffsets(), 50);
      setTimeout(() => this.updateStickyOffsets(), 120);
      setTimeout(() => this.updateStickyOffsets(), 300); // After data loads
      setTimeout(() => this.updateStickyOffsets(), 500); // Final attempt
      const headerRow = this.$el.querySelector('.tasklist-table .v-data-table__wrapper > table > thead > tr');
      if (headerRow) {
        this.__headerMutationObserver = new MutationObserver(() => {
          this.__attachHeaderDragListeners();
          this.scheduleStickyUpdate();
        });
        this.__headerMutationObserver.observe(headerRow, { childList: true });
        const ResizeObs = window.ResizeObserver;
        if (ResizeObs) {
          this.__headerResizeObserver = new ResizeObs(() => this.scheduleStickyUpdate());
          this.__headerResizeObserver.observe(headerRow);
        }
        this.__attachHeaderDragListeners();
      }
      this.viewModeToggleReady = true;
    });
  },
  beforeUnmount() {
    if (this._handleResize) {
      window.removeEventListener('resize', this._handleResize);
    }
    if (this.__headerMutationObserver) this.__headerMutationObserver.disconnect();
    if (this.__headerResizeObserver) this.__headerResizeObserver.disconnect();
  },
  // Vue 2 compatibility - beforeDestroy is equivalent to beforeUnmount
  beforeDestroy() {
    this.isComponentActive = false;
  },
  computed: {
    breadcrumbs() {
      return [
        {
          text: 'Home',
          testId: 'tasklist__breadcrumbs-home',
        },
        {
          text: 'Tasks',
          testId: 'tasklist__breadcrumbs-tasks',
        },
        {
          text: this.metadata?.description || '',
          noTransform: true,
          testId: 'tasklist__breadcrumbs-desc',
        },
      ];
    },
    /**
     * Computed min date for due date picker: today
     */
    dueDateMinDate() {
      return this.$nova.formatDateISO(new Date());
    },
    /**
     * Computed max date for due date picker: today + MAX_DUE_DATE_DAYS
     */
    dueDateMaxDate() {
      const today = new Date();
      const maxDate = new Date(today);
      maxDate.setDate(maxDate.getDate() + MAX_DUE_DATE_DAYS);
      return this.$nova.formatDateISO(maxDate);
    },
    /**
     * Calculates responsive table height based on viewport.
     * Uses different offsets for small vs large screens to maximize table visibility.
     */
    responsiveTableHeight() {
      // Dynamic offset based on screen height:
      let offset = TABLE_OFFSET_SMALL_SCREEN;
      if (this.windowHeight >= LARGE_SCREEN_HEIGHT_THRESHOLD) {
        offset = TABLE_OFFSET_LARGE_SCREEN;
      }
      return `calc(100vh - ${offset}px)`;
    },
    chatbotEnabled() {
      return this.$store.state.chatbotEnabled;
    },
    horizonViewEnabled() {
      return !!this.$store.getters['tasks/getFormDataV3']?.horizonViewEnabled;
    },
    isHorizonView() {
      return this.viewMode === true && this.horizonViewEnabled;
    },
    hasTasklistMetadata() {
      if (this.metadata?._id) {
        return true;
      }
      const checklistId = this.id || this.$route.params.id;
      const storeMeta = this.$store.getters['tasks/getTaskListData']?.metadata;
      return !!(checklistId && storeMeta?._id && storeMeta._id === checklistId);
    },
    ...mapState(['tasklistUserType']),
    customColumns() {
      return Array.isArray(this.localCustomColumns) ? this.localCustomColumns : [];
    },
    taskListData() {
      return this.$store.getters['tasks/getTaskListData']?.checklist || [];
    },
    statusDetails() {
      return this.$store.getters['tasks/getStatusDetails'];
    },
    transactionMatchingList() {
      return this.$store.getters['tasks/getTransactionMatchingList'];
    },
    isNotificationEnabled() {
        // Get notification enabled state from Vuex
        return this.$store.getters['tasks/isNotificationEnabled'];
      },
    usersList() {
      return this.$store.getters['tasks/getTaskListData']?.usersList || [];
    },
    // O(1) lookup map: userId → { _id, name, email, isActive } (from store getter)
    userMap() {
      return this.$store.getters['tasks/getUserMap'];
    },
    // O(1) lookup map: email → userId (from store getter)
    userEmailMap() {
      return this.$store.getters['tasks/getUserEmailMap'];
    },
    locationList() {
      return this.$store.getters['tasks/getTaskListData']?.locationList || [];
    },
     filteredLocationsFromStore() {
        const filtered = this.$store.getters['tasks/getFilteredLocations'];
        if (filtered && filtered.length > 0) return filtered;
        // Fallback: use the enabled locations fetched separately on mount.
        
        // ------------------------------------ NXTGEN-904 - retest and remove
        // // If the cycle metadata has a location list, filter locationList by it
        // const cycleLocations = this.metadata?.location;
        // if (Array.isArray(cycleLocations) && cycleLocations.length > 0) {
        //   return this.locationList.filter(loc => cycleLocations.includes(loc._id));
        // }
        // // Fallback to root store filteredLocations (set by getCycleInfo in base.vue)
        // const filtered = this.$store.getters.filteredLocations;
        // if (filtered && filtered.length > 0) return filtered;
        // // If still loading, don't fall back to all enabled locations — wait for
        // // getAllTasks to provide the correct metadata.location for the cycle.
        // // This prevents showing all locations for newly created cycles.
        // if (this.loading) return [];
        // // Fallback: for cycles where metadata.location is genuinely empty
        // // (no location restriction), use the enabled locations.
        // ------------------------------------
        
        return this.$store.getters['tasks/getEnabledLocations'] || [];
      },
    locationThresholds() {
      return this.$store.getters['tasks/getTaskListData']?.locationThresholds || [];
    },
    chartAcc() {
      return this.$store.getters['tasks/getTaskListData']?.chartAcc || [];
    },
    
    summary() {
      // Calculate dynamic summary based on processedTaskList (filtered by task type)
      const filteredTasks = this.processedTaskList || [];
      
      return {
        count: filteredTasks.length,
        pending: filteredTasks.filter(task => task.stage === 0).length,
        pendingapproval: filteredTasks.filter(task => task.stage === 2).length,
        approved: filteredTasks.filter(task => task.stage === 3).length
      };
    },
    // Get role-specific summary based on active userType
    activeSummary() {
      if (this.userType === 'manager') {
        return this.$store.getters['tasks/getManagerSummary'] || {};
      } else if (this.userType === 'preparer') {
        return this.$store.getters['tasks/getPreparerSummary'] || {};
      } else if (this.userType === 'approver') {
        return this.$store.getters['tasks/getApproverSummary'] || {};
      }
      return {};
    },
    hasManagerRole() {
      return this.metadata?.managerlist?.indexOf(this.userid) > -1;
    },
    availableUserTypeOptions() {
      const { ROLE_OPTIONS, NON_MANAGER_ROLE_VALUES } = this.$constants.TASK_LIST_CONSTANTS;
      return this.hasManagerRole
        ? ROLE_OPTIONS
        : ROLE_OPTIONS.filter((role) => NON_MANAGER_ROLE_VALUES.includes(role.value));
    },
    uniqueCategoryIds() {
      const cleanedArray = this.categoryAcc.filter(item => typeof item === 'string');
      return [...new Set(cleanedArray)];
    },
    selectAllCategories() {
      return [{ id: '__select_all__', name: 'Select All' }, ...this.uniqueCategoryIds.map(item => ({
        id: item,
        name: item
      }))];
    },
    dropdownLocations() {
      const enabledLocations = this.$store.getters['tasks/getEnabledLocations'] || [];
      const sourceLocations = enabledLocations.length > 0 ? enabledLocations : this.locationList;
      const seenIds = new Set();
      return [
        { _id: 'all', name: 'Select All' },
        ...sourceLocations.map((location) => {
          const normalizedId = location?._id || location?.id || location?.value || '';
          const normalizedIdString = String(normalizedId);
          if (!normalizedIdString || seenIds.has(normalizedIdString)) return null;
          seenIds.add(normalizedIdString);
          return {
            ...location,
            _id: normalizedIdString,
            name: location?.name || location?.label || location?.location || '',
          };
        }).filter(location => location && location._id)
      ];
    },
    isTaskTypeDisabled() {
    // Disable only if original task type was "Account Reconciliation"
    return this.isEditMode && this.originalTaskType === this.$constants.TASK_LIST_CONSTANTS.TASK_TYPES.ACCOUNT_RECONCILIATION;
  },
    invalidEmails() {
      if (this.emaildetils.emails) {
        return this.emaildetils.emails
          .filter((email) => !this.isValidEmail(email))
          .map((email) => `${email} is not a valid email.`);
      } else {
        return [];
      }
    },
    filteredData() {
      if (this.showdatawitherror) {
        return this.uploaddata.filter((_, rowIndex) =>
          Object.values(this.dataerror[rowIndex]).some((error) => error)
        );
      }
      return this.uploaddata; // Return all rows if not filtering errors
    },
    filteredDataEditBluk() {
      if (this.showdatawitherrorEditBulk) {
        return this.bulkEditFileDataList.filter((_, rowIndex) =>
          Object.values(this.dataerroreditBulk[rowIndex]).some((error) => error)
        );
      }
      return this.bulkEditFileDataList; // Return all rows if not filtering errors
    },
    filteredColumns() {
      if (!this.search?.trim()) {
        return this.configureColumns;
      }
      const searchTerm = this.search.trim().toLowerCase();
      return this.configureColumns.filter((item) =>
        item.toLowerCase().includes(searchTerm)
      );
    },

    filteredHeaders() {
      const searchTerm = this.searchcolumn.toLowerCase();
      return this.tableHeadersfilter.filter((header) =>
        header.text.toLowerCase()?.includes(searchTerm)
      );
    },

    filteredTasklist() {
      let array = [];
      if (this.userType === "preparer") {
        array = this.processedTaskList.filter((item) =>
          item.preparer.includes(this.userid)
        );
        if (this.overDueDate) {

          return array.filter((item) => item?.duedays < 0);
        }
        return [...array];
      } else if (this.userType === "approver") {
        array = this.processedTaskList.filter((item) =>
          item.approver.includes(this.userid)
        );
        if (this.overDueDate) {
          return array.filter((item) => item?.duedays < 0);
        }
        return [...array];
      } else if (this.userType === "manager") {
        array = this.processedTaskList;
        if (this.overDueDate) {
          return array.filter((item) => item?.duedays < 0);
        }
        return [...array];
      } else {
        return [...this.processedTaskList];
      }
    },

    filterByTab() {
      if (this.selectedTabStage !== null) {
        return this.filteredTasklist.filter(
          (item) => item.stage === this.selectedTabStage
        );
      } else return this.filteredTasklist;
    },

    filterbysearch() {
      const searchTerm = this.searchQuery?.trim().toLowerCase() || "";
      if (!Array.isArray(this.filterByTab)) return [];
      return this.filterByTab.filter((item) =>
        (item.description || "").toLowerCase().includes(searchTerm)
      );
    },

   validActiveUsers(){
    if(this.selectaction === ACTION_STAGE.REMOVE_USER || this.selectaction === ACTION_STAGE.REPLACE_USER){
      const val = attachInactiveLabel(this.possibleUsers, this.userDetails.activeUserIds);
      return val;
    }
    if(this.selectaction === ACTION_STAGE.MOVE_USER){
      return this.possibleUsers?.filter(user => this.userDetails.activeUserIds.includes(user._id));
    }
    return []
  },
    filterActiveUsersBySearchName(){
      const searchTerm = this.searchUserName?.trim().toLowerCase() ?? "";
      const activeUsers = Object.values(this.userMap).filter(user => this.userDetails?.activeUserIds.includes(user._id));
      if (!searchTerm) return activeUsers;
      return activeUsers.filter(user => 
        (user.name || '').toLowerCase().includes(searchTerm) || 
        (user.email || '').toLowerCase().includes(searchTerm)
      );
    },
    allowedTaskTypes() {
      return identifyPossibleTaskTypes(this.addeditdata?._id, this.addeditdata?.task_type);
    },
  //   allowedTaskTypes() {
  //   const current = this.addeditdata?.task_type;
  //   const list = [...this.taskTypes];

  //   // Ensure current value is always in the list
  //   if (current && !list.includes(current)) {
  //     list.push(current);
  //   }

  //   return list;
  // },
  },
  watch: {
    viewMode(mode) {
      if (!this.viewModeToggleReady) return;
      this.onViewModeChange(mode);
    },
    '$route.query.view'(view) {
      const wantsHorizon = view === HORIZON_VIEWS.HORIZON;
      if (!wantsHorizon) {
        if (this.viewMode) this.viewMode = false;
        return;
      }
      const formDataLoaded = !!this.$store.getters['tasks/getFormDataV3'];
      if (!formDataLoaded) {
        this.viewMode = true;
        return;
      }
      const nextMode = this.horizonViewEnabled;
      if (this.viewMode !== nextMode) {
        this.viewMode = nextMode;
      }
    },
    horizonViewEnabled(enabled) {
      if (!enabled) {
        this.enforceHorizonViewAccess();
      } else if (this.$route.query.view === HORIZON_VIEWS.HORIZON && !this.viewMode) {
        this.viewMode = true;
      }
    },
    isHorizonView(isHorizon) {
      if (isHorizon && this.hasTasklistMetadata) {
        this.syncHorizonAfterDataLoad();
      }
    },
    tableHeadersfilter: {
      handler() {
        // Delay to allow DOM re-render after reactive header list changes
        this.$nextTick(() => setTimeout(() => this.updateStickyOffsets(), 10));
      },
      deep: true
    },
    // Watch for task data changes and reapply sticky columns
    taskListData: {
      handler() {
        // Apply sticky columns when data loads
        this.$nextTick(() => {
          setTimeout(() => this.updateStickyOffsets(), 50);
          setTimeout(() => this.updateStickyOffsets(), 150);
        });
      },
      immediate: false
    },
    // Watch filtered task list changes
    paginatedFilteredItems: {
      handler() {
        // Apply sticky columns when pagination changes
        this.$nextTick(() => setTimeout(() => this.updateStickyOffsets(), 20));
      }
    },
    viewtaskdailog(newVal) {
      if (newVal === true) {
        // Reset to the first tab when the drawer opens
        this.tabify = 0;
      }
    },
    tabify(newVal) {
      // If the Comments tab (index 0) call getConversation
      if ( newVal === 0 && this.viewtaskdata) {
        this.getConversation(this.viewtaskdata);
      }
    },
    'addeditdata.task_type'(newVal) {
        if (newVal === this.$constants.TASK_LIST_CONSTANTS.TASK_TYPES.NORMAL) {
          this.selectgls = [];
          this.addeditdata.__tbtotals = {
            total: 0,
            items: [],
          };
        }
        if (newVal === this.$constants.TASK_LIST_CONSTANTS.TASK_TYPES.ACCOUNT_RECONCILIATION) {
          // Clear free-text category/subcategory values that may not exist in COA
          if (this.addeditdata.category && !this.coaCategoryAcc.includes(this.addeditdata.category)) {
            this.addeditdata.category = '';
          }
          if (this.addeditdata.subcategory && !this.coaSubcategoryAcc.includes(this.addeditdata.subcategory)) {
            this.addeditdata.subcategory = '';
          }
        }
    },
    'addeditdata.location'(newLocation, oldLocation) {
        // Only clear GL accounts if location actually changed from one value to another
        // Don't clear during task initialization (oldLocation undefined) or when no real change occurred
        if (newLocation && oldLocation && newLocation !== oldLocation) {
            this.selectgls = [];
            this.searchcustomfilter = "";
            this.addeditdata.__tbtotals = {
              total: 0,
              items: [],
            };
        }
    },
    showdatawitherror(newVal) {
      if (newVal) {
        this.errorsonly = this.dataerror.filter(
          (item) => Object.keys(item).length > 0
        );
      } else {
        this.errorsonly = this.dataerror;
      }
    },
    showdatawitherrorEditBulk(newVal) {
      if (newVal) {
        this.errorsonlyEditBulk = this.dataerroreditBulk.filter(
          (item) => Object.keys(item).length > 0
        );
      } else {
        this.errorsonlyEditBulk = this.dataerroreditBulk;
      }
    },
    selectedbot() {
      this.botSelecetedId = "";
      if (this.selectedbot && this.selectedbot.length > 0) {
        this.loading = true;
        const data = [{ name: this.selectedbot }];
        this.axios
          .post("/v2/bot/analysis/getbotidbyname", { data })
          .then((dt) => {
            if (dt.data.status === "success") {
              this.botSelecetedId = dt.data.data[0]._id;
            }
          })
          .catch((err) => {
            console.log(err);
          })
          .finally(() => {
            this.loading = false;
          });
      }
    },
    showUploadDrawer(val) {
      if (val === false) {
        // Increment session key so TaskUploadModal re-mounts next open
        this.singleUploadSession++;
      }
    },
    sendforreviewdrawer(val) {
      if (val === false) {
        this.bulkUploadSession++;
      }
    },
  },
};
</script>

<style >
/* Tasklist layout - ensure card fills available space */
[data-testid="tasklist"] {
  height: 100%;
}

[data-testid="tasklist__main-content"] {
  height: 100%;
  min-height: 0; /* Allows flex children to shrink below content size */
}

[data-testid="tasklist__main-card"] {
  display: flex;
  flex-direction: column;
  min-height: 0; /* Allows flex shrinking */
}

[data-testid="tasklist__main-card"] > .v-card__text {
  flex: 1 1 auto;
  overflow: hidden;
  display: flex;
  flex-direction: column;
}

.overflow-scroll {
  overflow: auto;
  height: 100%;
}

.tasklist__table-panel {
  flex: 1 1 0;
  min-height: 0;
  overflow: hidden;
  display: flex;
  flex-direction: column;
}

.lb-datatableaction-wrapper {
  position: relative;
  display: flex;
  flex-direction: column;
  flex: 1 1 0;
  min-height: 0;
  overflow: hidden;
}

.lb-datatableaction-wrapper .v-data-table {
  display: flex;
  flex-direction: column;
  flex: 1;
  overflow: hidden;
}



/* Removed: lb-datatableaction-wrapper::after pseudo-element that created an unwanted horizontal line */

/* Make horizontal scrollbar always visible at the bottom. */
.lb-datatableaction-wrapper .v-data-table > .v-data-table__wrapper {
  margin-bottom: 0px; /* Space for the scrollbar */
  overflow-x: auto !important;
  scrollbar-width: thin;
}

/* Make the table header sticky */
.lb-datatableaction-wrapper .v-data-table > .v-data-table__wrapper > table > thead > tr > th {
  position: sticky;
  top: 0;
  z-index: 2;
  /* Let the <thead> / row class supply background */
  background: inherit !important;
}

/* Amount cell styling */
.amount-cell {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  width: 100%;
}

.amount-value {
  text-align: right;
  /* font-variant-numeric: tabular-nums; */
}

/* Amount cell styling */
.amount-cell {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  width: 100%;
}

.amount-value {
  text-align: right;
  /* font-variant-numeric: tabular-nums; */
}

/* Ensure the horizontal scrollbar is visible */
.lb-datatableaction-wrapper .v-data-table > .v-data-table__wrapper::-webkit-scrollbar {
  height: 10px;
  background-color: #f5f5f5;
}

.lb-datatableaction-wrapper .v-data-table > .v-data-table__wrapper::-webkit-scrollbar-thumb {
  background-color: #c1c1c1;
  border-radius: 10px;
}

/* Rest of your styles */
/* .tab-header-height {
  height: 5rem;
} */

.width-tab {
  width: 25%;
  align-items: center;
  box-shadow: 0px 1px 2px 0px rgba(16, 24, 40, 0.06);
  box-shadow: 0px 1px 3px 0px rgba(16, 24, 40, 0.1);
}

.padding-tab {
  padding: 16px;
  border-radius: 8px;
}

.gap-tab {
  gap: 20px;
}


/* .task-tab:hover {
  transform: translateY(-1px);
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.15);
} */

/* .task-tab--selected {
  transform: translateY(-2px);
  box-shadow: 0 6px 12px rgba(0, 0, 0, 0.2);
  z-index: 2;
} */

/* Red border highlight for missing mandatory grouped location/users */
.mandatory-error-border {
  border: 1.5px solid #b22222 !important;
  border-radius: 6px;
  position: relative;
}
.userChip .userBg{
  background: #f4e7d1;
}
.locationChip .locationBg{
  background: rgb(182 209 255); 
  margin-right: 4px;
}

.width-20 {
  flex: 0 0 20%;
  max-width: 20%;
}

  .tasklist-location-list {
    max-height: 40vh;
    overflow-y: auto;
    min-height: 56px;
  }
  .tasklist-location-span {
    min-height: 34px;
    font-size: 1.1rem;
    display: flex;
    align-items: center;
  }
  .d-cont{
    display: contents !important;
  }

  /* Exclude first three header cells from resize / grab behavior (but keep dropdown clickable) */
/* .tasklist-table .tasklist-thead th.resizable-header:nth-child(-n+3) { position: static; } */
.tasklist-table .tasklist-thead th.resizable-header:nth-child(-n+3) .draggable-header {
  cursor: default;            /* normal cursor */
  /* pointer-events enabled so buttons / menus work */
}
/* Hide resize handle for first three headers */
.tasklist-table .tasklist-thead th.resizable-header:nth-child(-n+3) .resizer-handle { display: none !important; }
/* Optional: prevent drag reordering via attribute override */
.tasklist-table .tasklist-thead th.resizable-header:nth-child(-n+3) .draggable-header[draggable="true"] { 
  -webkit-user-drag: none; 
}
.tasklist-table .tasklist-thead th.resizable-header:nth-child(-n+3) .draggable-header .cursor-grab{
  cursor: default;
}

/* --- Sticky first three columns (checkbox + first two data columns) --- */
/* Container needs relative so sticky works correctly */
.tasklist-table .v-data-table__wrapper { position: relative; }

/* Generic dynamic sticky columns */
.tasklist-table .v-data-table__wrapper > table th.dyn-sticky-col{
  position: sticky !important;
  background: var(--color-bg-white, #fff) !important;
  z-index: 6 !important;
  /* left is set inline dynamically */
}
.tasklist-table .v-data-table__wrapper > table td.dyn-sticky-col { position: sticky; z-index: 1; background: #fff; }

/* Divider shadow for the last applied sticky column: apply to any dyn-sticky-col that immediately precedes a non-sticky cell */
.tasklist-table .v-data-table__wrapper > table th.dyn-sticky-col:last-of-type,
.tasklist-table .v-data-table__wrapper > table td.dyn-sticky-col:last-of-type {
  box-shadow: 2px 0 0 0 var(--color-border-light);
}

.tasklist-table .v-data-table__wrapper table tbody tr td .v-btn .v-icon.v-icon,
.tasklist-table .v-data-table__wrapper table tbody tr td .v-btn,
.tasklist-table .v-data-table__wrapper table tbody tr td .v-chip {
  position: relative;
}
.v-tabs-bar { height: auto;}
.user-search-checkbox-list{
  width:100%;
}

/* Rounded corner styling for Manager, Preparer, Approver tabs */
.toolbar-tab-rounded {
  border-radius: var(--radius-4) !important;
  margin-right: var(--space-8);
  padding: var(--space-4) var(--space-8);
}

.tasklist-dropdown-btn {
  min-width: 12rem;
  justify-content: space-between;
  text-transform: none;
}

/* Bulk actions menu improvements */
.bulk-actions-menu {
  box-shadow: 0 5px 15px rgba(0, 0, 0, 0.15) !important;
  border-radius: 8px;
}

.bulkactionscroll { 
  overflow-y: auto !important;
  overflow-x: hidden;
  max-height: 280px;
  width: 100%;
  position: relative;
  /* Show scrollbar always for better visibility */
  scrollbar-width: thin;
  scrollbar-color: var(--v-primary-base) #f0f0f0;
}

/* Webkit browsers (Chrome, Safari, Edge) */
.bulkactionscroll::-webkit-scrollbar {
  width: 8px;
  display: block;
}

.bulkactionscroll::-webkit-scrollbar-track {
  background: #f0f0f0;
  border-radius: 4px;
  margin: 4px 0;
}

.bulkactionscroll::-webkit-scrollbar-thumb {
  background-color: var(--v-primary-base);
  border-radius: 4px;
  border: 2px solid #f0f0f0;
  transition: background-color 0.2s ease;
}

.bulkactionscroll::-webkit-scrollbar-thumb:hover {
  background-color: var(--v-primary-darken1);
}

/* Add visual indicator for scrollable content */
.bulkactionscroll::after {
  content: '';
  position: sticky;
  bottom: 0;
  left: 0;
  right: 0;
  height: 20px;
  background: linear-gradient(to bottom, transparent, rgba(255, 255, 255, 0.95));
  pointer-events: none;
  display: block;
  z-index: 1;
}

/* Add padding to list items in bulk actions */
.bulkactionscroll .v-list-item {
  min-height: 40px !important;
  padding: 8px 12px !important;
}
.chat-agent-img{
  filter: saturate(0) brightness(100%);
}

.threshold-count-badge {
  width: fit-content;
  border-radius: 8px;
  border: 1px solid var(--grey-900);
  background: var(--grey-50);
  padding: var(--space-3) var(--space-5);
}

.threshold-count-label {
  color: var(--grey-900);
}

.enable-disable-radio {
  border-radius: 8px;
  border: 1px solid var(--color-border-default);
  padding: var(--space-3) var(--space-5);
}

.enable-disable-radio-card {
  border-radius: 8px !important;
  border: 1px solid var(--color-border-default) !important;
  cursor: pointer;
  transition: border-color 0.2s;
}

.enable-disable-radio-card--selected {
  border-color: var(--color-primary) !important;
  background: var(--color-surface-alt);
}

.ru-info-banner {
  background: var(--color-info-banner-bg);
  border: 1px solid var(--color-primary);
  line-height: 1.5;
}
.tasklist__toolbar{
  border-top: 1px solid var(--grey-100);
  border-bottom: 1px solid var(--grey-100);
  padding: 8px 0;
}

/* List / Horizon view toggle — active shows icon + label, inactive icon only */
.view-mode-toggle {
  border-radius: 8px;
  border: 1px solid var(--grey-100);
  background: var(--horizon-view-toggle-bg) !important;
  padding: 2px !important;
  box-shadow: none !important;
}

.view-mode-toggle .view-mode-toggle__btn {
  border: none !important;
  border-radius: 6px !important;
  min-width: 32px !important;
  height: 32px !important;
  padding: 5px 12px !important;
  background: transparent !important;
  box-shadow: none !important;
  color: var(--grey-800) !important;
  text-transform: none !important;
  letter-spacing: normal !important;
}

.view-mode-toggle .view-mode-toggle__btn::before {
  opacity: 0 !important;
}

.view-mode-toggle .view-mode-toggle__btn--active,
.view-mode-toggle .view-mode-toggle__btn.v-btn--active {
  background: var(--color-surface-default) !important;
  color: var(--horizon-view-toggle-active-text) !important;
  box-shadow: var(--shadow-sm) !important;
  padding: 5px 12px !important;
}

.view-mode-toggle .view-mode-toggle__btn.v-btn--active .v-icon {
  color: var(--grey-800) !important;
}

.view-mode-toggle__label {
  font-size: 0.875rem;
  font-weight: 500;
  line-height: 1;
}
</style>